<template>
    <div class="parameter">
        <div class="wid100 parameter_dh">
            <el-button>
                 <router-link :to="'/project?dio='+$route.query.dio"><i class="el-icon-back"></i></router-link></el-button>
                                    <span v-if="$route.query.dio==0">
                                        <span class="title" style="color:#ccc">全部项目 > </span><span style="margin-left:0px" class="title">{{currentProject.itemName}}</span>
                                    </span>
                                   <!-- <span v-else-if="$route.query.dio==1">
                                        <span class="title" style="color:#ccc" >归档项目 > </span><span style="margin-left:0px" class="title">{{currentProject.itemName}}</span>
                                    </span>-->
                                    <span v-else-if="$route.query.dio==2">
                                        <span class="title" style="color:#ccc" >负责项目 > </span><span style="margin-left:0px" class="title">{{currentProject.itemName}}</span>
                                    </span>
                                    <span v-else-if="$route.query.dio==3">
                                        <span class="title" style="color:#ccc" >待审项目 > </span><span style="margin-left:0px" class="title">{{currentProject.itemName}}</span>
                                    </span>
                
            <div class="right" v-show="isgdorPending==0">

                <button  class="dabiao" v-show="fuheshuju" @click="fuhepinpai()"><i class="el-icon-copy-document"></i>符合品牌</button>
                <button class="dabiao"><router-link target="_blank" :to="{ path: '/scaling?id='+$route.query.id}"><img src="@/assets/images/dingbiao1.png">定标定样</router-link></button>  

                <button class="dabiao" @click="exportBigTable()"><img src="@/assets/images/EXCEL.png" alt=""> 灯参大表</button>
                <button class="dabiao" @click="exportNumTable()"><img src="@/assets/images/EXCEL.png" alt=""> 数量表</button>
                
                <button v-if="printneedZong"  class="dabiao" @click="exportFullPdf()"><img src="@/assets/images/pdf.png" alt="">导出整本灯参</button>
                <button v-else class="dabiao" @click="exportFullExcelNow()"><img src="@/assets/images/ysb.png" alt="">整本灯参pdf</button> <!--跳过选择总则操作-->
                <button   class="dabiao" @click="exportFullWordZip()"><img src="@/assets/images/xiax_03.png" alt="">整本灯参zip</button>
                <button v-if="printneedZong"  class="dabiao" @click="exportRulePdf()"><img src="@/assets/images/pdf.png" alt="">导出总则</button>
                <button   class="dabiao" @click="sendSeal()"><img src="@/assets/images/gaizhang.jpg" alt="">发送盖章</button>
                <!-- <span @click="downloadCurrentProject()"><img src="@/assets/images/xiax_03.png" alt="">导出 </span> -->
              <!--  <span  v-show="fuheshuju" @click="projectArchiving()" style="cursor: pointer;"><img src="@/assets/images/xias1_05.png" alt="">归档 </span>-->
            </div>
            <div class="parameter_rt">
                <el-tooltip content="已按建筑等级预置配电箱和辅材的预估、图纸、实际价格。" placement="top">
                    <el-button class="parameter_rt_btn"><i class="el-icon-warning-outline"></i></el-button>
                </el-tooltip>
                <span>预估总价: {{parseFloat(totalPrice.estimateTotalPrice / 10000).toFixed(2)}}万元</span>
                <span>图纸总价: {{parseFloat(totalPrice.drawingTotalPrice / 10000).toFixed(2)}}万元</span>
                <span>实际总价: {{parseFloat(totalPrice.actualTotalPrice / 10000).toFixed(2)}}万元</span>
            </div>
        </div>
        <div class="wid100">
            <div class="ltNav">
                <div class="kongzhi" :class="activeClass == show ? 'active':''" @click="shows()">
                    <i class="el-icon-arrow-right"></i>
                    <i class="el-icon-arrow-left"></i>
                </div>
                <div class="ltNavConts">
                    <ul class="el-menu-vertical-demo" :class="activeClass == show ? 'active':''">
                        <li>
                            <div class="icon_top" :class="eds == true ? 'active':''"  @click="SeeeMenu()">
                                <span class="icon_is"><i class="el-icon-caret-right"></i> <i class="el-icon-caret-bottom"></i></span>
                                     <span class="icon_ise pened" @click="SelectProjectTreeMenu(currentProject)" >{{currentProject.itemName}}</span>
                            </div>
                            <div class="icon_cont">
                                <ul>
                                    <li v-for="(item,index) in projectTree" :key="index"   :class="index == jduhh ? 'active':''">
                                        <div class="icon_tops" :class="item == jduhhs ? 'selected':''">
                                            <span class="icon_i" @click="setx(index)"><i class="el-icon-caret-right"></i><i class="el-icon-caret-bottom"></i></span>
                                            <span class="name"  @click="SelectProjectTreeMenu(item)">
                                                {{item.itemName}} {{item.projectType == 1 ? '[区]' : '[单体]'}}
                                            </span>
                                        </div>
                                        <div class="icon_bottoms" :class="index == jduhh ? 'active':''">
                                            <p v-for="(j,i) in item.children" :key="'5'+i" @click="SelectProjectTreeMenu(j)" :class="j == jduhhs ? 'selected':''">
                                                <i class="el-icon-tickets"></i> 
                                                {{j.itemName}} {{j.projectType == 1 ? '[区]' : '[单体]'}}
                                            </p >
                                        </div>
                                    </li>  
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="ltNav_cont">
                </div>
            </div>
            <div class="centerCont">
                <el-form ref="form" :inline="true" class="demo-form-inline setyou">
                    <el-form-item label="灯参编号" class="witd">
                        <el-input v-model="request.lampparamNoLike"></el-input>
                    </el-form-item>
                    <el-form-item label="灯具类型" class="witd">
                        <el-select v-model="request.lampType" collapse-tags  >
                         <el-option label="全部" value=""></el-option>
                            <el-option
                            v-for="item in lampTypeList"
                            :key="item.id"
                            :label="item.lampName"
                            :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                     
                    <el-form-item label="灯参状态" class="witd">
                        <el-select v-model="dataStatusList" multiple collapse-tags>
                            <el-option label="暂存" value="1"></el-option>
                            <el-option label="生成" value="2"></el-option>
                            <el-option label="初审中" value="3"></el-option>
                            <el-option label="终审中" value="4"></el-option>
                            <el-option label="审核完成" value="5"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="功率" class="goglv">
                        <el-input v-model="request.lampPowerMin">
                            <span  slot="suffix">w</span>
                        </el-input>
                        ~
                        <el-input v-model="request.lampPowerMax">
                            <span  slot="suffix">w</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="制作人" class="witd zhizuoren">
                        <el-select v-model="request.createBy">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="应用面类型" class="witd">
                        <el-select v-model="request.contestType" >
                                <el-option label="全部" value=""></el-option>
                                <el-option v-for="item in typeList" :label="item.dictCont" :value="item.id" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- 洗墙 立柱 窗框-->
                    <template v-if="request.contestType==356 || request.contestType==358 || request.contestType==498|| request.contestType==362">
                        <el-form-item label="应用面" class="power">
                            <el-input placeholder="高度H" v-model="request.contestH">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="" class="power">
                            <el-input placeholder="宽度W" v-model="request.contestW">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="" class="power">
                            <el-input placeholder="含灯距离D" v-model="request.lumSize">
                            </el-input>
                        </el-form-item>
                    </template>
                    <!-- 正投-->
                    <template v-if="request.contestType==357">
                        <el-form-item label="应用面" class="power">
                            <el-input placeholder="宽度W" v-model="request.contestW">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="" class="power">
                            <el-input placeholder="高度W1" v-model="request.contestW1">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="" class="power">
                            <el-input placeholder="含灯距离D" v-model="request.lumSize">
                            </el-input>
                        </el-form-item>
                    </template>
                    <!--360 复合面 -->
                        <template v-if="request.contestType==360">
                            <el-form-item label="应用面" class="power">
                                <el-input placeholder="高度H" v-model="request.contestH">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="" class="power">
                                <el-input placeholder="宽度W" v-model="request.contestW">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="" class="power">
                                <el-input placeholder="宽度W1" v-model="request.contestW1">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="" class="power">
                                <el-input placeholder="宽度W2" v-model="request.contestW2">
                                </el-input>
                            </el-form-item>
                        </template>
                    <el-form-item>
                        <el-button type="primary" @click="search(1)">查询</el-button>
                        <el-button type="primary" @click="reset()">重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="centerCont_list">
                    <ul>
                        <li v-show="isgdorPending==0 && userhaveRole" @click="shows()"><i class="el-icon-circle-plus-outline"></i>添加</li>
                        <li v-show="isgdorPending==0 && userhaveRole" @click="xiugai()"><i class="el-icon-circle-plus-outline"></i>修改</li>
                        
                        <li v-show="isgdorPending==0 && userhaveRole" @click="deleteLampParamBatch()"><i class="el-icon-delete"></i>删除</li>
                        <li v-if="isgdorPending==3 && userhaveAuditRole" @click="gotoAudit()"><i class="el-icon-document-add"></i>审核</li>
                        <li v-if="isgdorPending==3 && userhaveFirstAuditRole && !userhaveFinalAuditRole" @click="retractFirstAudit()"><i class="el-icon-s-fold"></i>撤回</li>
                        <li v-if="isgdorPending==3 && userhaveAuditRole" @click="onKeyAudit(1)"><i class="el-icon-folder-checked"></i>一键通过</li>
                        <li v-if="isgdorPending==3 && userhaveAuditRole" @click="onKeyAudit(2)"><i class="el-icon-delete"></i>一键驳回</li>

                        <template v-if="isgdorPending == 1"><li @click="showAddToMyProject2()"><i class="el-icon-document-add"></i>添加至我的项目</li></template>
                        <template v-else>
                            <li v-if="isgdorPending!=3 && userhaveRole" @click="showAddToMyProject(1)"><i class="el-icon-document-add"></i>添加至我的项目</li>
                        </template>
                        <li v-show="isgdorPending==0 && fuheshuju && isSingle" @click="changeMan()"><i class="el-icon-guide"></i>变更制作人</li>
                        <li v-show="isgdorPending==0 && userhaveRole" @click="auditbatch()"><i class="el-icon-folder-checked"></i>提交审核</li>
                        <li v-show="isgdorPending==0 && userhaveRole" @click="retractbatch()"><i class="el-icon-s-fold"></i>撤回审核</li>
                      <!-- 暂时去掉自定义排序功能，需要的时候在打开-->
                      <li title="可实现拖拽行排序" v-show="isgdorPending==0 && userhaveRole" @click="sort()" style="width: 100px;"><i class="el-icon-sort" ></i>{{sortText}}</li>
                        <li v-show="isgdorPending==0 && userhaveRole"  @click="defaultSort()">
                            <i class="el-icon-sort"></i>默认排序
                        </li>
                        <!-- <li v-show="isgdorPending==0" @click="dataContrast = true"><i class="el-icon-guide"></i>数据对比</li> -->
                        <!-- <li v-show="isgdorPending==0 && fuheshuju" @click="fuhepinpai()"><i class="el-icon-copy-document"></i>符合品牌</li>  -->
                        <li v-show="isgdorPending==0" @click="showDiffView()"><i class="el-icon-copy-document"></i>差异比较</li>
                        <li class="list_Se">
                        <el-button slot="reference" @click="show_list()" class="list_Se_btn"><i class="el-icon-setting"></i>列表显示项</el-button>
                        </li>
                    </ul>
                </div>
                <div class="parameterTable" v-show="sortFlag">
                    <el-table :height="parameterTableH" 
                    v-loading="defaultSortLoading" element-loading-text="加载中..." 
                    :row-class-name="tableRowClassName"
                    @selection-change="selectTableData"
                    :data="tableData"
                    ref="multipleTable"
                    :row-key="rowKeys"
                    tooltip-effect="dark"
                    @row-click="tableRowClickEdit"
                    @row-dblclick="updatePriceOrCount"
                    @sort-change="sortChange"
                    :default-sort="sortRule"
                    border style="width: 100%" stripe>
                        <el-table-column type="selection" width="50" ></el-table-column>
                        <el-table-column v-if="columnShowHideList2[0].value" label="灯参编号" prop="lampparamNo" sortable='custom' width='110' fixed>
                            <template slot-scope="scope" >
                                <div v-if="isgdorPending == 3 && scope.row.projectLampparamVo.dataStatus != 1 && scope.row.projectLampparamVo.dataStatus != 2">
                                    <div  class="bianhao" @click="dianjiAudit(scope.row.lampparamId)">
                                        <span v-if="scope.row.projectLampparamVo.version != 1 && scope.row.rootIn==1" style="color:red" title="标准灯参有改动，请关注！">{{ scope.row.projectLampparamVo.lampparamNo }}</span>
                                        <span v-else>{{ scope.row.projectLampparamVo.lampparamNo }}</span>
                                        <!--单体使用次数大于1且存在修改记录表示可能公用灯参，提供灯参修改记录查看功能-->
                                        <span v-if="scope.row.projectLampparamVo.version >1 && scope.row.projectLampparamVo.monomersCount >1" class="tanhao" title="灯参被应用多个单体且修改多个版本，可对比历史记录查看">!</span>
                                    </div>
                                    <i v-if="scope.row.rootIn == 1 &&  scope.row.projectLampparamVo.version ==1" class="markIcon"></i>
                                </div>
                                <div v-else>
                                    <!-- <div v-if="scope.row.projectLampparamVo.makingWay == 2">
                                        <div class="bianhao" @click="showLampParamDetail(scope.row.lampparamId)">
                                            <span v-if="scope.row.projectLampparamVo.auditStatus == 3" style="color:red">{{ scope.row.projectLampparamVo.lampparamNo }}</span>
                                            <span v-else>{{ scope.row.projectLampparamVo.lampparamNo }}</span>
                                        </div>
                                    </div>
                                    <div v-else> -->
                                        <div class="bianhao" @click="isPdfStatusParent(scope.row)"  :style="scope.row.projectLampparamVo.auditStatus == 3?'background:red':''" :title="scope.row.projectLampparamVo.auditStatus == 3?'该灯参未通过审核':''">
                                        <!-- <div class="bianhao" @click="showLampParamDetail(scope.row.lampparamId)"  :style="scope.row.projectLampparamVo.auditStatus == 3?'background:red':''" :title="scope.row.projectLampparamVo.auditStatus == 3?'该灯参未通过审核':''"> -->
                                            <span>{{ scope.row.projectLampparamVo.lampparamNo }}</span>
                                            <!--单体使用次数大于1且存在修改记录表示可能公用灯参，提供灯参修改记录查看功能-->
                                            <span v-if="scope.row.projectLampparamVo.version >1 && scope.row.projectLampparamVo.monomersCount >1" class="tanhao" title="灯参被应用多个单体且修改多个版本，可对比历史记录查看">!</span>
                                        </div>
                                    <!-- </div> -->
                                </div>

                                
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList1[0].value" prop="contestTypeString" label="应用面类型" sortable='custom' width='120' >
                            <template slot-scope="scope">{{scope.row.projectLampparamVo.contestTypeString}}</template>
                        </el-table-column>
                        
                        <el-table-column v-if="columnShowHideList1[1].value" prop="contestH" sortable='custom' label="H" width="96">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.contestH != null && scope.row.projectLampparamVo.contestH != ''">{{scope.row.projectLampparamVo.contestH}} m</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList1[2].value" prop="contestW" sortable='custom' label="W" width="96">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.contestW != null && scope.row.projectLampparamVo.contestW != ''">{{scope.row.projectLampparamVo.contestW}} m</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList1[3].value" prop="contestW1" sortable='custom' label="W1" width="96">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.contestW1 != null && scope.row.projectLampparamVo.contestW1 != ''">{{scope.row.projectLampparamVo.contestW1}} m</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList1[4].value" prop="contestW2" sortable='custom' label="W2" width="96">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.contestW2 != null && scope.row.projectLampparamVo.contestW2 != ''">{{scope.row.projectLampparamVo.contestW2}} m</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList1[5].value" prop="lumSizeMin" sortable='custom' label="D" width="96">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.lumSizeMin != null && scope.row.projectLampparamVo.lumSizeMin != ''">{{scope.row.projectLampparamVo.lumSizeMin}} m ~</span>
                                <span v-show="scope.row.projectLampparamVo.lumSize != null && scope.row.projectLampparamVo.lumSize != ''"> {{scope.row.projectLampparamVo.lumSize}} m</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList1[6].value" sortable='custom' prop="projectLampparamVo.albedo" label="反射率"></el-table-column>
                        <el-table-column v-if="columnShowHideList1[7].value" sortable='custom' prop="projectLampparamVo.effectDescription" label="效果描述" width="110"></el-table-column>
                        
                        <el-table-column v-if="columnShowHideList2[1].value" sortable='custom'  prop="lampType" label="灯具类型" width='110'>
                            <template slot-scope="scope">{{scope.row.projectLampparamVo.lampTypeStr}}</template>
                        </el-table-column>

                        <el-table-column v-if="columnShowHideList2[2].value" sortable='custom' prop="projectLampparamVo.lightType" label="光源类型" width="110"></el-table-column>
                        <el-table-column v-if="columnShowHideList2[3].value" sortable='custom' prop="colorType" label="光色类型" width="110">
                            <template slot-scope="scope">
                                <span v-html="scope.row.projectLampparamVo.grayDemandStr"></span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[4].value" sortable='custom' prop="lampPower" label="功率">
                            <template slot-scope="scope">
                                <span v-if="scope.row.projectLampparamVo.lampPower != null && scope.row.projectLampparamVo.lampPower != ''">{{scope.row.projectLampparamVo.lampPower}} {{scope.row.projectLampparamVo.lampPowerUnit}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[5].value"  prop="colorTemperatureStr" label="色温色彩" width="110">
                            <template slot-scope="scope" >
                                <span v-if="scope.row.projectLampparamVo.colorTemperatureStr != null && scope.row.projectLampparamVo.colorTemperatureStr != ''">{{scope.row.projectLampparamVo.colorTemperatureStr}}
                                    <span v-if="scope.row.projectLampparamVo.colorTemperatureStr > 1000"> K</span>
                                </span>
                            </template>
                        </el-table-column>

                        <el-table-column v-if="columnShowHideList2[6].value" sortable='custom' prop="projectLampparamVo.workVoltage" label="工作电压" width="110">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.workVoltage != null && scope.row.projectLampparamVo.workVoltage != ''"> {{scope.row.projectLampparamVo.workVoltagePrefix}} {{scope.row.projectLampparamVo.workVoltage}} V</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[7].value" sortable='custom' prop="projectLampparamVo.materialQuality,projectLampparamVo.materialQuality" label="材质">
                            <template slot-scope="scope" >
                                <span v-if="scope.row.projectLampparamVo.lampQuality == '' ">{{scope.row.projectLampparamVo.materialQuality}}</span>
                                <span v-if="scope.row.projectLampparamVo.materialQuality == '' ">{{scope.row.projectLampparamVo.lampQuality}}</span>
                                <span v-if="scope.row.projectLampparamVo.lampQuality != '' && scope.row.projectLampparamVo.materialQuality != ''">{{scope.row.projectLampparamVo.lampQuality}},{{scope.row.projectLampparamVo.materialQuality}}</span>
                            </template>
                        </el-table-column>

                        <el-table-column v-if="columnShowHideList2[8].value" sortable='custom' prop="projectLampparamVo.lampColor" label="灯具颜色" width="110"></el-table-column>

                        <el-table-column v-if="columnShowHideList2[9].value" sortable='custom' prop="projectLampparamVo.surfaceTemperature" label="表面温度" width="110"></el-table-column>
                        <el-table-column v-if="columnShowHideList2[10].value" sortable='custom' prop="projectLampparamVo.protectLevel" label="防护等级" width="110"></el-table-column>

                        <el-table-column v-if="columnShowHideList2[11].value" sortable='custom' prop="projectLampparamVo.weight" label="重量">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.weight != null && scope.row.projectLampparamVo.weight != ''">{{scope.row.projectLampparamVo.weight}} KG</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[12].value" sortable='custom' prop="lampLong" label="灯具长">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.lampLong != null && scope.row.projectLampparamVo.lampLong != ''">{{scope.row.projectLampparamVo.lampLong}} mm</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[13].value" sortable='custom' prop="lampWidth" label="灯具宽">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.lampWidth != null && scope.row.projectLampparamVo.lampWidth != ''">{{scope.row.projectLampparamVo.lampWidth}} mm</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[14].value" sortable='custom' prop="lampHeight" label="灯具高">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.lampHeight != null && scope.row.projectLampparamVo.lampHeight != ''">{{scope.row.projectLampparamVo.lampHeight}} mm</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[15].value" sortable='custom' prop="projectLampparamVo.installDirection" label="安装方向" width="110"></el-table-column>
                        <el-table-column v-if="columnShowHideList2[16].value" sortable='custom' prop="projectLampparamVo.installType" label="安装方式" width="110"></el-table-column>
                        
                        
                        <el-table-column v-if="columnShowHideList2[17].value" sortable='custom' prop="controlProtocol" label="控制协议" width="110">
                            <template slot-scope="scope">{{scope.row.projectLampparamVo.controlProtocol}}</template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[18].value" sortable='custom'  prop="projectLampparamVo.colorDemand" label="动态效果" width="110"></el-table-column>
                        
                        <el-table-column v-if="columnShowHideList3[0].value" sortable='custom' prop="areaCount" label="区使用次数" width='130'>
                            <template slot-scope="scope">
                                <div v-if="scope.row.projectLampparamVo.areaCount != ''" class="bianhao" style="color:blue" @click="showCountDiaglog(scope.row.lampparamId,1)">{{ scope.row.projectLampparamVo.areaCount }}</div>
                                <div v-else>{{scope.row.projectLampparamVo.areaCount}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[1].value" sortable='custom' prop="monomersCount" label="单体使用次数" width='130'>
                            <template slot-scope="scope">
                                <div v-if="scope.row.projectLampparamVo.monomersCount != ''" class="bianhao" style="color:blue" @click="showCountDiaglog(scope.row.lampparamId,2)">{{ scope.row.projectLampparamVo.monomersCount }}</div>
                                <div v-else>{{scope.row.projectLampparamVo.monomersCount}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[2].value" sortable='custom' prop="unitPrice" label="参考价" width='100'>
                            <template slot-scope="scope" >
                                <div v-show="!scope.row.showEdit"><span v-show="scope.row.projectLampparamVo.unitPrice!=null && scope.row.projectLampparamVo.unitPrice!=''">{{scope.row.projectLampparamVo.unitPrice}} 元</span></div>
                                <div v-show="scope.row.showEdit"><el-input v-model="scope.row.projectLampparamVo.unitPrice"></el-input></div>
                            </template>
                        </el-table-column>                        
                        <el-table-column v-if="columnShowHideList3[3].value" sortable='custom' prop="estimateNum" label="预估数量" width='106'>
                            <template slot-scope="scope" >
                                <div v-show="!scope.row.showEditCountyugu">{{scope.row.projectLampparamVo.estimateNum}}</div>
                                <div v-show="scope.row.showEditCountyugu"><el-input v-model="scope.row.projectLampparamVo.estimateNum"></el-input></div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[4].value" sortable='custom' prop="estimateNum" label="预估小计" width='106'>
                            <template slot-scope="scope" >
                                <div>{{((scope.row.projectLampparamVo.estimateNum * scope.row.projectLampparamVo.unitPrice) / 10000).toFixed(2)}} 万元</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[5].value" sortable='custom' prop="drawingCount" label="图纸数量" width='106'>
                            <template slot-scope="scope" >
                                <div v-show="!scope.row.showEditCount">{{scope.row.projectLampparamVo.drawingCount}}</div>
                                <div v-show="scope.row.showEditCount"><el-input v-model="scope.row.projectLampparamVo.drawingCount"></el-input></div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[6].value" sortable='custom' prop="drawingCount" label="图纸小计" width='106'>
                            <template slot-scope="scope" >
                                <div>{{((scope.row.projectLampparamVo.drawingCount * scope.row.projectLampparamVo.unitPrice) / 10000).toFixed(2)}} 万元</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[7].value" sortable='custom' prop="actualCount" label="实际数量" width='106'>
                            <template slot-scope="scope" >
                                <div v-show="!scope.row.showEditCount">{{scope.row.projectLampparamVo.actualCount}}</div>
                                <div v-show="scope.row.showEditCount"><el-input v-model="scope.row.projectLampparamVo.actualCount"></el-input></div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[8].value" sortable='custom' prop="actualCount" label="实际小计" width='106'>
                            <template slot-scope="scope" >
                                <div>{{((scope.row.projectLampparamVo.actualCount* scope.row.projectLampparamVo.unitPrice / 10000)).toFixed(2)}} 万元</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="lightIndexDesc " height="100" label="量化指标" width='96'>
                                <template slot-scope="scope">
                                     <el-tooltip class="lianghuazhibiaoTip" :content="scope.row.projectLampparamVo.lightIndexDesc" placement="top">
                                        <span>{{scope.row.projectLampparamVo.lightIndexDesc | ellipsisLength20}}</span>
                                    </el-tooltip>
                                </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[9].value"  prop="createName" label="制作人" width='96'>
                            <template slot-scope="scope">{{scope.row.projectLampparamVo.createName}}</template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[10].value" sortable='custom' prop="dataStatus" label="灯参状态" width="170">
                            <template slot-scope="scope" >
                                <div v-if="scope.row.projectLampparamVo.dataStatus == 1">暂存</div>
                                <div v-else-if="scope.row.projectLampparamVo.dataStatus == 2">生成
                                    <!-- <div class="btn2" @click="audit(scope.row.lampparamId)">提交审核</div> -->
                                </div>
                                <div v-else-if="scope.row.projectLampparamVo.dataStatus == 3">初审中</div>
                                <div v-else-if="scope.row.projectLampparamVo.dataStatus == 4 && scope.row.projectLampparamVo.taskName=='灯参终审人'">终审中</div>
                                <div v-else-if="scope.row.projectLampparamVo.dataStatus == 5">审核完成</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[11].value" sortable='custom' prop="versionStr" label="版本号" width='100'>
                            <template slot-scope="scope">{{scope.row.projectLampparamVo.versionStr}}</template>
                        </el-table-column>
                   
                        <el-table-column prop="operation" label="操作" width="140" fixed="right">
                            <template slot-scope="scope">
                                <div class="btns_S">
                                    <div class="btn1">...</div>
                                    <div class="cont">
                                        <!-- @click="showSubmitAudit(scope.row.lampparamId)"-->
                                        <!-- <div class="btn2" @click="dataSourcesBtn(scope.row.projectLampparamVo.detectionIds,scope.row.projectLampparamVo.lampIds)">
                                            <el-tooltip content="数据来源" placement="top">
                                                <i class="el-icon-s-check"></i>
                                            </el-tooltip>
                                        </div> -->
                                        <span class="btn2" @click="ShowAuditRecordList(scope.row.lampparamId)">
                                            <el-tooltip content="审核记录" placement="top">
                                                <i class="el-icon-receiving"></i>
                                            </el-tooltip>                                           
                                        </span>
                                        <!-- @click="deleteLampParam(scope.row.lampparamId)" -->
                                        <span class="btn2" @click="historicalRecord(scope.row.lampparamId)">
                                            <el-tooltip content="历史修改记录" placement="top">
                                                <i class="el-icon-time"></i>
                                            </el-tooltip> 
                                        </span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                                        @size-change="handleSizeChangeAll"
                                        @current-change="handleCurrentChangeAll"
                                        :current-page="request.page"
                                        :page-sizes="[20, 50, 100, 200]"
                                        :page-size="request.rows"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="totalCount">
                                    </el-pagination>
                </div>
                <div class="parameterTable" id="sortList" v-show="!sortFlag">
                    <el-table :height="parameterTableH" 
                    :row-class-name="tableRowClassName"
                    @selection-change="selectTableData"
                    :data="tableData"
                    ref="multipleTable"
                    :row-key="rowKeys"
                    tooltip-effect="dark"
                    @row-click="tableRowClickEdit"
                    @row-dblclick="updatePriceOrCount"
                    @sort-change="sortChange"
                    :default-sort="sortRule"
                    border style="width: 100%" stripe>
                        <el-table-column type="selection" width="50" ></el-table-column>
                        <el-table-column v-if="columnShowHideList2[0].value" label="灯参编号" prop="lampparamNo" sortable='custom' width='110'>
                            <template slot-scope="scope" >
                                <div v-if="isgdorPending == 3 && scope.row.projectLampparamVo.dataStatus != 1 && scope.row.projectLampparamVo.dataStatus != 2">
                                    <div  class="bianhao" @click="dianjiAudit(scope.row.lampparamId)">{{ scope.row.projectLampparamVo.lampparamNo }}</div>
                                </div>
                                <div v-else>
                                    <!-- <div v-if="scope.row.projectLampparamVo.makingWay == 2">
                                        <div class="bianhao" @click="showLampParamDetail(scope.row.lampparamId)">
                                            <span v-if="scope.row.projectLampparamVo.auditStatus == 3" style="color:red">{{ scope.row.projectLampparamVo.lampparamNo }}</span>
                                            <span v-else>{{ scope.row.projectLampparamVo.lampparamNo }}</span>
                                        </div>
                                    </div>
                                    <div v-else> -->
                                        <div class="bianhao" @click="showLampParamDetail(scope.row.lampparamId)">
                                            <span v-if="scope.row.projectLampparamVo.auditStatus == 3" style="color:red">{{ scope.row.projectLampparamVo.lampparamNo }}</span>
                                            <span v-else>{{ scope.row.projectLampparamVo.lampparamNo }}</span>
                                        </div>
                                    <!-- </div> -->
                                </div>
                                
                                
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList1[0].value" prop="contestTypeString" label="应用面类型" sortable='custom' width='120' >
                            <template slot-scope="scope">{{scope.row.projectLampparamVo.contestTypeString}}</template>
                        </el-table-column>
                        
                        <el-table-column v-if="columnShowHideList1[1].value" prop="contestH" sortable='custom' label="H" width="96">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.contestH != null && scope.row.projectLampparamVo.contestH != ''">{{scope.row.projectLampparamVo.contestH}} m</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList1[2].value" prop="contestW" sortable='custom' label="W" width="96">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.contestW != null && scope.row.projectLampparamVo.contestW != ''">{{scope.row.projectLampparamVo.contestW}} m</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList1[3].value" prop="contestW1" sortable='custom' label="W1" width="96">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.contestW1 != null && scope.row.projectLampparamVo.contestW1 != ''">{{scope.row.projectLampparamVo.contestW1}} m</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList1[4].value" prop="contestW2" sortable='custom' label="W2" width="96">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.contestW2 != null && scope.row.projectLampparamVo.contestW2 != ''">{{scope.row.projectLampparamVo.contestW2}} m</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList1[5].value" prop="lumSizeMin" sortable='custom' label="D" width="96">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.lumSizeMin != null && scope.row.projectLampparamVo.lumSizeMin != ''">{{scope.row.projectLampparamVo.lumSizeMin}} m ~</span>
                                <span v-show="scope.row.projectLampparamVo.lumSize != null && scope.row.projectLampparamVo.lumSize != ''"> {{scope.row.projectLampparamVo.lumSize}} m</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList1[6].value" sortable='custom' prop="projectLampparamVo.albedo" label="反射率"></el-table-column>
                        <el-table-column v-if="columnShowHideList1[7].value" sortable='custom' prop="projectLampparamVo.effectDescription" label="效果描述" width="110"></el-table-column>
                        
                        <el-table-column v-if="columnShowHideList2[1].value" sortable='custom'  prop="lampType" label="灯具类型" width='110'>
                            <template slot-scope="scope">{{scope.row.projectLampparamVo.lampTypeStr}}</template>
                        </el-table-column>

                        <el-table-column v-if="columnShowHideList2[2].value" sortable='custom' prop="projectLampparamVo.lightType" label="光源类型" width="110"></el-table-column>
                        <el-table-column v-if="columnShowHideList2[3].value" sortable='custom' prop="colorType" label="光色类型" width="110">
                            <template slot-scope="scope">
                                <span v-html="scope.row.projectLampparamVo.grayDemandStr"></span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[4].value" sortable='custom' prop="lampPower" label="功率">
                            <template slot-scope="scope">
                                <span v-if="scope.row.projectLampparamVo.lampPower != null && scope.row.projectLampparamVo.lampPower != ''">{{scope.row.projectLampparamVo.lampPower}} W</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[5].value"  prop="colorTemperatureStr" label="色温色彩" width="110">
                            <template slot-scope="scope" >
                                <span v-if="scope.row.projectLampparamVo.colorTemperatureStr != null && scope.row.projectLampparamVo.colorTemperatureStr != ''">{{scope.row.projectLampparamVo.colorTemperatureStr}}
                                    <span v-if="scope.row.projectLampparamVo.colorTemperatureStr > 1000"> K</span>
                                </span>
                            </template>
                        </el-table-column>

                        <el-table-column v-if="columnShowHideList2[6].value" sortable='custom' prop="projectLampparamVo.workVoltage" label="工作电压" width="110">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.workVoltage != null && scope.row.projectLampparamVo.workVoltage != ''">{{scope.row.projectLampparamVo.workVoltage}} V</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[7].value" sortable='custom' prop="projectLampparamVo.materialQuality" label="材质"></el-table-column>

                        <el-table-column v-if="columnShowHideList2[8].value" sortable='custom' prop="projectLampparamVo.lampColor" label="灯具颜色" width="110"></el-table-column>

                        <el-table-column v-if="columnShowHideList2[9].value" sortable='custom' prop="projectLampparamVo.surfaceTemperature" label="表面温度" width="110"></el-table-column>
                        <el-table-column v-if="columnShowHideList2[10].value" sortable='custom' prop="projectLampparamVo.protectLevel" label="防护等级" width="110"></el-table-column>

                        <el-table-column v-if="columnShowHideList2[11].value" sortable='custom' prop="projectLampparamVo.weight" label="重量">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.weight != null && scope.row.projectLampparamVo.weight != ''">{{scope.row.projectLampparamVo.weight}} KG</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[12].value" sortable='custom' prop="lampLong" label="灯具长">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.lampLong != null && scope.row.projectLampparamVo.lampLong != ''">{{scope.row.projectLampparamVo.lampLong}} mm</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[13].value" sortable='custom' prop="lampWidth" label="灯具宽">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.lampWidth != null && scope.row.projectLampparamVo.lampWidth != ''">{{scope.row.projectLampparamVo.lampWidth}} mm</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[14].value" sortable='custom' prop="lampHeight" label="灯具高">
                            <template slot-scope="scope">
                                <span v-show="scope.row.projectLampparamVo.lampHeight != null && scope.row.projectLampparamVo.lampHeight != ''">{{scope.row.projectLampparamVo.lampHeight}} mm</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[15].value" sortable='custom' prop="projectLampparamVo.installDirection" label="安装方向" width="110"></el-table-column>
                        <el-table-column v-if="columnShowHideList2[16].value" sortable='custom' prop="projectLampparamVo.installType" label="安装方式" width="110"></el-table-column>
                        
                        
                        <el-table-column v-if="columnShowHideList2[17].value" sortable='custom' prop="controlProtocol" label="控制协议" width="110">
                            <template slot-scope="scope">{{scope.row.projectLampparamVo.controlProtocol}}</template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList2[18].value" sortable='custom'  prop="projectLampparamVo.colorDemand" label="动态效果" width="110"></el-table-column>
                        
                        <el-table-column v-if="columnShowHideList3[0].value" sortable='custom' prop="areaCount" label="区使用次数" width='130'>
                            <template slot-scope="scope">
                                <div v-if="scope.row.projectLampparamVo.areaCount != ''" class="bianhao" style="color:blue" @click="showCountDiaglog(scope.row.lampparamId,1)">{{ scope.row.projectLampparamVo.areaCount }}</div>
                                <div v-else>{{scope.row.projectLampparamVo.areaCount}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[1].value" sortable='custom' prop="monomersCount" label="单体使用次数" width='130'>
                            <template slot-scope="scope">
                                <div v-if="scope.row.projectLampparamVo.monomersCount != ''" class="bianhao" style="color:blue" @click="showCountDiaglog(scope.row.lampparamId,2)">{{ scope.row.projectLampparamVo.monomersCount }}</div>
                                <div v-else>{{scope.row.projectLampparamVo.monomersCount}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[2].value" sortable='custom' prop="unitPrice" label="参考价" width='100'>
                            <template slot-scope="scope" >
                                <div v-show="!scope.row.showEdit"><span v-show="scope.row.projectLampparamVo.unitPrice!=null && scope.row.projectLampparamVo.unitPrice!=''">{{scope.row.projectLampparamVo.unitPrice}} 元</span></div>
                                <div v-show="scope.row.showEdit"><el-input v-model="scope.row.projectLampparamVo.unitPrice"></el-input></div>
                            </template>
                        </el-table-column>                        
                        <el-table-column v-if="columnShowHideList3[3].value" sortable='custom' prop="estimateNum" label="预估数量" width='106'>
                            <template slot-scope="scope" >
                                <div v-show="!scope.row.showEditCountyugu">{{scope.row.projectLampparamVo.estimateNum}}</div>
                                <div v-show="scope.row.showEditCountyugu"><el-input v-model="scope.row.projectLampparamVo.estimateNum"></el-input></div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[4].value" sortable='custom' prop="estimateNum" label="预估小计" width='106'>
                            <template slot-scope="scope" >
                                <div>{{((scope.row.projectLampparamVo.estimateNum * scope.row.projectLampparamVo.unitPrice) / 10000).toFixed(2)}} 万元</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[5].value" sortable='custom' prop="drawingCount" label="图纸数量" width='106'>
                            <template slot-scope="scope" >
                                <div v-show="!scope.row.showEditCount">{{scope.row.projectLampparamVo.drawingCount}}</div>
                                <div v-show="scope.row.showEditCount"><el-input v-model="scope.row.projectLampparamVo.drawingCount"></el-input></div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[6].value" sortable='custom' prop="drawingCount" label="图纸小计" width='106'>
                            <template slot-scope="scope" >
                                <div>{{((scope.row.projectLampparamVo.drawingCount * scope.row.projectLampparamVo.unitPrice) / 10000).toFixed(2)}} 万元</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[7].value" sortable='custom' prop="actualCount" label="实际数量" width='106'>
                            <template slot-scope="scope" >
                                <div v-show="!scope.row.showEditCount">{{scope.row.projectLampparamVo.actualCount}}</div>
                                <div v-show="scope.row.showEditCount"><el-input v-model="scope.row.projectLampparamVo.actualCount"></el-input></div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[8].value" sortable='custom' prop="actualCount" label="实际小计" width='106'>
                            <template slot-scope="scope" >
                                <div>{{((scope.row.projectLampparamVo.actualCount* scope.row.projectLampparamVo.unitPrice / 10000)).toFixed(2)}} 万元</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[9].value"  prop="createName" label="制作人" width='96'>
                            <template slot-scope="scope">{{scope.row.projectLampparamVo.createName}}</template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[10].value" sortable='custom' prop="dataStatus" label="灯参状态" width="106">
                            <template slot-scope="scope" >
                                <div v-if="scope.row.projectLampparamVo.dataStatus == 1">暂存</div>
                                <div v-else-if="scope.row.projectLampparamVo.dataStatus == 2">生成
                                    <!-- <div class="btn2" @click="audit(scope.row.lampparamId)">提交审核</div> -->
                                </div>
                                <div v-else-if="scope.row.projectLampparamVo.dataStatus == 3">已提交</div>
                                <div v-else-if="scope.row.projectLampparamVo.dataStatus == 4">审核中</div>
                                <div v-else-if="scope.row.projectLampparamVo.dataStatus == 5">审核完成</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="columnShowHideList3[11].value" sortable='custom' prop="versionStr" label="版本号" width='100'>
                            <template slot-scope="scope">{{scope.row.projectLampparamVo.versionStr}}</template>
                        </el-table-column>
                   
                        <el-table-column prop="operation" label="操作" width="140" >
                            <template slot-scope="scope">
                                <div class="btns_S">
                                    <div class="btn1">...</div>
                                    <div class="cont">
                                        <!-- @click="showSubmitAudit(scope.row.lampparamId)"-->
                                        <!-- <div class="btn2" @click="dataSourcesBtn(scope.row.projectLampparamVo.detectionIds,scope.row.projectLampparamVo.lampIds)">
                                            <el-tooltip content="数据来源" placement="top">
                                                <i class="el-icon-s-check"></i>
                                            </el-tooltip>
                                        </div> -->
                                        <span class="btn2" @click="ShowAuditRecordList(scope.row.lampparamId)">
                                            <el-tooltip content="审核记录" placement="top">
                                                <i class="el-icon-receiving"></i>
                                            </el-tooltip>                                           
                                        </span>
                                        <!-- @click="deleteLampParam(scope.row.lampparamId)" -->
                                        <span class="btn2" @click="historicalRecord(scope.row.lampparamId)">
                                            <el-tooltip content="历史修改记录" placement="top">
                                                <i class="el-icon-time"></i>
                                            </el-tooltip> 
                                        </span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                                        @size-change="handleSizeChangeAll"
                                        @current-change="handleCurrentChangeAll"
                                        :current-page="request.page"
                                        :page-sizes="[20, 50, 100, 200]"
                                        :page-size="request.rows"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="totalCount">
                                    </el-pagination>
                </div>
            </div>
            <div class="rtNav" v-show="isgdorPending==0 && userhaveRole">
                <div class="kongzhi" :class="activeClass == show ? 'active':''" @click="shows()">
                    <i class="el-icon-arrow-right"></i>
                    <i class="el-icon-arrow-left"></i>
                </div>
                        <el-dialog
                            custom-class="applicationbounced"
                            :visible.sync="show1"
                            @close="closeReco"
                             title="推荐灯参"
                             v-dialogDrag>
                            <div class="cont">
                                <div class="lt">
                                     <el-table :data="recoImgArr" :max-height="tableHeight4"  highlight-current-row  style="width: 100%">
                                        <el-table-column type="index"> </el-table-column>
                                        <el-table-column label="推荐灯参示意图">
                                        <template slot="header" slot-scope="scope">
                                          <el-form :model="recoForm" label-width="80px">
                                            <el-form-item label="应用类型" class="recoLabel">
                                              <el-select @change="changeReco" v-model="otherProjectRequest.contestType"  >
                                                <el-option label="全部" value=""></el-option>
                                            <el-option v-for="item in typeList" :label="item.dictCont" :value="item.id" :key="item.id"></el-option></el-select>
                                            </el-form-item>
                                            </el-form>
                                        </template>
                                         <template slot-scope="scope">
                                            <div @click="chooseContestType(scope.row,index)">
                                                <img :src="ImgPath + scope.row.sketchMapOriginal" alt="">
                                                 <p>{{ scope.row.contestDescribe }}</p>
                                            </div>
                                         </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="rt">
                                    <div  class="tables_td border_bottom">
                                        <div class="te">推荐灯参</div>
                                        <div v-if="!allLeft">
                                        <el-form :inline="true" class="demo-form-inline recoSelect">
                                          <template v-if="letterItemJson">
                                            <el-form-item :label="key" v-for="(value,key) in letterItemJson" v-if="key!='Dmin'" :key="value" class="letterInput">
                                              <el-input @blur="changeLetterValue(key.toLocaleLowerCase())" v-model="selectcontestList[key.toLocaleLowerCase()]" placeholder=""></el-input>
                                            </el-form-item>
                                          </template>
                                          <template v-else>
                                            <el-form-item label="H" class="letterInput">
                                              <el-input @blur="changeLetterValue('h')" v-model="selectcontestList.h" placeholder=""></el-input>
                                            </el-form-item>
                                            <el-form-item label="W" class="letterInput">
                                              <el-input @blur="changeLetterValue('w')" v-model="selectcontestList.w" placeholder=""></el-input>
                                            </el-form-item>
                                            <el-form-item label="D" class="letterInput">
                                              <el-input @blur="changeLetterValue('d')" v-model="selectcontestList.d" placeholder=""></el-input>
                                            </el-form-item>
                                          </template>
                                            <el-form-item label="灯具类型" class="lampTypeWidth">
                                               <el-select v-model="request.lampType" @change="recoLampType">
                                                <el-option label="全部" value="" ></el-option>
                                                    <el-option
                                                    v-for="item in contestUnionLampTypeList"
                                                    :key="item.id"
                                                    :label="item.dictCont"
                                                    :value="item.id"
                                                    ></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="灯参编号">
                                              <el-input v-model="recoSearchJson.lampparamNoLike" placeholder=""></el-input>
                                            </el-form-item>
                                            <el-form-item label="功率" class="letterInput">
                                              <el-input v-model="recoSearchJson.lampPowerMin" >
                                                  <span  slot="suffix">w</span>
                                              </el-input>
                                              ~
                                              <el-input v-model="recoSearchJson.lampPowerMax" >
                                                  <span  slot="suffix">w</span>
                                              </el-input>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-button type="primary" @click="searchReco">查询</el-button>
                                                <!-- <el-button type="primary" @click="reset()">重置</el-button> -->
                                            </el-form-item>
                                          </el-form>
                                                <div  :style="[tableHeightCss]" >
                                                <!-- <table border class="tables" >
                                                    <tr>
                                                        <th width='146'>典型应用场景编号</th>
                                                        <th width='86'>H（m）</th>
                                                        <th width='86'>W（m）</th>
                                                        <th width='86'>D（m）</th>
                                                        <th>标准灯参（单白）</th>
                                                        <th width="156">标准灯参（RGBW）</th>
                                                    </tr>
                                                    <tr v-for="item in contestList" :key="item.id">
                                                        <td>{{item.contestCode}}</td>
                                                        <td>{{item.h}}</td>
                                                        <td>{{item.w}}</td>
                                                        <td>{{item.d}}</td>
                                                        <td class="check">
                                                            <label v-for="j in item.singleColor" :key="j.id"><input v-model="ckblampparamId" type="checkbox" :value="j.id" />{{j.lampparamNo}} </label> 
                                                        </td>
                                                        <td>
                                                            <label v-for="j in item.rgbColor" :key="j.id"><input v-model="ckblampparamId" type="checkbox" :value="j.id" />{{j.lampparamNo}} </label> 
                                                        </td>
                                                    </tr>
                                                </table>     -->
                                                <div class="tables_div" :class="scrollHideFlag?'scrollHideFlag':''"  :max-height="tableHeight4">
                                                    <div class="box_flex div_flex">
                                                      <template v-if="letterItemJson">
                                                        <div class="div_th td_unit "  v-for="(value,key) in letterItemJson"  v-if="key!='Dmin'" :key="value">{{key}}（m）</div>
                                                      </template>
                                                      <template v-else>
                                                        <div class="div_th td_unit">H（m）</div>
                                                        <div class="div_th td_unit">W（m）</div>
                                                        <div class="div_th td_unit">D（m）</div>
                                                      </template>
                                                        <div class="div_th td_weight" >权重</div>

                                                        <div class="td_view_t"  v-show="otherProjectRequest.contestType!=806">
                                                            <div>3000k</div>
                                                            <div class="td_view_d"  >
                                                                <div class="td_view border_right border_bottom">{{this.lowName}}
                                                                    <span class="span-box">
                                                                            <el-tooltip placement="top">
                                                                            <div slot="content" v-html="escapeHTML(this.lowNameDesc)"></div>
                                                                            <i class="el-icon-question"></i>
                                                                          </el-tooltip>
                                                                     </span>

                                                                </div>
                                                                <div class="td_view border_right border_bottom">{{this.middleName}}
                                                                    <span class="span-box">
                                                                            <el-tooltip placement="top">
                                                                            <div slot="content" v-html="escapeHTML(this.middleNameDesc)"></div>
                                                                            <i class="el-icon-question"></i>
                                                                          </el-tooltip>
                                                                     </span>
                                                                </div>
                                                                <div class="td_view border_bottom">{{this.highName}}
                                                                    <span class="span-box">
                                                                            <el-tooltip placement="top">
                                                                            <div slot="content" v-html="escapeHTML(this.highNameDesc)"></div>
                                                                            <i class="el-icon-question"></i>
                                                                          </el-tooltip>
                                                                     </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="td_view_t">
                                                            <div>RGBW</div>
                                                            <div class="td_view_d"  >
                                                                <div class="td_view border_right border_bottom">{{this.lowName}}
                                                                    <span class="span-box">
                                                                            <el-tooltip placement="top">
                                                                            <div slot="content" v-html="escapeHTML(this.rgb_lowNameDesc)"></div>
                                                                            <i class="el-icon-question"></i>
                                                                          </el-tooltip>
                                                                     </span>
                                                                </div>
                                                                <div class="td_view border_right border_bottom">{{this.middleName}}
                                                                    <span class="span-box">
                                                                            <el-tooltip placement="top">
                                                                            <div slot="content" v-html="escapeHTML(this.rgb_middleNameDesc)"></div>
                                                                            <i class="el-icon-question"></i>
                                                                          </el-tooltip>
                                                                     </span>
                                                                </div>
                                                                <div class="td_view border_bottom">{{this.highName}}
                                                                    <span class="span-box">
                                                                            <el-tooltip placement="top">
                                                                            <div slot="content" v-html="escapeHTML(this.rgb_highNameDesc)"></div>
                                                                            <i class="el-icon-question"></i>
                                                                          </el-tooltip>
                                                                     </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-for="(item,index) in contestList" :key="item.id" class="box_flex div_tr">
                                                      <template v-if="letterItemJson">
                                                        <div class="div_td td_unit" v-for="(value,key) in letterItemJson" v-if="key!='Dmin'" :key="value">{{item[key.toLocaleLowerCase()]}}</div>
                                                      </template>
                                                      <template v-else>
                                                        <div class="div_td td_unit">{{item.h}}</div>
                                                        <div class="div_td td_unit">{{item.w}}</div>
                                                        <div class="div_td td_unit">{{item.d}}</div>
                                                      </template>
                                                        <div class="div_td td_weight">
                                                            <div>均匀优先</div>
                                                            <div>亮度优先</div>
                                                            <div>节能优先</div>
                                                        </div>

                                                        <div class="div_td td_view" v-if="item.singleColorMinNear && otherProjectRequest.contestType!=806">
                                                            <div class="check"  v-if="item.singleColorMinNear && JSON.parse(item.singleColorMinNear)[0]">
                                                                <input v-if="JSON.parse(item.singleColorMinNear)[0].lampparamNo" v-model="ckblampparamId"  type="checkbox" :value="JSON.parse(item.singleColorMinNear)[0].id" />
                                                                <label  @click="recommendLamp(JSON.parse(item.singleColorMinNear)[0].id)">{{JSON.parse(item.singleColorMinNear)[0].lampparamNo}}
                                                                </label>

                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                            <div class="check"  v-if="item.singleColorMinNear && JSON.parse(item.singleColorMinNear)[1]" >

                                                                <input v-if="JSON.parse(item.singleColorMinNear)[1].lampparamNo" v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.singleColorMinNear)[1].id" />

                                                                <label  @click="recommendLamp(JSON.parse(item.singleColorMinNear)[1].id)">   {{JSON.parse(item.singleColorMinNear)[1].lampparamNo}} </label>

                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                            <div class="check"  v-if="item.singleColorMinNear && JSON.parse(item.singleColorMinNear)[2]">

                                                                <input v-if="JSON.parse(item.singleColorMinNear)[2].lampparamNo" v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.singleColorMinNear)[2].id" />
                                                                <label  @click="recommendLamp(JSON.parse(item.singleColorMinNear)[2].id)">
                                                                    {{JSON.parse(item.singleColorMinNear)[2].lampparamNo}}
                                                                </label>
                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                        </div>

                                                        <div class="div_td td_view" v-if="item.singleColorNear && otherProjectRequest.contestType!=806">
                                                            <div class="check"  v-if="item.singleColorNear&&JSON.parse(item.singleColorNear)[0]">
                                                                  <input v-if="JSON.parse(item.singleColorNear)[0].lampparamNo" v-model="ckblampparamId"  type="checkbox" :value="JSON.parse(item.singleColorNear)[0].id" />
                                                                   <label  @click="recommendLamp(JSON.parse(item.singleColorNear)[0].id)">{{JSON.parse(item.singleColorNear)[0].lampparamNo}}
                                                                    </label>

                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                            <div class="check"  v-if="item.singleColorNear&&JSON.parse(item.singleColorNear)[1]" >
                                                                <!-- <label> -->
                                                                    <input v-if="JSON.parse(item.singleColorNear)[1].lampparamNo" v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.singleColorNear)[1].id" />

                                                                <label  @click="recommendLamp(JSON.parse(item.singleColorNear)[1].id)">   {{JSON.parse(item.singleColorNear)[1].lampparamNo}} </label>
                                                                <!-- </label> -->
                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                            <div class="check"  v-if="item.singleColorNear&&JSON.parse(item.singleColorNear)[2]">
                                                                <!-- <label> -->
                                                                    <input v-if="JSON.parse(item.singleColorNear)[2].lampparamNo" v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.singleColorNear)[2].id" />
                                                                <label  @click="recommendLamp(JSON.parse(item.singleColorNear)[2].id)">
                                                                    {{JSON.parse(item.singleColorNear)[2].lampparamNo}}
                                                                </label>

                                                                <!-- </label> -->
                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                        </div>

                                                          <div class="div_td td_view" v-if="item.singleColorFar && otherProjectRequest.contestType!=806">
                                                            <div class="check"  v-if="item.singleColorFar&&JSON.parse(item.singleColorFar)[0]" >
                                                                <!-- <label> -->
                                                                    <input v-if="JSON.parse(item.singleColorFar)[0].lampparamNo" v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.singleColorFar)[0].id" />
                                                                <label  @click="recommendLamp(JSON.parse(item.singleColorFar)[0].id)">
                                                                    {{JSON.parse(item.singleColorFar)[0].lampparamNo}}
                                                                </label>
                                                                <!-- </label> -->
                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                            <div class="check"  v-if="item.singleColorFar&&JSON.parse(item.singleColorFar)[1]" >
                                                                <!-- <label> -->
                                                                    <input v-if="JSON.parse(item.singleColorFar)[1].lampparamNo" v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.singleColorFar)[1].id" />
                                                                <label  @click="recommendLamp(JSON.parse(item.singleColorFar)[1].id)">
                                                                    {{JSON.parse(item.singleColorFar)[1].lampparamNo}}
                                                                </label>
                                                                <!-- </label> -->
                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                            <div class="check"  v-if="item.singleColorFar&&JSON.parse(item.singleColorFar)[2]"  >
                                                                <!-- <label> -->
                                                                    <input v-if="JSON.parse(item.singleColorFar)[2].lampparamNo" v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.singleColorFar)[2].id" />
                                                                <label  @click="recommendLamp(JSON.parse(item.singleColorFar)[2].id)">
                                                                    {{JSON.parse(item.singleColorFar)[2].lampparamNo}}
                                                                </label>
                                                                <!-- </label> -->
                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                        </div>

                                                        <div class="div_td td_view" v-if="item.rgbColorMinNear">
                                                            <div class="check"  v-if="item.rgbColorMinNear && JSON.parse(item.rgbColorMinNear)[0]" >
                                                                <!-- <label> -->
                                                                <input v-if="JSON.parse(item.rgbColorMinNear)[0].lampparamNo" v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.rgbColorMinNear)[0].id" />

                                                                <label   @click="recommendLamp(JSON.parse(item.rgbColorMinNear)[0].id)">
                                                                    {{JSON.parse(item.rgbColorMinNear)[0].lampparamNo}}
                                                                </label>
                                                                <!-- </label> -->
                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                            <div class="check"  v-if="item.rgbColorMinNear && JSON.parse(item.rgbColorMinNear)[1]">
                                                                <input v-if="JSON.parse(item.rgbColorMinNear)[1].lampparamNo"  v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.rgbColorMinNear)[1].id" />

                                                                <label    @click="recommendLamp(JSON.parse(item.rgbColorMinNear)[1].id)">
                                                                    {{JSON.parse(item.rgbColorMinNear)[1].lampparamNo}}
                                                                </label>

                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                            <div class="check"  v-if="item.rgbColorMinNear&&JSON.parse(item.rgbColorMinNear)[2]" >

                                                                <input v-if="JSON.parse(item.rgbColorMinNear)[2].lampparamNo"  v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.rgbColorMinNear)[2].id" />

                                                                <label   @click="recommendLamp(JSON.parse(item.rgbColorMinNear)[2].id)">
                                                                    {{JSON.parse(item.rgbColorMinNear)[2].lampparamNo}}
                                                                </label>

                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                        </div>

                                                         <div class="div_td td_view" v-if="item.rgbColorNear">
                                                            <div class="check"  v-if="item.rgbColorNear&&JSON.parse(item.rgbColorNear)[0]" >
                                                                <!-- <label> -->
                                                                    <input v-if="JSON.parse(item.rgbColorNear)[0].lampparamNo" v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.rgbColorNear)[0].id" />

                                                                <label   @click="recommendLamp(JSON.parse(item.rgbColorNear)[0].id)">
                                                                    {{JSON.parse(item.rgbColorNear)[0].lampparamNo}}
                                                                </label>
                                                                <!-- </label> -->
                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                            <div class="check"  v-if="item.rgbColorNear&&JSON.parse(item.rgbColorNear)[1]">
                                                                <!-- <label> -->
                                                                    <input v-if="JSON.parse(item.rgbColorNear)[1].lampparamNo"  v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.rgbColorNear)[1].id" />

                                                                <label    @click="recommendLamp(JSON.parse(item.rgbColorNear)[1].id)">
                                                                    {{JSON.parse(item.rgbColorNear)[1].lampparamNo}}
                                                                </label>
                                                                <!-- </label> -->
                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                            <div class="check"  v-if="item.rgbColorNear&&JSON.parse(item.rgbColorNear)[2]" >
                                                                <!-- <label> -->
                                                                    <input v-if="JSON.parse(item.rgbColorNear)[2].lampparamNo"  v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.rgbColorNear)[2].id" />

                                                                <label   @click="recommendLamp(JSON.parse(item.rgbColorNear)[2].id)">
                                                                    {{JSON.parse(item.rgbColorNear)[2].lampparamNo}}
                                                                </label>
                                                                <!-- </label> -->
                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                        </div>

                                                          <div class="div_td td_view" v-if="item.rgbColorFar">
                                                              <!-- {{JSON.parse(item.rgbColorFar)[1]}} -->
                                                            <div class="check"  v-if="JSON.parse(item.rgbColorFar)[0]" >
                                                                <!-- {{JSON.parse(item.rgbColorFar)[0]}} -->
                                                                <!-- <label> -->
                                                                    <input v-if="JSON.parse(item.rgbColorFar)[0].lampparamNo"  v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.rgbColorFar)[0].id" />

                                                                <label  @click="recommendLamp(JSON.parse(item.rgbColorFar)[0].id)">
                                                                    {{JSON.parse(item.rgbColorFar)[0].lampparamNo}}
                                                                </label>
                                                                <!-- </label> -->
                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                            <div class="check"  v-if="item.rgbColorFar&&JSON.parse(item.rgbColorFar)[1]" >
                                                                <!-- <label> -->
                                                                    <input v-if="JSON.parse(item.rgbColorFar)[1].lampparamNo" v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.rgbColorFar)[1].id" />

                                                                <label @click="recommendLamp(JSON.parse(item.rgbColorFar)[1].id)">
                                                                    {{JSON.parse(item.rgbColorFar)[1].lampparamNo}}
                                                                </label>
                                                                <!-- </label> -->
                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                            <div class="check"  v-if="item.rgbColorFar&&JSON.parse(item.rgbColorFar)[2]" >
                                                                <!-- <label> -->
                                                                    <input v-if="JSON.parse(item.rgbColorFar)[2].lampparamNo"  v-model="ckblampparamId" type="checkbox" :value="JSON.parse(item.rgbColorFar)[2].id" />

                                                                <label @click="recommendLamp(JSON.parse(item.rgbColorFar)[2].id)">
                                                                    {{JSON.parse(item.rgbColorFar)[2].lampparamNo}}
                                                                </label>
                                                                <!-- </label> -->
                                                            </div>
                                                            <div class="check" v-else>
                                                                <div></div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                        </div>
                                         <div class="import">
                                                    <span @click="copyLamparam(1)">
                                                        <!-- <img src="@/assets/images/shang_03.jpg" alt=""> -->
                                                        导入</span>
                                                </div>

                                          
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-dialog>
                        <el-dialog
                            custom-class="library"
                            title="项目库"
                            width="80%"
                            :visible.sync="show2"
                             v-dialogDrag>
                            <div class="libraryCont html_pst">
                                <el-form :inline="true" class="demo-form-inline">
                                    <el-form-item label="项目名称">
                                        <el-select filterable v-model="otherProjectRequest.projectId"> 
                                            <el-option label="全部" value=""></el-option>
                                            <el-option v-for="item in projectList" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="灯参编号" class="width15">
                                        <el-input v-model="otherProjectRequest.lampparamNoLike"></el-input>
                                    </el-form-item>
                                    <el-form-item label="灯具类型" class="width15">
                                        <el-select v-model="otherProjectRequest.lampType">
                                            <el-option label="全部" value=""></el-option>
                                            <el-option
                                            v-for="item in lampTypeList"
                                            :key="item.id"
                                            :label="item.lampName"
                                            :value="item.id"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="制作人" class="width15">
                                        <el-input v-model="otherProjectRequest.createNameLike"></el-input>
                                    </el-form-item>
                                    <el-form-item label="功率" class="power power1">
                                        <el-input v-model="otherProjectRequest.lampPowerMin"></el-input>
                                        <span class="xian">-</span>
                                        <el-input v-model="otherProjectRequest.lampPowerMax"></el-input>
                                        <span>W</span>
                                    </el-form-item>
                                    <el-form-item label="应用面类型" class="width15 width15_s">
                                        <el-select v-model="otherProjectRequest.contestType">
                                            <el-option label="全部" value=""></el-option>
                                            <el-option v-for="item in typeList" :label="item.dictCont" :value="item.id" :key="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <!-- 洗墙 立柱 窗框-->
                    <template v-if="otherProjectRequest.contestType==356 || otherProjectRequest.contestType==358 || otherProjectRequest.contestType==498|| otherProjectRequest.contestType==362">
                        <el-form-item label="应用面" class="power2 power">
                            <el-input placeholder="高度H" v-model="otherProjectRequest.contestH">
                            </el-input>
                            <el-input placeholder="宽度W" v-model="otherProjectRequest.contestW">
                            </el-input>
                            <el-input placeholder="含灯距离D" v-model="otherProjectRequest.lumSize">
                            </el-input>
                        </el-form-item>
                    </template>
                    <!-- 正投-->
                    <template v-if="otherProjectRequest.contestType==357">
                        <el-form-item label="应用面" class="power">
                            <el-input placeholder="宽度W" v-model="otherProjectRequest.contestW">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="" class="power">
                            <el-input placeholder="高度W1" v-model="otherProjectRequest.contestW1">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="" class="power">
                            <el-input placeholder="含灯距离D" v-model="otherProjectRequest.lumSize">
                            </el-input>
                        </el-form-item>
                    </template>
                    <!--360 复合面 -->
                        <template v-if="otherProjectRequest.contestType==360">
                            <el-form-item label="应用面" class="power">
                                <el-input placeholder="高度H" v-model="otherProjectRequest.contestH">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="" class="power">
                                <el-input placeholder="宽度W" v-model="otherProjectRequest.contestW">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="" class="power">
                                <el-input placeholder="宽度W1" v-model="otherProjectRequest.contestW1">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="" class="power">
                                <el-input placeholder="宽度W2" v-model="otherProjectRequest.contestW2">
                                </el-input>
                            </el-form-item>
                        </template>
                                    
                                    <el-form-item>
                                        <el-button @click="getOtherProject(1)" type="primary">查询</el-button>
                                    </el-form-item>
                             </el-form>
                                 
                                    
                                <el-table
                                    stripe
                                    :data="otherProjectList"
                                    tooltip-effect="dark"
                                    style="width: 100%"
                                    :max-height="tableHeight5"
                                    @selection-change="otherProjectSelect">
                                    <el-table-column type="selection" width="55"></el-table-column>
                                    <el-table-column prop="projectName" label="项目名称"> </el-table-column>
                                    <el-table-column prop="lampparamNo" label="灯参编号">
                                        <template slot-scope="scope" >
                                            <div class="bianhao" style="color:blue" @click="showLampParamDetail(scope.row.id,false)">{{ scope.row.lampparamNo }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="contestTypeString" label="应用面类型" ></el-table-column>
                                    <el-table-column prop="contestH" label="H(m)"></el-table-column>
                                    <el-table-column prop="contestW" label="W(m)"></el-table-column>
                                    <el-table-column prop="lumSize" label="D(m)"></el-table-column>
                                    <el-table-column prop="lampType" label="灯具类型"></el-table-column>
                                    <el-table-column prop="lampPower" label="功率">
                                        <template slot-scope="scope">{{scope.row.lampPower}}W</template>
                                    </el-table-column>
                                    <el-table-column prop="" label="控制"></el-table-column>
                                </el-table>
                                <div class="add sdsdeee">
                                    <el-pagination
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :current-page="otherProjectRequest.page"
                                        :page-sizes="[20, 50, 100, 200]"
                                        :page-size="otherProjectRequest.rows"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="otherProjectTotalCount">
                                    </el-pagination>
                                   
                                </div>
                                <div class="add addss addsse"><button type="button" class="el-button el-button--primary"><span @click="copyLamparam(2)"><img src="@/assets/images/bb1.jpg">添加至我的项目</span></button></div>
                            </div>
                        </el-dialog>
                        <el-dialog
                            custom-class="upload"
                            :visible.sync="show3"
                             v-dialogDrag>
                            <el-form ref="form">
                                <div class="title">上传</div>
                                    光色类型：<el-dropdown trigger="click" @command="ChangelampParamUploadFormColorType">
                                        <span class="el-dropdown-link">
                                            <span v-html="lampParamUploadFormColorType.dictCont"></span><i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item v-for="item in guangseleixingList" :key="item.id" :command="item" icon="el-icon-plus" v-html="item.dictCont"></el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                <div class="tihsi">文件命名规则为：［灯参编号.pdf］否则不予上传</div>
                                <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    :action="uploadUrl"
                                    drag
                                    :headers ="headers"
                                    accept=".PDF"
                                    :on-remove="handleRemove"
                                    :before-remove="beforeRemove"
                                    :on-success="LampParamUploadSuccess"
                                    :before-upload="LampParamUploadBefore"
                                    :on-change="LampParamUploadChange"
                                    :auto-upload="false"
                                    >
                                    <i class="el-icon-upload"></i>
                                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                </el-upload>
                                <el-form-item>
                                    <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button> -->
                                    <el-button type="primary" @click="submitUpload">保  存</el-button>
                                </el-form-item>
                            </el-form>
                        </el-dialog>
                <ul :class="activeClass == show ? '':'active'">
                    <li @click="addClass(1)" :class="{active:index == 1}">
                        <el-button type="text" @click="show1 = true" class="btn">
                            <img src="@/assets/images/icon20_101.png" alt="">
                            <img src="@/assets/images/icon20_10.png" alt="">
                            <p>推荐灯参</p>
                        </el-button>
                    </li>
                    <li @click="addClass(2)" :class="{active:index == 2}">
                        <el-button type="text" @click="show2 = true" class="btn">
                            <img src="@/assets/images/icon21_13.png" alt="">
                            <img src="@/assets/images/icon21_131.png" alt="">
                            <p>项目库</p>
                        </el-button>
                        
                    </li>
                    <li @click="addClass(3)" :class="{active:index == 3}">
                        <el-button type="text" class="btn">
                             <img src="@/assets/images/icon22_17.png" alt="">
                            <img src="@/assets/images/icon22_171.png" alt="">
                            <p>自定义</p>
                        </el-button>
                    </li>
                    <!-- <li @click="addClass(4)" :class="{active:index == 4}">
                        <el-button type="text" class="btn">
                             <img src="@/assets/images/icon23_20.png" alt="">
                            <img src="@/assets/images/icon23_201.png" alt="">
                            <p>通用模板</p>
                        </el-button>
                    </!--> 
                    <!-- <li @click="addClass(4)" :class="{active:index == 4}">
                        <el-button type="text" @click="show3Upload()" class="btn">
                             <img src="@/assets/images/icon23_20.png" alt="">
                            <img src="@/assets/images/icon23_201.png" alt="">
                            <p>自行上传</p>
                        </el-button>
                    </li> -->
                </ul>
            </div>
        </div>
       
        <!--归档项目 添加至我的项目 -->
         <el-dialog
            class="tableAddproducts tableDiff "
            title="添加至我的项目"
            custom-class="guidangtable"
            width="600"
            :visible.sync="addMyProject2"
             v-dialogDrag>
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="项目名称">
                        <el-input v-model="searchItemName"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="searchgdProject(1)">查询</el-button>
                     </el-form-item>
                </el-form>
                <el-table
                    ref="singleTable"
                    border
                    :data="gdProjectList"
                    highlight-current-row
                    style="width: 100%">
                    <el-table-column  type="index" width="50"></el-table-column>
                    <el-table-column  label="项目名称">
                         <template slot-scope="scope">
                            <div class="" @click="showAddToMyProject3(scope.row)">{{scope.row.itemName}}</div>
                         </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @current-change="handleCurrentChangegd"
                    :current-page="gdPage"
                    :page-size="10"
                    layout="prev, pager, next"
                    :total="gdTotalCount">
                </el-pagination>
        </el-dialog>
        <el-dialog
            class="tableAddproducts tableDiff "
            title="添加至我的项目"
            custom-class="guidangtable1"
            width="600"
            :visible.sync="addMyProject3"
             v-dialogDrag>
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="子项目名称">
                        <el-input v-model="searchChildProject"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="searchAddMyProjectChild()">查询</el-button>
                     </el-form-item>
                </el-form>
                <el-table
                    @selection-change="gdselectTableData"
                    ref="singleTable"
                    border
                    :data="childProjectList"
                    highlight-current-row
                    style="width: 100%">
                    <el-table-column type="selection" width="50" ></el-table-column>
                    <el-table-column  label="子项目名称" prop="itemName"></el-table-column>
                    <el-table-column prop="projectType" label="单体属性">
                        <template slot-scope="scope">
                            {{scope.row.projectType == 1 ? '[区]' : '[单体]'}}
                        </template>
                    </el-table-column>
                </el-table>
                <span class="dialog-footer">
                    <el-button @click="addMyProject3 = false">返回项目列表</el-button>
                    <el-button type="primary" @click="saveAddToMyProject3()">保存</el-button>
                </span>
        </el-dialog>

        <!-- 列表显示项 -->
        <el-dialog @close='closeShowHideDivSetCookie' :visible.sync="showMorelist" id="typeshowhtml" custom-class='dynamic-class showMorelist show_list'  width="780"  v-dialogDrag>
            <div class="tp">选择设置项包含的信息</div>
            <div class="contcheck">
                <el-form :inline="true" class="demo-form-inline">
                <el-form-item>
                    <div class="cont">
                              <div class="title">应用参数</div>
                              <div class="conts">
                                <div class="li_list" v-for="(item,index)  in columnShowHideList1" :key="index">
                                    <input type="checkbox" :checked="item.value ? 'checked' : ''" @click="changeColumnSH1(index,item)" /> 
                                    <span>{{item.label}}</span>
                                </div>
                              </div>
                    </div>

                    <div class="cont">
                              <div class="title">设备参数</div>
                              <div class="conts">
                                <div class="li_list" v-for="(item,index)  in columnShowHideList2" :key="index">
                                    <input type="checkbox" :checked="item.value ? 'checked' : ''" @click="changeColumnSH2(index,item)" /> 
                                    <span>{{item.label}}</span>
                                </div>
                              </div>
                    </div>
                    <div class="cont">
                              <div class="title">实测参数</div>
                              <div class="conts">
                                <div class="li_list" v-for="(item,index)  in columnShowHideList3" :key="index">
                                    <input type="checkbox" :checked="item.value ? 'checked' : ''" @click="changeColumnSH3(index,item)" /> 
                                    <span>{{item.label}}</span>
                                </div>
                              </div>
                    </div>
                    
                    <div class="btn"><el-button type="primary"  @click="showMorelist = false">确定</el-button></div>
                </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        <!-- 灯参编号 详情 -->
        <parameterLampDetail ref="detail" v-on:setDetailInfo="setDetailInfo" v-on:showAddToMyProject="showAddToMyProject" v-on:showPDFEditView="showPDFEditView" v-on:gotoUpdate="gotoUpdate" v-on:audit="audit" v-on:perv="perv" v-on:next="next" v-on:refreshdetail="refreshdetail"></parameterLampDetail>
        <!-- 灯参编号 Pdf详情 -->
        <parameterLampDetailPdf ref="detailPdf" v-on:setDetailInfo="setDetailInfo" v-on:showAddToMyProject="showAddToMyProject" v-on:showPDFEditView="showPDFEditView" v-on:gotoUpdatePdf="gotoUpdatePdf" v-on:audit="audit" v-on:perv="pervPdf" v-on:next="nextPdf" v-on:refreshdetail="refreshdetail"></parameterLampDetailPdf>
        <!-- 历史修改记录 -->
        <el-dialog :visible.sync="historicalRecord_dialog" 
            class="tableAddproducts"
            title="历史修改记录"
            custom-class="classCources"
            v-dialogDrag>
            <el-table :data="historyModifyList" border style="width: 100%" :max-height="tableHeight8"  :key="Math.random()">
                <el-table-column  prop="lampparamNo" label="灯参编号"></el-table-column>
                <el-table-column  prop="versionStr" label="灯参版本"></el-table-column>
                <el-table-column  prop="grayDemandStr" label="光色类型"></el-table-column>
                <el-table-column  prop="lampType" label="灯具类型"></el-table-column>
                <el-table-column  prop="controlProtocol"  label="控制协议"></el-table-column>
                <el-table-column  prop="contestTypeString" label="应用类型"></el-table-column>

                <!--非点光源显示 begin -->
                <template v-if="historyContestType!='控光点光源' && historyContestType!='不控光点光源' && historyContestType!='远视点光源'">

                    <el-table-column  prop="albedo" label="反射率"></el-table-column>
                    <el-table-column  prop="contestH"  label="应用尺寸">
                        <template slot-scope="scope">
                            <span v-if="scope.row.contestH != null && scope.row.contestH != ''">H:{{scope.row.contestH}} m</span>
                            <span v-if="scope.row.contestW != null && scope.row.contestW != ''">W:{{scope.row.contestW}} m</span>
                            <span v-if="scope.row.contestW1 != null && scope.row.contestW1 != ''">W1:{{scope.row.contestW1}} m</span>
                            <span v-if="scope.row.contestW2 != null && scope.row.contestW2 != ''">W2:{{scope.row.contestW2}} m</span>
                            <span v-if="(scope.row.lumSizeMin != null && scope.row.lumSizeMin != '') && (scope.row.lumSize != null && scope.row.lumSize != '')">D:{{scope.row.lumSizeMin}} m ~ {{scope.row.lumSize}} m </span>
                            <span v-else-if="(scope.row.lumSizeMin != null && scope.row.lumSizeMin != '')">
                                D:<span v-if="scope.row.contestTypeString != '窗框'">≤</span>
                                {{scope.row.lumSizeMin}} m</span>
                            <span v-else-if="(scope.row.lumSize != null && scope.row.lumSize != '')">
                                D:<span v-if="scope.row.contestTypeString != '窗框'">≤</span>
                                {{scope.row.lumSize}} m</span>
                        </template>
                    </el-table-column>

                    <!--量化指标 -->
                    <!--复合面/窗框时显示begin -->
                    <template v-if="historyContestType=='复合面' || historyContestType=='窗框'">
                        <el-table-column label="量化指标(亮度单位统一为cd/㎡)" width="800px">
                            <template slot-scope="scope">
                                <el-table :data="scope.row.projectParamindexHisVoList">
                                    <el-table-column prop="faceType" label="应用面"></el-table-column>
                                    <el-table-column prop="faceType" label="平均亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.brightnessAvgMin != null && sc.row.brightnessAvgMax != null">{{sc.row.brightnessAvgMin}} ~ {{sc.row.brightnessAvgMax}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="faceType" label="最大亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.brightnessMax != null && sc.row.brightnessMax != ''">{{sc.row.brightnessMax}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="faceType" label="最小亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.brightnessMin != null && sc.row.brightnessMin != ''">{{sc.row.brightnessMin}}</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有begin -->
                                    <el-table-column prop="faceType" label="A点亮度" v-show="historyContestType=='正投'">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.brightnessA != null && sc.row.brightnessA != ''">{{sc.row.brightnessA}}</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有end -->
                                    <el-table-column prop="faceType" label="均匀度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.evenness != null && sc.row.evenness != ''">{{sc.row.evenness}}</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有begin -->
                                    <el-table-column prop="faceType" label="b/c之比" v-show="historyContestType=='正投'">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.bcBrightnessRatioMin != null && sc.row.bcBrightnessRatioMax != ''">{{sc.row.bcBrightnessRatioMin}} ~ {{sc.row.bcBrightnessRatioMax}}</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有end -->
                                    <el-table-column prop="colorTemperatureCustom" label="自定义颜色"></el-table-column>
                                    <el-table-column prop="faceType" label="单色平均亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.brightnessAvgMinCustom != null && sc.row.brightnessAvgMaxCustom != ''">{{sc.row.brightnessAvgMinCustom}} ~ {{sc.row.brightnessAvgMaxCustom}}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                
                            </template>
                        </el-table-column>
                    </template>
                <!--复合面/窗框时显示end -->
                    <template v-else>
                                    <el-table-column prop="faceType" label="平均亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList.length>0 && sc.row.projectParamindexHisVoList[0].brightnessAvgMin != null && sc.row.projectParamindexHisVoList[0].brightnessAvgMax != null">{{sc.row.projectParamindexHisVoList[0].brightnessAvgMin}} ~ {{sc.row.projectParamindexHisVoList[0].brightnessAvgMax}} cd/㎡</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="faceType" label="最大亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList.length>0 && sc.row.projectParamindexHisVoList[0].brightnessMax != null && sc.row.projectParamindexHisVoList[0].brightnessMax != ''">{{sc.row.projectParamindexHisVoList[0].brightnessMax}} cd/㎡</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="faceType" label="最小亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList.length>0 &&  sc.row.projectParamindexHisVoList[0].brightnessMin != null && sc.row.projectParamindexHisVoList[0].brightnessMin != ''">{{sc.row.projectParamindexHisVoList[0].brightnessMin}} cd/㎡</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有begin -->
                                    <el-table-column prop="faceType" label="A点亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList.length>0 &&  sc.row.projectParamindexHisVoList[0].brightnessA != null && sc.row.projectParamindexHisVoList[0].brightnessA != ''">{{sc.row.projectParamindexHisVoList[0].brightnessA}} cd/㎡</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有end -->
                                    <el-table-column prop="faceType" label="均匀度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList.length>0 &&  sc.row.projectParamindexHisVoList[0].evenness != null && sc.row.projectParamindexHisVoList[0].evenness != ''">{{sc.row.projectParamindexHisVoList[0].evenness}}</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有begin -->
                                    <el-table-column prop="faceType" label="b/c之比">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList.length>0 &&  sc.row.projectParamindexHisVoList[0].bcBrightnessRatioMin != null && sc.row.projectParamindexHisVoList[0].bcBrightnessRatioMax != ''">{{sc.row.projectParamindexHisVoList[0].bcBrightnessRatioMin}} ~ {{sc.row.projectParamindexHisVoList[0].bcBrightnessRatioMax}}</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有end -->
                                    <el-table-column prop="colorTemperatureCustom" label="自定义颜色"></el-table-column>
                                    <el-table-column prop="faceType" label="单色平均亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList.length>0 && sc.row.projectParamindexHisVoList[0].brightnessAvgMinCustom != null && sc.row.projectParamindexHisVoList[0].brightnessAvgMaxCustom != ''">{{sc.row.projectParamindexHisVoList[0].brightnessAvgMinCustom}} ~ {{sc.row.projectParamindexHisVoList[0].brightnessAvgMaxCustom}}</span>
                                        </template>
                                    </el-table-column>
                        <!-- 正投、洗墙、复合面、立柱（柱子、瓦楞）、窗框显示 -->
                        <el-table-column  prop="projectParamindexHisVoList[0].maculaHight" label="暗斑高度">
                            <template slot-scope="scope">
                                <span v-if="scope.row.maculaHight != null && scope.row.maculaHight != ''">{{scope.row.maculaHight}} m</span>
                            </template>
                        </el-table-column>
                    </template>
                </template>
                <!--非点光源显示 end -->

                <!--点光源们 -->
                <!--控光 -->
                <template v-else>
                    <template v-if="historyContestType=='控光点光源'">
                        <el-table-column prop="projectParamindexHisVoList[0].level0" label="0°"  sortable="custom">
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].level0}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].level0 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        prop="lightIntensity6"
                        label="上30°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalUp30 != null && scope.row.projectParamindexHisVoList[0].verticalUp30Max != null">
                                {{scope.row.projectParamindexHisVoList[0].verticalUp30}} ~ {{scope.row.projectParamindexHisVoList[0].verticalUp30Max}}
                            cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        prop="verticalUp60"
                        label="下60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].verticalDown60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalDown60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                         :key="Math.random()"
                        prop="lightIntensity5"
                        label="左60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].levelLeft60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].levelLeft60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        prop="lightIntensity2"
                        label="右60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].levelRight60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].levelRight60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        prop="lightIntensity2"
                        label="自定义颜色"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].colorTemperatureCustom}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].colorTemperatureCustom != null">cd</span>
                        </template>
                        </el-table-column>
                         <el-table-column
                        :key="Math.random()"
                        prop="level0Custom"
                        label="单色0°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].level0Custom}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].level0Custom != null">cd</span>
                        </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="historyContestType=='不控光点光源'">
                        <el-table-column prop="projectParamindexHisVoList[0].level0" label="0°"  sortable="custom">
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].level0}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].level0 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        prop="lightIntensity6"
                        label="上60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalUp60">
                                {{scope.row.projectParamindexHisVoList[0].verticalUp60}}
                            cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        prop="verticalUp60"
                        label="下60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].verticalDown60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalDown60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                         :key="Math.random()"
                        prop="lightIntensity5"
                        label="左60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].levelLeft60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].levelLeft60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        prop="lightIntensity2"
                        label="右60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].levelRight60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].levelRight60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        prop="lightIntensity2"
                        label="自定义颜色"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].colorTemperatureCustom}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].colorTemperatureCustom != null">cd</span>
                        </template>
                        </el-table-column>
                         <el-table-column
                        :key="Math.random()"
                        prop="level0Custom"
                        label="单色0°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].level0Custom}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].level0Custom != null">cd</span>
                        </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="historyContestType=='远视点光源'">
                        <el-table-column
                        :key="Math.random()"
                        prop="lightIntensity6"
                        label="上30°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalUp30 != null && scope.row.projectParamindexHisVoList[0].verticalUp30Max != null">
                                {{scope.row.projectParamindexHisVoList[0].verticalUp30}} ~ {{scope.row.projectParamindexHisVoList[0].verticalUp30Max}}
                            cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        prop="lightIntensity6"
                        label="下45°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.projectParamindexHisVoList[0].down45 != null && scope.row.projectParamindexHisVoList[0].down45Max != null">
                                {{scope.row.projectParamindexHisVoList[0].down45}} ~ {{scope.row.projectParamindexHisVoList[0].down45Max}}
                            cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        prop="verticalDown10"
                        label="下10°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalDown10">
                                {{scope.row.projectParamindexHisVoList[0].verticalDown10}}
                            cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        prop="verticalUp60"
                        label="下10°左60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].vertical10Left60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].vertical10Left60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                         :key="Math.random()"
                        prop="lightIntensity5"
                        label="下10°右60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].vertical10Right60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].vertical10Right60 != null">cd</span>
                        </template>
                        </el-table-column>
                       
                        <el-table-column
                        :key="Math.random()"
                        prop="lightIntensity2"
                        label="自定义颜色"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].colorTemperatureCustom}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].colorTemperatureCustom != null">cd</span>
                        </template>
                        </el-table-column>
                         <el-table-column
                        :key="Math.random()"
                        prop="level0Custom"
                        label="单色下10°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].verticalDown10Custom}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalDown10Custom != null">cd</span>
                        </template>
                        </el-table-column>
                    </template>
                </template>

                <el-table-column  prop="lightType" label="光源类型"></el-table-column>
                <el-table-column  prop="workVoltage" label="工作电压">
                    <template slot-scope="scope">
                        <span v-if="scope.row.workVoltage != null && scope.row.workVoltage != ''">{{scope.row.workVoltage}} V</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="lampPower" label="灯具功率">
                    <template slot-scope="scope">
                        <span v-if="scope.row.lampPower != null && scope.row.lampPower != ''">{{scope.row.lampPower}} W</span>
                    </template>
                </el-table-column>

                <!--色温色彩也要表格 -->
                <el-table-column v-if="historyColorType == 2" width="300px" prop="colorTemperatureStr" label="色温色彩">
                    <template slot-scope="sc">
                        <el-table :show-header="false" :data="sc.row.projectParamindexHisVoList1">
                            <el-table-column prop="colorTemperatureStr"></el-table-column>
                            <el-table-column prop="colorPower"></el-table-column>
                            <el-table-column prop="colorCoordinate"></el-table-column>
                        </el-table>
                    </template>
                </el-table-column>
                <el-table-column v-else prop="olorTemperatureStr" label="色温色彩"></el-table-column>

                <el-table-column  prop="controlDigit" label="控制位数" width="100"></el-table-column>

                <el-table-column  prop="lampQuality" label="材质" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.lampQuality != null && scope.row.materialQuality != ''">{{scope.row.lampQuality}},{{scope.row.materialQuality}}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="lampQuality" label="灯具尺寸" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.lampLong != null">{{scope.row.lampLong}}</span> <span v-if="scope.row.lampWidth != ''">* {{scope.row.lampWidth}}</span> <span v-if="scope.row.lampHeight != null">* {{scope.row.lampHeight}}</span> mm
                    </template>
                </el-table-column>
                <el-table-column  prop="weight" label="重量">
                    <template slot-scope="scope">
                        <span v-if="scope.row.weight != null && scope.row.weight != ''">{{scope.row.weight}} KG</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="protectLevel" label="防护等级"></el-table-column>
                <el-table-column  prop="surfaceTemperature" label="表面温度 "></el-table-column>
                <el-table-column  prop="lampColor" label="灯具颜色"></el-table-column>
                <el-table-column  prop="installDirection" label="安装方向"></el-table-column>
                <el-table-column  prop="installType" label="安装方式 "></el-table-column>
                <el-table-column  prop="attachDemand" label="附件要求 " width="400"></el-table-column>
                <el-table-column  prop="effectDescription" label="效果要求" width="400"></el-table-column>    
                <el-table-column  prop="colorDemand" label="动态效果" width="400"></el-table-column>    
                <el-table-column  prop="otherDemand" label="其他要求" width="400"></el-table-column>   
            </el-table>
            <el-pagination
                                @current-change="handleCurrentChangeHistory"
                                :current-page="historyModifyPage"
                                :page-size="5"
                                layout="total,  prev, pager, next"
                                :total="historyModifyCount">
                            </el-pagination>
        </el-dialog>
        <!-- 差异比较 -->
        <el-dialog
            class="tableDiff"
            custom-class="chayibi"
            title="差异项详情"
            width="90%"
            :visible.sync="diff"
            :max-height="tableHeight1"
            v-dialogDrag>
            <el-table :data="tableDiffList" border style="width: 100%" :max-height="tableHeight6" :key="Math.random()">
                <el-table-column prop="lampparamNo" label="灯参编号"></el-table-column>
                <el-table-column prop="versionStr"  label="灯参版本"></el-table-column>
                <el-table-column prop="grayDemandStr" label="光色类型">
                    <template slot-scope="scope">
                        <span v-html="scope.row.grayDemandStr"></span>
                    </template>
                </el-table-column>
                <el-table-column prop="lampType"  label="灯具类型"></el-table-column>
                <el-table-column v-if="!fields.controlProtocol" prop="controlProtocol"  label="控制协议"></el-table-column>
                <el-table-column v-if="!fields.contestTypeString" prop="contestTypeString"  label="应用类型"></el-table-column>

                <template v-if="chayidibiContestType!='控光点光源' && chayidibiContestType!='不控光点光源' && chayidibiContestType!='远视点光源'">

                    <el-table-column  v-if="!fields.albedo" prop="albedo" label="反射率"></el-table-column>
                    <el-table-column  prop="contestH"  label="应用尺寸">
                        <template slot-scope="scope">
                            <span v-if="!fields.contestH && scope.row.contestH != null && scope.row.contestH != ''">H:{{scope.row.contestH}} m</span>
                            <span v-if="!fields.contestW &&  scope.row.contestW != null && scope.row.contestW != ''">W:{{scope.row.contestW}} m</span>
                            <span v-if="!fields.contestW1 && scope.row.contestW1 != null && scope.row.contestW1 != ''">W1:{{scope.row.contestW1}} m</span>
                            <span v-if="!fields.contestW2 && scope.row.contestW2 != null && scope.row.contestW2 != ''">W2:{{scope.row.contestW2}} m</span>
                            <template v-if="!fields.lumSize">
                                <span v-if="(scope.row.lumSizeMin != null && scope.row.lumSizeMin != '') && (scope.row.lumSize != null && scope.row.lumSize != '')">D:{{scope.row.lumSizeMin}} m ~ {{scope.row.lumSize}} m </span>
                                <span v-else-if="(scope.row.lumSizeMin != null && scope.row.lumSizeMin != '')">
                                    D:<span v-if="scope.row.contestTypeString != '窗框'">≤</span>
                                    {{scope.row.lumSizeMin}} m</span>
                                <span v-else-if="(scope.row.lumSize != null && scope.row.lumSize != '')">
                                    D:<span v-if="scope.row.contestTypeString != '窗框'">≤</span>
                                    {{scope.row.lumSize}} m</span>
                            </template>
                        </template>
                    </el-table-column>

                    <!--量化指标 -->
                    <!--复合面/窗框时显示begin -->
                    <template v-if="chayidibiContestType=='复合面' || chayidibiContestType=='窗框'">
                        <el-table-column label="量化指标(亮度单位统一为cd/㎡)" width="800px">
                            <template slot-scope="scope">
                                <el-table :data="scope.row.projectParamindexHisVoList">
                                    <el-table-column v-if="!childFields.faceType" prop="faceType" label="应用面"></el-table-column>
                                    <el-table-column v-if="!childFields.brightnessAvgMin" prop="faceType" label="平均亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.brightnessAvgMin != null && sc.row.brightnessAvgMax != null">{{sc.row.brightnessAvgMin}} ~ {{sc.row.brightnessAvgMax}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="!childFields.brightnessMax" prop="faceType" label="最大亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.brightnessMax != null && sc.row.brightnessMax != ''">{{sc.row.brightnessMax}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="!childFields.brightnessMin" prop="faceType" label="最小亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.brightnessMin != null && sc.row.brightnessMin != ''">{{sc.row.brightnessMin}}</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有begin -->
                                    <el-table-column v-if="!childFields.brightnessA" prop="faceType" label="A点亮度" v-show="historyContestType=='正投'">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.brightnessA != null && sc.row.brightnessA != ''">{{sc.row.brightnessA}}</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有end -->
                                    <el-table-column v-if="!childFields.evenness" prop="faceType" label="均匀度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.evenness != null && sc.row.evenness != ''">{{sc.row.evenness}}</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有begin -->
                                    <el-table-column v-if="!childFields.bcBrightnessRatioMin" prop="faceType" label="b/c之比" v-show="historyContestType=='正投'">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.bcBrightnessRatioMin != null && sc.row.bcBrightnessRatioMax != ''">{{sc.row.bcBrightnessRatioMin}} ~ {{sc.row.bcBrightnessRatioMax}}</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有end -->
                                    <el-table-column v-if="!childFields.colorTemperatureCustom" prop="colorTemperatureCustom" label="自定义颜色"></el-table-column>
                                    <el-table-column v-if="!childFields.brightnessAvgMinCustom" prop="faceType" label="单色平均亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.brightnessAvgMinCustom != null && sc.row.brightnessAvgMaxCustom != ''">{{sc.row.brightnessAvgMinCustom}} ~ {{sc.row.brightnessAvgMaxCustom}}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                
                            </template>
                        </el-table-column>
                    </template>
                <!--复合面/窗框时显示end -->
                    <template v-else>
                                    <el-table-column v-if="!childFields.brightnessAvgMin" prop="faceType" label="平均亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList[0].brightnessAvgMin != null && sc.row.projectParamindexHisVoList[0].brightnessAvgMax != null">{{sc.row.projectParamindexHisVoList[0].brightnessAvgMin}} ~ {{sc.row.projectParamindexHisVoList[0].brightnessAvgMax}} cd/㎡</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="!childFields.brightnessMax" prop="faceType" label="最大亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList[0].brightnessMax != null && sc.row.projectParamindexHisVoList[0].brightnessMax != ''">{{sc.row.projectParamindexHisVoList[0].brightnessMax}} cd/㎡</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="!childFields.brightnessMin" prop="faceType" label="最小亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList[0].brightnessMin != null && sc.row.projectParamindexHisVoList[0].brightnessMin != ''">{{sc.row.projectParamindexHisVoList[0].brightnessMin}} cd/㎡</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有begin -->
                                    <el-table-column v-if="!childFields.brightnessA" prop="faceType" label="A点亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList[0].brightnessA != null && sc.row.projectParamindexHisVoList[0].brightnessA != ''">{{sc.row.projectParamindexHisVoList[0].brightnessA}} cd/㎡</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有end -->
                                    <el-table-column v-if="!childFields.evenness" prop="faceType" label="均匀度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList[0].evenness != null && sc.row.projectParamindexHisVoList[0].evenness != ''">{{sc.row.projectParamindexHisVoList[0].evenness}}</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有begin -->
                                    <el-table-column v-if="!childFields.bcBrightnessRatioMin" prop="faceType" label="b/c之比">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList[0].bcBrightnessRatioMin != null && sc.row.projectParamindexHisVoList[0].bcBrightnessRatioMax != ''">{{sc.row.projectParamindexHisVoList[0].bcBrightnessRatioMin}} ~ {{sc.row.projectParamindexHisVoList[0].bcBrightnessRatioMax}}</span>
                                        </template>
                                    </el-table-column>
                                    <!--正投才有end -->
                                    <el-table-column v-if="!childFields.colorTemperatureCustom" prop="colorTemperatureCustom" label="自定义颜色"></el-table-column>
                                    <el-table-column v-if="!childFields.brightnessAvgMinCustom" prop="faceType" label="单色平均亮度">
                                        <template slot-scope="sc">
                                            <span v-if="sc.row.projectParamindexHisVoList[0].brightnessAvgMinCustom != null && sc.row.projectParamindexHisVoList[0].brightnessAvgMaxCustom != ''">{{sc.row.projectParamindexHisVoList[0].brightnessAvgMinCustom}} ~ {{sc.row.projectParamindexHisVoList[0].brightnessAvgMaxCustom}}</span>
                                        </template>
                                    </el-table-column>
                        <!-- 正投、洗墙、复合面、立柱（柱子、瓦楞）、窗框显示 -->
                        <el-table-column  v-if="!childFields.maculaHight" prop="projectParamindexHisVoList[0].maculaHight" label="暗斑高度">
                            <template slot-scope="scope">
                                <span v-if="scope.row.maculaHight != null && scope.row.maculaHight != ''">{{scope.row.maculaHight}} m</span>
                            </template>
                        </el-table-column>
                    </template>
                </template>
                <!--非点光源显示 end -->



                <!--点光源们 -->
                <!--控光 -->
                <template v-else>
                    <template v-if="chayidibiContestType=='控光点光源'">
                        <el-table-column v-if="!childFields.level0" prop="projectParamindexHisVoList[0].level0" label="0°"  sortable="custom">
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].level0}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].level0 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="!childFields.verticalUp30 && !childFields.verticalUp30Max"
                        :key="Math.random()"
                        prop="lightIntensity6"
                        label="上30°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalUp30 != null && scope.row.projectParamindexHisVoList[0].verticalUp30Max != null">
                                {{scope.row.projectParamindexHisVoList[0].verticalUp30}} ~ {{scope.row.projectParamindexHisVoList[0].verticalUp30Max}}
                            cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="!childFields.verticalDown60"
                        :key="Math.random()"
                        prop="verticalUp60"
                        label="下60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].verticalDown60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalDown60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="!childFields.levelLeft60"
                         :key="Math.random()"
                        prop="lightIntensity5"
                        label="左60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].levelLeft60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].levelLeft60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="!childFields.levelRight60"
                        :key="Math.random()"
                        prop="lightIntensity2"
                        label="右60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].levelRight60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].levelRight60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="!childFields.colorTemperatureCustom"
                        :key="Math.random()"
                        prop="lightIntensity2"
                        label="自定义颜色"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].colorTemperatureCustom}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].colorTemperatureCustom != null">cd</span>
                        </template>
                        </el-table-column>
                         <el-table-column
                        v-if="!childFields.level0Custom"
                        :key="Math.random()"
                        prop="level0Custom"
                        label="单色0°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].level0Custom}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].level0Custom != null">cd</span>
                        </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="chayidibiContestType=='不控光点光源'">
                        <el-table-column 
                        v-if="!childFields.level0" prop="projectParamindexHisVoList[0].level0" label="0°"  sortable="custom">
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].level0}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].level0 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="!childFields.verticalUp60"
                        :key="Math.random()"
                        prop="lightIntensity6"
                        label="上60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalUp60">
                                {{scope.row.projectParamindexHisVoList[0].verticalUp60}}
                            cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="!childFields.verticalDown60"
                        :key="Math.random()"
                        prop="verticalUp60"
                        label="下60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].verticalDown60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalDown60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                         :key="Math.random()"
                        v-if="!childFields.levelLeft60"
                        prop="lightIntensity5"
                        label="左60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].levelLeft60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].levelLeft60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        v-if="!childFields.levelRight60"
                        prop="lightIntensity2"
                        label="右60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].levelRight60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].levelRight60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        prop="lightIntensity2"
                        label="自定义颜色"
                        v-if="!childFields.colorTemperatureCustom"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].colorTemperatureCustom}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].colorTemperatureCustom != null">cd</span>
                        </template>
                        </el-table-column>
                         <el-table-column
                        :key="Math.random()"
                        v-if="!childFields.level0Custom"
                        prop="level0Custom"
                        label="单色0°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].level0Custom}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].level0Custom != null">cd</span>
                        </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="chayidibiContestType=='远视点光源'">
                        <el-table-column
                        :key="Math.random()"
                        prop="lightIntensity6"
                        label="上30°"
                        v-if="!childFields.verticalUp30 && !childFields.verticalUp30Max"
                        width="110"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalUp30 != null && scope.row.projectParamindexHisVoList[0].verticalUp30Max != null">
                                {{scope.row.projectParamindexHisVoList[0].verticalUp30}} ~ {{scope.row.projectParamindexHisVoList[0].verticalUp30Max}}
                            cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        :key="Math.random()"
                        v-if="!childFields.down45 && !childFields.down45Max"
                        prop="lightIntensity6"
                        label="下45°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.projectParamindexHisVoList[0].down45 != null && scope.row.projectParamindexHisVoList[0].down45Max != null">
                                {{scope.row.projectParamindexHisVoList[0].down45}} ~ {{scope.row.projectParamindexHisVoList[0].down45Max}}
                            cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="!childFields.verticalDown10"
                        :key="Math.random()"
                        prop="verticalDown10"
                        label="下10°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalDown10">
                                {{scope.row.projectParamindexHisVoList[0].verticalDown10}}
                            cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="!childFields.vertical10Left60"
                        :key="Math.random()"
                        prop="verticalUp60"
                        label="下10°左60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].vertical10Left60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].vertical10Left60 != null">cd</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                         :key="Math.random()"
                        v-if="!childFields.vertical10Right60"
                        prop="lightIntensity5"
                        label="下10°右60°"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].vertical10Right60}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].vertical10Right60 != null">cd</span>
                        </template>
                        </el-table-column>
                       
                        <el-table-column
                        :key="Math.random()"
                        v-if="!childFields.colorTemperatureCustom"
                        prop="lightIntensity2"
                        label="自定义颜色"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].colorTemperatureCustom}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].colorTemperatureCustom != null">cd</span>
                        </template>
                        </el-table-column>
                         <el-table-column
                        :key="Math.random()"
                        prop="level0Custom"
                        label="单色下10°"
                        v-if="!childFields.verticalDown10Custom"
                        width="110"
                        >
                        <template slot-scope="scope">
                            {{scope.row.projectParamindexHisVoList[0].verticalDown10Custom}}
                            <span v-if="scope.row.projectParamindexHisVoList[0].verticalDown10Custom != null">cd</span>
                        </template>
                        </el-table-column>
                    </template>
                </template>
                <!-- -->
                <el-table-column v-if="!fields.lightType" prop="lightType"  label="光源类型"></el-table-column>
                 <el-table-column v-if="!fields.workVoltage" prop="workVoltage" label="工作电压">
                    <template slot-scope="scope">
                        <span v-if="scope.row.workVoltage != null && scope.row.workVoltage != ''">{{scope.row.workVoltage}} V</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="!fields.lampPower" prop="lampPower" label="灯具功率">
                    <template slot-scope="scope">
                        <span v-if="scope.row.lampPower != null && scope.row.lampPower != ''">{{scope.row.lampPower}} W</span>
                    </template>
                </el-table-column>
                <!--色温色彩也要表格 -->
                <template v-if="!childFields.colorTemperatureStr">
                    <el-table-column v-if="chayiduibiColorType == 2" width="300px" prop="colorTemperatureStr" label="色温色彩">
                        <template slot-scope="sc">
                            <el-table :show-header="false" :data="sc.row.projectParamindexHisVoList1">
                                <el-table-column prop="colorTemperatureStr"></el-table-column>
                                <el-table-column prop="colorPower"></el-table-column>
                                <el-table-column prop="colorCoordinate"></el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column v-else prop="colorTemperatureStr" label="色温色彩"></el-table-column>
                </template>
                <el-table-column v-if="!fields.controlDigit" prop="controlDigit"  label="控制位数"></el-table-column>

                <el-table-column v-if="!fields.lampQuality" prop="lampQuality" label="材质" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.lampQuality != null && scope.row.materialQuality != ''">{{scope.row.lampQuality}},{{scope.row.materialQuality}}</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="!fields.lampLong" prop="lampQuality" label="灯具尺寸" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.lampLong != null">{{scope.row.lampLong}}</span> <span v-if="scope.row.lampWidth != ''">* {{scope.row.lampWidth}}</span> <span v-if="scope.row.lampHeight != null">* {{scope.row.lampHeight}}</span> mm
                    </template>
                </el-table-column>
                <el-table-column v-if="!fields.weight" prop="weight" label="重量">
                    <template slot-scope="scope">
                        <span v-if="scope.row.weight != null && scope.row.weight != ''">{{scope.row.weight}} KG</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="!fields.protectLevel" prop="protectLevel" label="防护等级"></el-table-column>
                <el-table-column v-if="!fields.surfaceTemperature" prop="surfaceTemperature" label="表面温度 "></el-table-column>
                <el-table-column v-if="!fields.lampColor" prop="lampColor" label="灯具颜色"></el-table-column>
                <el-table-column v-if="!fields.installDirection" prop="installDirection" label="安装方向"></el-table-column>
                <el-table-column v-if="!fields.installType" prop="installType" label="安装方式 "></el-table-column>
                <el-table-column v-if="!fields.attachDemand" prop="attachDemand" label="附件要求 " width="400"></el-table-column>
                <el-table-column v-if="!fields.effectDescription" prop="effectDescription" label="效果要求" width="400"></el-table-column>    
                <el-table-column v-if="!fields.colorDemand" prop="colorDemand" label="动态效果" width="400"></el-table-column>    
                <el-table-column v-if="!fields.otherDemand" prop="otherDemand" label="其他要求" width="400"></el-table-column>  

            </el-table>
        </el-dialog>
        <!-- 添加至我的项目 -->
         <el-dialog
            class="tableAddproducts tableDiff"
            title="选择目标项目"
            width="600"
            :visible.sync="addMyProject"
            v-dialogDrag>
                        <!-- @check-change="choosemyProjectIdchange" -->
                        <!-- @check-click="choosemyProjectIdclick" -->
                    <el-tree
                        id="myprojectTree"
                        ref="myprojectTree"
                        show-checkbox
                        node-key="id"
                        :data="projectTree"
                        default-expand-all
                        :check-strictly="true"
                        ></el-tree> 
            <span slot="footer" class="dialog-footer">
                <el-button @click="addMyProject = false">取 消</el-button>
                <el-button type="primary" @click="addlampProjecttoMyproject()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 数据对比 -->
        <el-dialog
            class="dataContrast tableDiff"
            title="选择目标项目"
            :visible.sync="dataContrast"
            v-dialogDrag>
            <div class="lt">
                <el-form :inline="true" :model="formContrast" class="demo-form-inline" :max-height="tableHeight2">
                    <el-form-item>
                        <el-select v-model="formContrast.name" placeholder="选择项目">
                            <el-option label="区域一" value="shanghai"></el-option>
                            <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" >查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table  ref="singleTable" border :data="tableContrast" highlight-current-row :max-height="tableHeight3">
                    <el-table-column type="index" width="50"></el-table-column>
                    <el-table-column property="name" label="项目名称"></el-table-column>
                    <el-table-column property="num" label="灯参编号"></el-table-column>
                    <el-table-column property="type" label="检测类型"></el-table-column>
                </el-table>
            </div>
            <div class="rt">
                <el-form :inline="true" :model="formContrast1" class="demo-form-inline">
                    <el-form-item label="品牌">
                        <el-select v-model="formContrast1.name">
                            <el-option label="区域一" value="shanghai"></el-option>
                            <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" >查询</el-button>
                    </el-form-item>
                </el-form>
                 <el-table :data="tableContrast1" border tooltip-effect="dark" max-height="500" style="width: 100%" >
                    <el-table-column  type="selection"  width="55"> </el-table-column>
                    <el-table-column prop="name" label="来源"></el-table-column>
                    <el-table-column label="编号" >
                        <template slot-scope="scope">
                            <span class="sdw">{{ scope.row.name1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name2" label="品牌" width="100"></el-table-column>
                    <el-table-column prop="name3" label="灯具类型"></el-table-column>
                    <el-table-column prop="name4" label="光源类型"></el-table-column>
                    <el-table-column prop="name5" label="色容差"></el-table-column>
                    <el-table-column prop="name6" label="功率（W）" width="100"></el-table-column>
                    <el-table-column prop="name7" label="色温（K）" width="110"></el-table-column>
                    <el-table-column prop="name8" label="平均亮度（cd/㎡）" width="146"></el-table-column>
                    <el-table-column prop="name9" label="最小亮度（cd/㎡）" width="146"></el-table-column>
                    <el-table-column prop="name10" label="最大亮度（cd/㎡）" width="146"></el-table-column>
                    <el-table-column prop="name11" label="亮度均匀度" width="100"></el-table-column>
                    <el-table-column prop="name12" label="暗斑高度（m）" width="120"></el-table-column>
                    <el-table-column prop="name13" label="长（m）"></el-table-column>
                    <el-table-column prop="name14" label="宽（m）"></el-table-column>
                    <el-table-column prop="name15" label="高（m）"></el-table-column>
                    <el-table-column prop="name16" label="效果图片">
                        <template slot-scope="scope">
                            <img src="@/assets/images/7_03.jpg" alt="">
                        </template>
                    </el-table-column>
                    <el-table-column prop="name17" label="伪色图">
                        <template slot-scope="scope">
                            <img src="@/assets/images/7_03.jpg" alt="">
                        </template>
                    </el-table-column>
                    <el-table-column prop="name18" label="光束角1"></el-table-column>
                    <el-table-column prop="name19" label="光束角2"></el-table-column>
                </el-table>
            </div>
        </el-dialog>
        <!-- 审核记录 -->
         <el-dialog
            class="submitAudit tableDiff"
            title="审核记录"
            :visible.sync="showAuditRecord"
            v-dialogDrag
            max-height='tableHeight6'>
            <el-table ref="singleTable" :data="auditRecordList" highlight-current-row style="width: 100%">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column property="auditStateStr" label="审核状态" ></el-table-column>
                <el-table-column property="createName" label="审核人" ></el-table-column>
                <el-table-column property="createDate" label="审核时间" ></el-table-column>
                <el-table-column property="auditReson" label="审核原因" ></el-table-column>
            </el-table>

            <el-pagination
                                @current-change="handleCurrentChangeAudit"
                                :current-page="auditPage"
                                :page-size="10"
                                layout="total,  prev, pager, next"
                                :total="auditCount">
                            </el-pagination>

        </el-dialog>
        <!-- 区、单体使用次数弹窗 -->
         <el-dialog
            class="submitAudit tableDiff"
            title="灯参使用记录"
            :visible.sync="CountDiaglog"
            v-dialogDrag
            max-height='tableHeight6'>
            <el-table :data="countmenList" highlight-current-row style="width: 100%" max-height="530">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column property="projectName" label="项目名称" ></el-table-column>
                <el-table-column property="createDate" label="使用时间" ></el-table-column>
            </el-table>
            <el-pagination
                                @current-change="handleCurrentChangeCount"
                                :current-page="countmenPage"
                                :page-size="10"
                                layout="total,  prev, pager, next"
                                :total="countmenCount">
                            </el-pagination>
        </el-dialog>
        <!--提交审核结果  -->
        <el-dialog :visible="isShowSubmitAudit" 
            class="tableAddproducts tableDiff"
            title="提交审核"
            width="300"
            v-dialogDrag>
            <el-form ref="form" label-width="80px">
                <el-form-item label="审核原因">
                    <el-input type="textarea" v-model="OnKeyAuditReson"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowSubmitAudit = false">取 消</el-button>
                <el-button type="primary" @click="auditSubmit()">提 交</el-button>
            </span>
        </el-dialog>
        <!--上传灯参 确认弹窗 -->
        <el-dialog
            class="submitAudit tableDiff"
            title="上传灯参"
            :visible.sync="showConfrimDialog"
            width="1200px"
            v-dialogDrag>
            <el-table ref="singleTable" :data="confirmDataTable" highlight-current-row style="width: 100%">
                <el-table-column type="index" width="50" label="序号"> </el-table-column>
                <el-table-column property="fileName" label="文件名" ></el-table-column>
                <el-table-column property="lampTypeStr"  width="180">
                    <template slot="header" slot-scope="scope">
                       光色类型 <span style="color:red"> *</span>
                    </template>
                    <template slot-scope="scope">
                        <el-dropdown trigger="click" @command="rowgrayDemandChange"> 
                                                    <span class="el-dropdown-link">
                                                        <span v-html="scope.row.grayDemandText"></span><i class="el-icon-arrow-down el-icon--right"></i>
                                                    </span>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <el-dropdown-item v-for="item in guangseleixingList" :key="item.id" icon="el-icon-plus" v-html="item.dictCont" :command="composeValue(item,scope.$index)"></el-dropdown-item>
                                                    </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
                <el-table-column property="lampTypeStr" width="120">
                    <template slot="header" slot-scope="scope">
                       灯具类型 <span style="color:red"> *</span>
                    </template>
                    <template slot-scope="scope">
                        <el-popover :ref="'popoverlampTypeStr'+scope.$index" :id="'1popover-'+scope.$index" placement="bottom" width="124" trigger="focus" popper-class="xiala dianya">
                            <ul>
                                <li v-for="item in lampAllTypeList" @click="setConfirmDiagLogPopover(scope.row,item,scope.$index)">{{item.dictCont}}</li>
                            </ul>
                            <el-input v-model="scope.row.lampTypeStr" slot="reference"></el-input>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column property="angleNo" label="光束角" >
                    <template slot-scope="scope">
                        <el-popover :ref="'popoverAnglemapList'+scope.$index" :id="'2popover-'+scope.$index" placement="bottom" width="124" trigger="focus" popper-class="xiala dianya">
                            <ul>
                                <li v-for="item in AnglemapList" @click="setAngleNo(scope.row,item,scope.$index)">{{item.ruleKey}}</li>
                            </ul>
                            <el-input v-model="scope.row.angleNoText" :readonly="true" slot="reference"></el-input>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column property="colorTemperatureStr">
                    <template slot="header" slot-scope="scope">
                       色温色彩 <span style="color:red"> *</span>
                    </template>
                    <template slot-scope="scope">
                        <el-popover :ref="'popovercolorTemperatureStr'+scope.$index" :id="'3popover-'+scope.$index" placement="bottom" width="124" trigger="focus" popper-class="xiala dianya">
                            <ul>
                                <li v-for="item in mbColorList" @click="setcolorTemperatureStr(scope.row,item,scope.$index)">{{item.dictCont}}</li>
                            </ul>
                            <el-input v-model="scope.row.colorTemperatureStr"  slot="reference"></el-input>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column property="lampPower">
                    <template slot="header" slot-scope="scope">
                       功率 <span style="color:red"> *</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input class="donlv" v-model="scope.row.lampPower" @blur="checkPower(scope.row.lampPower,scope.$index)"><i slot="suffix">W</i></el-input>
                    </template>
                </el-table-column>
                <el-table-column property="workVoltage" >
                    <template slot="header" slot-scope="scope">
                       工作电压 <span style="color:red"> *</span>
                    </template>
                    <template slot-scope="scope">
                        <el-popover :ref="'popoverworkVoltage'+scope.$index" :id="'4popover-'+scope.$index" placement="bottom" width="60" trigger="focus" popper-class="xiala dianya glv">
                            <ul>
                                <li v-for="item in gongzuodianyaList" @click="setworkVoltage(scope.row,item,scope.$index)">{{item.dictCont}}</li>
                            </ul>   
                            <el-input  class="donlv" v-model="scope.row.workVoltage" @blur="checkInteger(scope.row.workVoltage,scope.$index)" slot="reference"><i slot="suffix">V</i></el-input>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column property="lightType"  >
                    <template slot="header" slot-scope="scope">
                       光源类型 <span style="color:red"> *</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.lightType"></el-input>
                    </template>
                </el-table-column>
                 <el-table-column property="controlProtocol"  width="170">
                    <template slot="header" slot-scope="scope">
                       控制协议 <span style="color:red"> *</span>
                    </template>
                    <template slot-scope="scope">
                        <el-popover :ref="'popovercontrolProtocol'+scope.$index" :id="'5popover-'+scope.$index" placement="bottom" width="124" trigger="focus" popper-class="xiala dianya">
                            <ul>
                                <li v-for="item in controlProtocol1List" @click="setcontrolProtocol(scope.row,item,scope.$index)">{{item.dictCont}}</li>
                            </ul>
                            <el-input v-model="scope.row.controlProtocol" slot="reference"></el-input>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeSubmitConfrim()">取 消</el-button>
                <el-button type="primary" @click="submitConfrim()">提 交</el-button>
            </span>
        </el-dialog>
         <!-- 数据来源 -->
        <el-dialog :visible.sync="dataSources" 
            class="tableAddproducts tableDiff"
            title="参考数据来源"
            custom-class="classCources"
            v-dialogDrag>
            <el-table :data="dataSourceList" border style="width: 100%" :max-height="tableHeight">
                <el-table-column  prop="brandName" label="品牌"></el-table-column>
                <el-table-column  prop="dictIdLtype" label="灯具类型"></el-table-column>
                <el-table-column  prop="lumVoltage" label="标称电压"></el-table-column>
                <el-table-column  prop="power" label="实测功率"></el-table-column>
                <el-table-column  prop="colorTempe" label="色温"></el-table-column>
                <el-table-column  prop="sdcm" label="色容差"></el-table-column>
                <el-table-column  prop="date" label="光束角">
                    <template slot-scope="scope">
                        <template v-if="scope.row.angle1 != null && scope.row.angle2 != null">{{scope.row.angle1}}° * {{scope.row.angle2}}°</template>
                      </template>
                </el-table-column>
                <el-table-column  prop="sH" label="H"></el-table-column>
                <el-table-column  prop="sW" label="W"></el-table-column>
                <el-table-column  prop="lumSize" label="含灯具距离" width="100"></el-table-column>
                <el-table-column  prop="lightnessAve" label="平均亮度"></el-table-column>
                <el-table-column  prop="lightness" label="最小亮度"></el-table-column>
                <el-table-column  prop="lightnessMax" label="最大亮度"></el-table-column>
                <el-table-column  prop="evenness" label="亮度均匀度 " width="100"></el-table-column>
                <el-table-column  prop="date" label="伪色图">
                    <template slot-scope="scope" >
                            <img :src="ImgPath+scope.row.pseuColor" height="66" alt="" @click="viewPicture(ImgPath+scope.row.pseuColor)">
                        </template>
                </el-table-column>
                <el-table-column  prop="date" label="效果图片">
                    <template slot-scope="scope" >
                            <img :src="ImgPath+scope.row.viewPhoto" height="66"  alt="" @click="viewPicture(ImgPath+scope.row.viewPhoto)">
                        </template></el-table-column>                
                <el-table-column  prop="date" label="配光曲线">
                    <template slot-scope="scope" >
                            <img :src="ImgPath+scope.row.lightIntensity" alt="" @click="viewPicture(ImgPath+scope.row.lightIntensity)">
                        </template>
                </el-table-column>
                <el-table-column  prop="date" label="尺寸（含支架)" width="120">
                    <template slot-scope="scope" >
                            <template v-if="scope.row.longS != null && scope.row.widthS != null">{{scope.row.longS}} * {{scope.row.widthS}} * {{scope.row.heightS}}mm</template>
                        </template>
                </el-table-column>                
                <el-table-column  prop="date" label="尺寸（不含支架)" width="130">
                    <template slot-scope="scope" >
                           <template v-if="scope.row.longNs != null && scope.row.widthNs != null"> {{scope.row.longNs}} * {{scope.row.widthNs}} * {{scope.row.heightNs}}mm</template>
                        </template>
                </el-table-column>                
                <el-table-column  prop="ipGrade" label="IP等级 "></el-table-column>                
                <el-table-column  prop="price" label="价格(元)"></el-table-column>                
            </el-table>
        </el-dialog>
        
        <!--导出整本灯参  -->
         <el-dialog :visible.sync="exportdialog" id="export" title="项目灯参总则配置项" custom-class='export'   v-dialogDrag>
             <el-form ref="exportform" label-width="80px">
                <table border class="exportTable" id="read"  @scroll="orderScroll">
                    <tr v-for="(item,index) in projectConfigureList" :key="index">
                        <td width="170" v-html="item.paramName.split(',')[0]+':'"></td>
                        <td width="210">
                            <el-date-picker v-if="item.paramName == '生成时间'" v-model="item.paramValue" type="month" placeholder="选择月份" value-format="yyyy-MM" format="yyyy-MM"></el-date-picker>
                             <template v-else-if="item.paramName == '所属公司'">
                                <el-popover ref="popover21" placement="bottom" trigger="focus" popper-class="xiala">
                                    <ul>
                                        <li v-for="item1 in organizationsList" @click="setCompany(item1.orgName,item1.orgCode,item)">{{item1.orgName}}</li>
                                    </ul>
                                </el-popover>
                                <el-input v-model="exportform.companyText" v-popover:popover21></el-input>
                            </template> 
                            <!-- <div id="container"  v-else-if="item.paramName == '所属公司'">
                                <select  class="select-box" v-model="exportform.companyText">
                                    <option @click="setCompany('北京清华同衡规划设计研究院有限公司','1300',item)">北京清华同衡规划设计研究院有限公司</option>
                                        <option @click="setCompany('北京清控人居光电研究院有限公司','1100',item)">北京清控人居光电研究院有限公司</option>
                                        <option @click="setCompany('北京清城同衡照明设计院有限公司','1200',item)">北京清城同衡照明设计院有限公司</option>
                                </select>
                                <el-input  v-model="exportform.companyText" @input="changeValue()"></el-input>
                            </div> -->
                             <el-popover v-else ref="popoverlist" :id="'popover-'+index" placement="bottom" trigger="focus" popper-class="xiala">
                                <ul>
                                    <li v-for="(j,i) in options[index]" :key="i" @click="setProjectConfigure(item,j.dictCont,index)" v-html="j.dictCont"></li>
                                </ul>
                                <el-input  v-model="item.paramValue" :disabled="item.disabled"  slot="reference" ></el-input>
                            </el-popover>
                            <!-- <div id="container"  v-else-if="options[index].length>0">
                                <select  class="select-box" v-model="item.paramValue" :id="'popover-'+index">
                                    <option v-for="(j,i) in options[index]" :key="i" @click="setProjectConfigure(item,j.dictCont,index)" v-html="j.dictCont"></option>
                                </select>
                                <el-input  v-model="item.paramValue" @input="changeValue()"></el-input>
                            </div>
                            <div id="container"  v-else>
                                <el-input  v-model="item.paramValue" @input="changeValue()"></el-input>
                            </div> -->
                            
                        </td>
                    </tr>
                    <!-- <tr>
                        <td width="170">项目名称:</td>
                        <td width="210">
                            <el-input v-model="exportform.projectName" ></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td width="170">所属公司名称:</td>
                        <td width="210">
                            <el-popover ref="popover21" placement="bottom" trigger="focus" popper-class="xiala">
                                <ul>
                                    <li @click="setCompany('北京清华同衡规划设计研究院有限公司','1300')">北京清华同衡规划设计研究院有限公司</li>
                                    <li @click="setCompany('北京清控人居光电研究院有限公司','1100')">北京清控人居光电研究院有限公司</li>
                                    <li @click="setCompany('北京清城同衡照明设计院有限公司','1200')">北京清城同衡照明设计院有限公司</li>
                                </ul>
                            </el-popover>
                            <el-input v-model="exportform.companyText" v-popover:popover21></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td width="170">生成时间:</td>
                        <td width="210">
                            <el-date-picker
                            v-model="exportform.date"
                            type="date"
                            placeholder="选择日期">
                            </el-date-picker>
                        </td>
                    </tr> -->


                </table>
                <el-form-item class="tectCent">
                     <el-button type="primary" @click="exportdialog = false" >取消</el-button>
                    <el-button type="primary" @click="editZongZe()" >确定</el-button>
                </el-form-item>
             </el-form>
        </el-dialog>
        <!--编辑pdf的 修改  -->
         <el-dialog :visible.sync="showPDFEditViewDiag" id="export" title="重新上传灯参" custom-class='export'   v-dialogDrag>
             <el-form ref="exportform" label-width="80px">
                <table border class="exportTable">
                    <tr>
                        <td width="170">光色类型:<span style="color:red">*</span></td>
                        <td width="210">
                            <el-dropdown trigger="click" @command="EditFormPdfGrayDemandText">
                                        <span class="el-dropdown-link">
                                            <span v-html="pefEditForm.grayDemandText"></span><i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item v-for="item in guangseleixingList" :key="item.id" :command="item" icon="el-icon-plus" v-html="item.dictCont"></el-dropdown-item>
                                        </el-dropdown-menu>
                            </el-dropdown>
                        </td>
                    </tr>
                    <tr>
                        <td width="170">灯具类型:<span style="color:red">*</span></td>
                        <td width="210">
                            <el-popover ref="popoverlampTypeStr1ed" placement="bottom" width="124" trigger="focus" popper-class="xiala dianya">
                                <ul class="ulsse">
                                    <li v-for="item in lampAllTypeList" @click="setConfirmDiagLogPopover1(item)">{{item.dictCont}}</li>
                                </ul>
                            </el-popover>
                            <el-input v-model="pefEditForm.lampTypeStr" class="e4y" v-popover:popoverlampTypeStr1ed></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td width="170">光束角:</td>
                        <td width="210">
                            <el-popover ref="popoverAnglemapList1ed" placement="bottom" width="124" trigger="focus" popper-class="xiala dianya">
                            <ul class="ulsse">
                                <li v-for="item in AnglemapList" @click="setAngleNo1(item)">{{item.ruleKey}}</li>
                            </ul>
                        </el-popover>
                        <el-input v-model="pefEditForm.angleNoText" :readonly="true"  class="e4y" v-popover:popoverAnglemapList1ed></el-input>
                        </td>
                    </tr>
                     <tr>
                        <td width="170">色温色彩:<span style="color:red">*</span></td>
                        <td width="210">
                            <el-popover ref="popovercolorTemperatureStr1ed" placement="bottom" width="124" trigger="focus" popper-class="xiala dianya">
                                <ul class="ulsse">
                                    <li v-for="item in mbColorList" @click="setcolorTemperatureStr1(item)">{{item.dictCont}}</li>
                                </ul>
                            </el-popover>
                            <el-input v-model="pefEditForm.colorTemperatureStr" class="e4y" v-popover:popovercolorTemperatureStr1ed></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td width="170">功率:<span style="color:red">*</span></td>
                        <td width="210">
                            <el-input v-model="pefEditForm.lampPower" class="e4y"><i slot="suffix">w</i></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td width="170">工作电压:<span style="color:red">*</span></td>
                        <td width="210">
                            <el-popover ref="popoverworkVoltage1ed" placement="bottom" width="124" trigger="focus" popper-class="xiala dianya">
                            <ul class="ulsse">
                                <li v-for="item in gongzuodianyaList" @click="setworkVoltage1(item)">{{item.dictCont}}</li>
                            </ul>
                        </el-popover>
                        <el-input v-model="pefEditForm.workVoltage" class="e4y" v-popover:popoverworkVoltage1ed><i slot="suffix">v</i></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td width="170">光源类型:<span style="color:red">*</span></td>
                        <td width="210">
                            <el-input v-model="pefEditForm.lightType" class="e4y"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td width="170">控制协议:<span style="color:red">*</span></td>
                        <td width="210">
                            <el-popover ref="popovercontrolProtocol1ed" placement="bottom" width="124" trigger="focus" popper-class="xiala dianya">
                                <ul class="ulsse">
                                    <li v-for="item in controlProtocol1List" @click="setcontrolProtocol1(item)">{{item.dictCont}}</li>
                                </ul>
                            </el-popover>
                            <el-input v-model="pefEditForm.controlProtocol" slot="reference" v-popover:popovercontrolProtocol1ed></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td width="170">灯参文件:</td>
                        <td width="210">
                            <el-input style="display:none" v-model="pefEditForm.pdfPath" class="e4y"></el-input>
                            <el-upload
                                    class="upload-demo"
                                    ref="upload1"
                                    :action="uploadUrl"
                                    :headers ="headers"
                                    :on-success="LampParamUploadSuccess1"
                                    :before-upload="LampParamUploadBefore"
                                    :file-list="fileList">
                                    <el-button type="primary">重新上传</el-button>
                            </el-upload>
                        </td>
                    </tr>
                </table>
                <el-form-item>
                     <el-button type="primary" @click="showPDFEditViewDiag = false" >取消</el-button>
                    <el-button type="primary" @click="editPdfParamBtn()" >确定</el-button>
                </el-form-item>
             </el-form>
        </el-dialog>
        <!-- 变更灯参制作人 -->
        <el-dialog
            class="tableAddproducts tableDiff"
            title="变更灯参制作人"
            width="600"
            :visible.sync="changeProducer"
            v-dialogDrag>
                   <el-form ref="form" label-width="125px">
                    <el-form-item label="当前灯参制作人：">
                        <span v-for="item in currentCreateUsers" style="padding-right:10px">{{item}}</span>
                    </el-form-item>
                    <el-form-item label="指定灯参制作人：">
                        <el-select v-model="thisLampPeople">
                            <el-option label="请选择" value=""></el-option>
                            <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="changeProducer = false">取 消</el-button>
                        <el-button type="primary" @click="changePeople()" >变 更</el-button>
                    </el-form-item>
                  </el-form>       
           
        </el-dialog>
    </div>
</template>

<script>
import parameterLampDetail from '@/views/component/parameterLampDetail.vue'
import parameterLampDetailPdf from '@/views/component/parameterLampDetailPdf.vue'
import { Loading } from 'element-ui';
import $ from 'jquery';

import Sortable from 'sortablejs'
import { setTimeout } from 'timers';
import { Message } from "element-ui"
export default {
    data(){
        return{
            lowName:'低',
            lowNameDesc:'10~20 cd/m²',
            middleName:'中',
            middleNameDesc:'20~40 cd/m²',
            highName:'高',
            highNameDesc:'40~60 cd/m²',
            contestDescMap : new Map([
                ['洗墙',{lowNameDesc:'＜20 cd/m²',middleNameDesc:'20~40 cd/m²',highNameDesc:'40~60 cd/m²',rgb_lowNameDesc:'＜20 cd/m²',middleNameDesc:'20~40 cd/m²',highNameDesc:'40~60 cd/m²'}],
                ['自发光线',{lowNameDesc:'2000~4000',middleNameDesc:'4000~8000',highNameDesc:'＞8000',rgb_lowNameDesc:'＜2000',rgb_middleNameDesc:'2000~4000',rgb_highNameDesc:'＞4000'}],
                ['立柱',{lowNameDesc:'＜20 cd/m²',middleNameDesc:'20~40 cd/m²',highNameDesc:'40~60 cd/m²',rgb_lowNameDesc:'＜20 cd/m²',middleNameDesc:'20~40 cd/m²',highNameDesc:'40~60 cd/m²'}],
                ['正投',{lowNameDesc:'＜20 cd/m²',middleNameDesc:'20~40 cd/m²',highNameDesc:'40~60 cd/m²',rgb_lowNameDesc:'＜20 cd/m²',middleNameDesc:'20~40 cd/m²',highNameDesc:'40~60 cd/m²'}],
                ['瓦楞',{lowNameDesc:'＜20 cd/m²',middleNameDesc:'20~40 cd/m²',highNameDesc:'40~60 cd/m²',rgb_lowNameDesc:'＜20 cd/m²',middleNameDesc:'20~40 cd/m²',highNameDesc:'40~60 cd/m²'}],
                ['显示照明',{rgb_lowNameDesc:'夜晚观看 ≤2000cd/m²',highNameDesc:'白天观看≥6500cd/m²'}],
                ['复合面',{lowNameDesc:'A面＜20 cd/m²',middleNameDesc:'A面20~40 cd/m²',highNameDesc:'A面40~60 cd/m²',rgb_lowNameDesc:'A面＜20 cd/m²',middleNameDesc:'A面20~40 cd/m²',highNameDesc:'A面40~60 cd/m²'}],
                ['窗框',{lowNameDesc:'A面＜20 cd/m²',middleNameDesc:'A面20~40 cd/m²',highNameDesc:'A面40~60 cd/m²',rgb_lowNameDesc:'A面＜20 cd/m²',middleNameDesc:'A面20~40 cd/m²',highNameDesc:'A面40~60 cd/m²'}],


            ]),

            embedHhtml: '', //pdf内容
            tableHeightCss: {
                'height': window.innerHeight-470+'px',
                'overflow': 'auto',
            },
            //tableHeightss:window.innerHeight-215,
          // 推荐灯参隐藏横向滚动条
          scrollHideFlag: false,
          // 左侧是否选择全部
          allLeft:false,
          // 筛选项查询数据
          recoSearchJson:{
            lampparamNoLike:'',
            lampType:'',
            lampPowerMax:'',
            lampPowerMin:''
          },
          // 筛选项数据
          selectcontestList:{
            h:'',
            w:'',
            d:''
          },
          // 字母项JSON
            letterItemJson:'',
            // 推荐灯参图片
            recoImgArr:[],
            recoFormInline:{
              H: '',
              W: '',
              D: '',
              type:'',
              num:'',
              power1:'',
              power2:''
            },  
            recoForm:{
              region: ''
            },
            sortFlag:true, //排序列表展示哪一个
            sortText:"自定义排序",
            historyModifyCount:0,
            historyModifyPage:1,
            gdPage:1,
            gdTotalCount:0,
            changeProducer:false,
            organizationsList:[],
            searchItemName:'',
            fuheshuju:false,
            historyContestType:'',
            chayidibiContestType:'',
            historyColorType:1,
            chayiduibiColorType:1,
            addMyProjecthtml3:[
                {
                    name:'项目'
                }
            ],
            addMyProjecthtml4:[
                    {
                        name:'111',
                        name2:'w22'
                    }
            ],
            currentUserCompany:'',
            OnKeyAuditReson:'',
            eds:true,
            loadingInstance: false,
            showPDFEditViewDiag:false,
            sortRule:{prop:null,order:null},
            tabData:'', //table排序前的数据
            gongzuodianyaList:[],
            guangseleixingList:[],
            colorTypeList:[],
            jduhh:'',
            jduhhs:'',
            dataStatusList:[],
            childProjectList:[],
            asc:false,
            parameterTableH:400,
             tableHeight :200,
             tableHeight1:200,
             tableHeight2:200,
             tableHeight3:200,
             tableHeight4:200,
             tableHeight5:200,
             thisLampPeople:'',
             tableHeight6:200,
             tableHeight8:300,
            userOrgCode:'',
            options:[],
            projectConfigureList:[],
            totalPrice:{},
            exportform:{//导出整本灯参
                company:'',
                date:'',
                projectName:'',
                companyText:''
            },
            exportdialog:false,
            xiaoguomiaoshuList:[],
            gongzuodianyaList:[],
            anzhuangfangxiangList:[],
            dengjuyanseList:[],
            biaomianwenduList:[],
            fanghudengjiList:[],
            caijidengticaizhiList:[],
            caijibiaomiancaizhiList:[],
            anzhuangfangshiList:[],
            fujianyaoqiuList:[],
            controlProtocol1List:[],
            controlProtocol2List:[],
            dongtaixiaoguoList:[],
            qitayaoqiuList:[],
            historicalRecord_dialog:false,
            historyModifyList:[],
            tableDiffList:[],
            childFields:[],
             defaultOpenTree:[],
             dataSourceList:[],
            dataSources:false,
            defaultOpenTree:[],
            dataContrast:false,
            formContrast:{
                name:''
            },
            formContrast1:{
                name:''
            },
            tableContrast:[
                {
                name:'测试项目',
                num:'LSW8',
                type:'定标'
            },{
                name:'测试项目',
                num:'LSW8',
                type:'定标'
            },{
                name:'测试项目',
                num:'LSW8',
                type:'定标'
            }],
                tableContrast1:[{
                    name:'LSW8',
                    name1:'',
                    name2:'线型投光灯',
                    name3:'LED',
                    name4:'',
                    name5:'67',
                    name6:'3000',
                    name7:'16.2~52.5',
                    name8:'3.2',
                    name9:'186.52',
                    name10:'0.19',
                    name11:'0',
                    name12:'1005',
                    name13:'75',
                    name14:'145',
                    name15:'',
                    name16:'',
                    name17:'',
                    name18:'',
                    name19:'',
                }
            ],
            sicel:[{
                val:'单色'
            }],
            val:'',
            
            projectRootId:0,
            columnShowHideList1:[
                {
                    label:'应用面类型',
                    value:true
                },
                {
                    label:'H',
                    value:false,
                },
                {
                    label:'W',
                    value:false,
                },
                {
                    label:'W1',
                    value:false,
                },
                {
                    label:'W2',
                    value:false,
                },
                {
                    label:'D',
                    value:false,
                },
                {
                    label:'反射率',
                    value:false
                },
                {
                    label:'效果描述',
                    value:false
                },
            ],
            columnShowHideList2:[
                {
                    label:'灯参编号',
                    value:true,
                },
                {
                    label:'灯具类型',
                    value:true
                },
                {
                    label:'光源类型',
                    value:false
                },
                {
                    label:'光色类型',
                    value:false
                },
                {
                    label:'功率',
                    value:true
                },
                {
                    label:'色温色彩',
                    value:false
                },
                {
                    label:'工作电压',
                    value:false
                },
                {
                    label:'材质',
                    value:false
                },
                {
                    label:'灯具颜色',
                    value:false
                },
                {
                    label:'表面温度',
                    value:false
                },
                {
                    label:'防护等级',
                    value:false
                },
                {
                    label:'重量',
                    value:false
                },
                {
                    label:'灯具长',
                    value:false
                },
                {
                    label:'灯具宽',
                    value:false
                },
                {
                    label:'灯具高',
                    value:false
                },
                {
                    label:'安装方向',
                    value:false
                },
                {
                    label:'安装方式',
                    value:false
                },
                {
                    label:'控制协议',
                    value:true
                },
                {
                    label:'动态效果',
                    value:false
                },
            ],
            columnShowHideList3: 
            [ 
                {
                    label:'区使用次数',
                    value:true
                },
                {
                    label:'单体使用次数',
                    value:true
                },
                {
                    label:'参考价',
                    value:true
                },
                {
                    label:'预估数量',
                    value:true
                },
                {
                    label:'预估小计',
                    value:false,
                },
                {
                    label:'图纸数量',
                    value:true
                },
                {
                    label:'图纸小计',
                    value:false
                },
                {
                    label:'实际数量',
                    value:true
                },
                {
                    label:'实际小计',
                    value:false
                },
                {
                    label:'制作人',
                    value:true
                },
                {
                    label:'灯参状态',
                    value:true
                },
                {
                    label:'版本号',
                    value:true
                },
            ],
            headers: {
                "Authorization": localStorage.getItem('token')
            },
            allProjectList:[],
            gdProjectList:[],
            uploadUrl:'',
            isgdorPending:0, // 是否是归档项目1 或待审核3
            activeClass:false,
            submitAuditForm:{
                flag:'1',
                auditReson:''
            },
            diff:false,
            tableDiff:[],
            fields:{},
            totalCount:0,
            request:{
                page:1,
                rows:20,
                projectId:'',
                lampparamNoLike:'', //灯参编号
                contestType:'', //应用类型id 356
                lampType:'', //灯具类型 id
                contestH:'', //应用面h
                contestW:'', //应用面w
                lumSize:'', //应用面d
                dataStatus:'', // 1暂存 2生成 3已提交 4审核中 5审核完成
                lampPowerMin:'', //功率
                lampPowerMax:'',
                createBy:''//制作人id
            },
            typeList:[],
            lampTypeList:[],
            contestUnionLampTypeList:[],
            lampAllTypeList:[],
            AnglemapList:[],
            mbColorList:[],
            userList:[],
            currentProject:{},
            projectTree:[],
            tableData:[],
            checkboxModel:[],
            histableCheckboxModel:[], //历史记录表选择
            gdcheckboxModel:[],
            addToMyProjectId:'',
            searchChildProject:'',
            show:true,
            index:'0',
            show1:false,
            show2:false,
            show3:false,
            contestTypeList:[],
            currentContestType:{},
            contestList:[],
            ckblampparamId:[],
            otherProjectList:[],
            otherProjectTotalCount:0,
            checkOtherProjectModel:[],
            otherProjectRequest:{
                page:1,
                rows:20,
                projectId:'',
                lampPowerMin:'',
                lampPowerMax:'',
                contestType:'',
                contestH:'',
                lumSize:'',
                contestW:'',
                contestW1:'',
                contestW2:'',
                lampparamNoLike:'',//灯参编号
                lampType:'',
                createBy:'',
                // dataStatus:5,//erp是5
            },
            projectList:[],
            showDetail:false,
            currentDetailInfo:{
                projectLampparamVo:{},
                projectParamindexList:[{
                    brightnessAvgMin:''
                }]
            },
            chooseMyProjectId:'',
            addMyProject:false,
            addMyProject2:false,
            addMyProject3:false,
            chooseAddmyProjectSource:'',
            showAuditRecord:false,
            auditRecordList:[],
            isShowSubmitAudit:false,
            OnKeyAuditFlag:2,
            submitAuditId:0,
            showMorelist:false, 
            isSingle:false,
            userhavePrice:false,
            userhaveCount:false,
            userhaveCountyugu:false,
            printneedZong:false,
            userhaveRole:false,
            userhaveAuditRole:false,//是否拥有审核角色
            userhaveFirstAuditRole:false,//是否拥有初审核角色
            userhaveFinalAuditRole:false,//是否拥有终审人角色
            fileList:[],
            currentCreateUsers:[],
            pefEditForm:{
                angleNoText:'',
                grayDemandText:''
            },
            lampParamUploadForm:[
                {
                    colorType:'',
                    fileName:'',
                    pdfPath:'',
                    projectId:''
                }
            ],
            lampParamUploadFormColorType:{
                dictCont:'请选择光色类型',
                id:''
            },
            showConfrimDialog:false,
            confirmDataTable:[],
            CountDiaglog:false,
            countmenList:[],
            countmenPage:1,
            searchCountlampparamId:'',
            searchCountprojectType:'',
            countmenCount:0,
            auditId:'',
            auditPage:1,
            auditCount:0,
            sortData:[], //排序的数据
            defaultSortLoading:false,//表格的lodaing
            exportType:1//导出按钮类型 1-整本灯参导出 2-总则导出
        }
    },
    components:{
        parameterLampDetail,
        parameterLampDetailPdf
    },

    watch:{
        // screenHeight(val,oldVal){
        //     let num = val - 247;
        //     this.$set(this.sizeList,"--tableHeight",num+'px');
        // }
    },
    
    methods:{
        initLampType(){
            if(this.lampTypeList.length==0) {
                const self = this;
                this.$http.get("/api/lampTypes/json", {}, function (res) {
                    if (res.success) {
                        self.lampTypeList = res.data;
                    }
                })
            }
        },
        initContestType(){
            if(this.typeList.length==0){
                const self = this;
                this.$http.get("/api/dictTypeAllList", {indexPinyin:'yingyongchangjingleixing'}, function(res) {
                    if (res.success) {
                        self.typeList = res.data;
                    }
                });
            }

        },

        // c处理转义字符
        escapeHTML(str) {
            if(str){
                str = str.replace(/&lt;/g, "<");
                str = str.replace(/&gt;/g, ">");
            }
            return str;
        },
        //将历史记录灯参另存在单体
        resetMyDanti(){
            if(this.histableCheckboxModel.length == 0){
                this.$message.error("请至少选择一项")
                return
            }
            let lampparamHisId = this.histableCheckboxModel[0].id;

            var param = {};
            param.lampparamHisId =lampparamHisId;
            param.targetProjectId =  this.request.projectId
            let self = this
            this.$http.post("/api/lampparams/copyHisLamparam",param,(res)=>{
                if(res.code == '0000'){
                    //that.search(that.request.page)
                    self.historicalRecord_dialog = false
                    self.search(1)
                    self.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                }else{
                    self.$message.error(res.message);

                }

            })


        },

      //关闭推荐灯参弹窗
      closeReco(){
        for(let key in this.recoSearchJson){
          this.recoSearchJson[key] = ''
          if(this.selectcontestList[key.toLowerCase()]){
            // 清除子母项
            this.selectcontestList[key.toLowerCase()] = '';
          }
        }
        this.reset();
      },
      // 子母项发生变化
      changeLetterValue(key){
        
        this.recoSearchJson[key] = this.selectcontestList[key]
      },
      // 筛选项灯具类型变化
      recoLampType(type){
        this.recoSearchJson.lampType = type;
      },
      // 通过筛选项查询推荐灯参
      searchReco(){
        this.getContestList(this.recoSearchJson)
      },
      // 推荐灯参应用类型变更
      changeReco(data){
        var json = {};
        if(!data){
          // 左侧选择全部
          this.allLeft = true;
          this.contestList = [];
          return this.recoImgArr = this.contestTypeList
        }else{
            this.allLeft = false;
            this.recoImgArr = this.contestTypeList.filter((item,index)=>{
              if(item.contestTypeId == data){
                // 请求右侧数据
                this.chooseContestType(item)
                item.sketchAttr = JSON.parse(JSON.stringify(item.sketchAttr))
                return item
              }
            })
        }
        if(!this.recoImgArr.length){
          // 左侧无示意图
          this.allLeft = true;
        }
        for(let key in this.letterItemJson){
          // 子母项清空数据
          this.selectcontestList[key.toLowerCase()] = '';
        }
        for(let key in this.recoSearchJson){
          // 其他项清空数据
          this.recoSearchJson[key] = '';
        }
        // 灯具类型恢复全部状态
        this.request.lampType = '';
       
      },
        //点击默认排序按钮
        // 没用的注释
        defaultSort(){
          var that =this;
            this.defaultSortLoading = true;
            setTimeout(()=>{
                this.$http.get("/api/lampparams/setDefaultSorts/"+this.request.projectId,{},(res)=>{
                    if(res.code == '0000'){
                        that.search(that.request.page)
                        setTimeout(()=>{
                            that.defaultSortLoading = false;
                            that.$message({
                            message: '排序成功',
                            type: 'success'
                        });
                        },3000)
                    }else{
                        that.defaultSortLoading = false;
                        that.$message.error(res.message);

                    }

                })
            },300)
            
        },
        //点击排序按钮
        sort(){
            if(this.sortFlag){
               this.sortText ="完成排序";
               this.sortFlag = false;
            }else{
                this.sortText ="自定义排序";
                this.sortFlag = true;
                
            }
        },
        // 拖拽排序函数
        rowDrop() {
            let url = '/api/lampparams/setCustSorts';
            let self = this;
            const tbody = document.querySelector('#sortList .el-table__body-wrapper tbody')
            Sortable.create(tbody,{
            onEnd({ newIndex, oldIndex }) {
                    let newData = self.sortData.splice(oldIndex,1);
                    let newObj = {
                        id: newData[0].id,
                        sorts: ''
                    }
                    self.sortData.splice(newIndex,0,newObj);
                     for(var i = 0;i<self.sortData.length;i++){
                         self.sortData[i].sorts = (self.request.page - 1)*20+ i + 1;
                    };
                     self.$http.postObj(url,self.sortData,(res)=>{
                         if(res.code == '0000'){
                             self.search(self.request.page)
                             self.$message({
                                message: '排序成功',
                                type: 'success'
                            });
                        }else{
                            self.$message.error(res.message);
                        }
                     })
                }
               
            });
        },
        changePeople(){
            if(this.thisLampPeople == ''){
                this.$message.error("请指定灯参制作人")
                return
            }
            
            var ids = ''
            for(var i = 0;i<this.checkboxModel.length;i++){
                ids += this.checkboxModel[i].lampparamId + ','
            }
            ids = ids.substring(0,ids.length-1)

            let self = this
            this.$http.postQuery('/api/lampparams/producer/batchChange',{lampparamIds:ids,targetUserId:this.thisLampPeople},function(res){
                if(res.success){
                    self.changeProducer = false
                    self.search()
                    self.$message({
                        message: "变更成功！",
                        type: "success"
                    })
                }else{
                    self.$message.error(res.data)
                }
            })
            
        },
        changeMan(){
            this.thisLampPeople == ''
            if(this.checkboxModel.length == 0){
                this.$message.error("请至少选择一项")
                return
            }
            this.currentCreateUsers = [];
            for(var i =0;i<this.checkboxModel.length;i++){
                if (this.currentCreateUsers.indexOf(this.checkboxModel[i].createName) == -1){ 
                this.currentCreateUsers.push(this.checkboxModel[i].createName)
                }
            }
            if(this.currentCreateUsers.length > 1){
                this.$confirm('您选的灯参由多个灯参制作人制作，是否同时变更？','提示',{
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    this.changeProducer = true
                }).catch(()=>{});
            }else{
                    this.changeProducer = true
            }
        },
        orderScroll(e){
            let _this = this
            let read = _this.$el.querySelector('#read')
        },
        setDetailInfo(data){
            this.currentDetailInfo = data
        },
        fuhepinpai(){
            //var targetProjectId = this.$route.query.id //this.request.projectId

            //修改为可选择区或者单体
            var targetProjectId = this.request.projectId;
           let routeUrl = this.$router.resolve({
                path: "/conformBrand?id="+targetProjectId
            });
            window.open(routeUrl.href, '_blank');
        },
        changeValue: function () {
                    const self = this;
                    var text = this.$refs.inputBox.value;
 
                    //遍历修改对应文本值
                    this.options.forEach(function (item, index) {
                        if (item.value === self.selectValue) {
                            item.text = text;
                        }
                    });
 
                },
        closeShowHideDivSetCookie(){
            var jsonparamshowhideList1 = JSON.stringify(this.columnShowHideList1);
            var jsonparamshowhideList2 = JSON.stringify(this.columnShowHideList2);
            var jsonparamshowhideList3 = JSON.stringify(this.columnShowHideList3);
            localStorage.setItem("paramshowhideList1",jsonparamshowhideList1)
            localStorage.setItem("paramshowhideList2",jsonparamshowhideList2)
            localStorage.setItem("paramshowhideList3",jsonparamshowhideList3)
        },
        onKeyAudit(flag){
            var allowAudit =true;
            if(this.checkboxModel.length == 0){
                this.$message.error("请至少选择一项")
                return
            }

            for(var i =0;i<this.checkboxModel.length;i++){
                var id = this.checkboxModel[i].lampparamId
                var status = this.checkboxModel[i].projectLampparamVo.dataStatus
                if(status == 1 || status  == 2){
                    this.$message.error("暂存状态和生成状态的灯参不能审核")
                    return
                }

                //验证是否具有审核权限
                let self = this
                this.$http.get("/api/lampparams/validateAuditTask/"+id, {}, function(res) {
                    if (res.success) {
                        var isAuditTask = res.data;
                        if(isAuditTask==false){
                            allowAudit = false;
                           return
                        }
                    }
                });
            }

            if(allowAudit){
                this.OnKeyAuditReson = ''
                this.OnKeyAuditFlag = flag
                this.isShowSubmitAudit = true
            }else{
                this.$message.error("无审核权限！")
                return
            }

        },
        EditFormPdfGrayDemandText(item){
            // this.$nextTick(function () {
                // this.pefEditForm.grayDemand = item.id
                // this.pefEditForm.grayDemandText = item.dictCont
                this.$set(this.pefEditForm,'grayDemandText',item.dictCont)
                this.$set(this.pefEditForm,'grayDemand',item.id)
            // })
        },
        rowgrayDemandChange(v){
            this.confirmDataTable[v.index].grayDemand = v.item.id
            this.confirmDataTable[v.index].grayDemandText = v.item.dictCont
            this.$set(this.confirmDataTable,v.index,this.confirmDataTable[v.index])
        },
        composeValue(item,index){
            return {
            'item': item,
            'index': index
            }
        },
        ChangelampParamUploadFormColorType(item){
            this.lampParamUploadFormColorType = item
        },
        refreshdetail(){

                this.checkOtherProjectModel = []
                this.getOtherProject(1)
                this.search(1)
        },
        show3Upload(){
            this.show3 = true
            this.fileList = []
            this.lampParamUploadForm=[
                {
                    colorType:'',
                    fileName:'',
                    pdfPath:'',
                    projectId:''
                }
            ]
            this.lampParamUploadFormColorType={
                dictCont:'请选择光色类型',
                id:''
            }
            if(this.$refs.upload){
                this.$refs.upload.clearFiles()
            }
        },
        show_list(){
            this.showMorelist = true
            },
        sortChange(item){
            //如果不排序了，就恢复到最初的状态
            if(item.order == null){
                this.tableData = this.tabData;
            }else{
                var val = item.prop.replace('projectLampparamVo.','')
                if(val == "contestTypeString"){
                    val = "contestType"
                }else if(val == "versionStr"){
                    val = "version"
                }else if(val == "lumSizeMin"){
                    val = "lumSize"
                }
                this.request.sort = val
                this.request.order = (item.order == 'ascending'? 'asc' : 'desc')
                this.search(1)
                // if(colmun.prop == 'projectLampparamVo.lampPower'){
                //     var data = []
                //     for(let i = 0;i< this.tableData.length;i++){
                //         //如果是空的push在数字后面，有值就放前面，然后把排好的数组在赋值给表格data
                //         if(this.tableData[i].projectLampparamVo.lampPower == null){
                //             data.push(this.tableData[i]);
                //         }else{
                //             data.unshift(this.tableData[i]);
                //         }
                //     }
                //     this.tableData = data
                // }else if(colmun.prop == 'projectLampparamVo.unitPrice'){
                //     var data = []
                //     for(let i = 0;i< this.tableData.length;i++){
                //         //如果是空的push在数字后面，有值就放前面，然后把排好的数组在赋值给表格data
                //         if(this.tableData[i].projectLampparamVo.unitPrice == null){
                //             data.push(this.tableData[i]);
                //         }else{
                //             data.unshift(this.tableData[i]);
                //         }
                //     }
                //     this.tableData = data
                // }
            }
            
            this.sortRule.order = item.order;
            this.sortRule.prop = item.prop;
        },
        showCountDiaglog(lampparamId,projectType){
            this.searchCountlampparamId = lampparamId;
            this.searchCountprojectType = projectType;
            this.searchCountList(1)
            this.CountDiaglog = true
        },
        searchCountList(page){
            let self = this
            this.countmenPage = page
            this.$http.postObj('/api/lampparams/useRecordJson',{page:this.countmenPage,rows:10,lampparamId:this.searchCountlampparamId,projectType:this.searchCountprojectType},function(res){
                self.countmenList = res.data.rows
                self.countmenCount = res.data.total
            })
        },
        showPdf(url){
            window.open(this.ImgPath + url)
        },
        rowKeys(row){
            return row.lampparamId;
        },
        setConfirmDiagLogPopover(name,item,index){
            name.lampTypeStr = item.dictCont
            name.lampType = item.id
            this.$set(this.confirmDataTable,index,name)
            this.$refs['popoverlampTypeStr'+index].doClose()
        },
        setConfirmDiagLogPopover1(item){
            this.pefEditForm.lampTypeStr = item.dictCont
            this.pefEditForm.lampType = item.id
            this.$refs.popoverlampTypeStr1ed.doClose()
        },
        setAngleNo(name,item,index){
            name.angleNoText = item.ruleKey
            name.angleNo = item.ruleNo
            this.$set(this.confirmDataTable,index,name)
            this.$refs['popoverAnglemapList'+index].doClose()
        },
        setAngleNo1(item){
            this.pefEditForm.angleNo = item.ruleNo
            this.pefEditForm.angleNoText = item.ruleKey
            this.$refs.popoverAnglemapList1ed.doClose()
        },
        setcolorTemperatureStr(name,item,index){
            name.colorTemperatureStr = item.dictCont
            this.$refs['popovercolorTemperatureStr'+index].doClose()
        },
        setcolorTemperatureStr1(item){
            this.pefEditForm.colorTemperatureStr = item.dictCont
            this.$refs.popovercolorTemperatureStr1ed.doClose()
        },
        checkPower(power,index){
            if(power != null && power != "" && !isNaN(power)){
                power = parseFloat(power).toFixed(1)
                var last = power.toString().substr(power.indexOf('.')+1,power.length)
                if(last == "0"){
                    power = parseInt(power)
                }
            }else{
                power = ''
            }
            this.confirmDataTable[index].lampPower = power
            this.$set(this.confirmDataTable,index,this.confirmDataTable[index])
        },
        checkInteger(voltage,index){
            if(voltage != null && voltage != "" && !isNaN(voltage)){
                voltage = parseInt(voltage)
            }else{
                voltage = ''
            }
            this.confirmDataTable[index].workVoltage = power
            this.$set(this.confirmDataTable,index,this.confirmDataTable[index])
        },
        setworkVoltage(name,item,index){
            name.workVoltage = item.dictCont
            this.$set(this.confirmDataTable,index,name)
            this.$refs['popoverworkVoltage'+index].doClose()
        },
        setcontrolProtocol(name,item,index){
            name.controlProtocol = item.dictCont
            this.$refs['popovercontrolProtocol'+index].doClose()
            this.$set(this.confirmDataTable,index,name)
        },
        setcontrolProtocol1(item){
            this.pefEditForm.controlProtocol = item.dictCont
            this.$refs.popovercontrolProtocol1ed.doClose()
        },
        setworkVoltage1(item){
            this.pefEditForm.workVoltage = item.dictCont
            this.$refs.popoverworkVoltage1ed.doClose()
        },
        setx(ojp){
           this.jduhh = ojp
        },
        handleSizeChange(pageSize){
            this.otherProjectRequest.rows = pageSize
            this.getOtherProject(1)
        },
        handleCurrentChange(page) {
            this.getOtherProject(page)
        },
        handleCurrentChangeCount(page){
            this.searchCountList(page)
        },
        handleCurrentChangeAudit(page){
            this.searchAuditList(page)
        },
        handleCurrentChangeHistory(page){
            this.searchHistoryList(page)
        },
        handleSizeChangeAll(pageSize){
            this.request.rows = pageSize
            this.search(1)
        },
        handleCurrentChangeAll(page) {
            this.search(page)
        },
        handleCurrentChangegd(page){
            this.searchgdProject(page)
        },
        reset(){
            this.dataStatusList = []
            this.request.lampparamNoLike='' //灯参编号
            this.request.contestType='' //应用类型id 356
            this.request.lampType='' //灯具类型 id
            this.request.contestH='' //应用面h
            this.request.contestW='' //应用面w
            this.request.lumSize='' //应用面d
            this.request.dataStatus='' // 1暂存 2生成 3已提交 4审核中 5审核完成
            this.request.lampPowerMin='' //功率
            this.request.lampPowerMax=''
            this.request.createBy=''//制作人id
        },
        setCompany(name,val,item){
            this.exportform.companyText = name
            this.exportform.company = val
            item.paramValue = val
            this.$refs.popover21[0].doClose()
        },
        exportBigTable(){
            let self = this

            var targetProjectId = this.request.projectId;
            var exportFileds = [];
            $.each(this.columnShowHideList1,function(i,e){
                if(!e.value){
                    exportFileds.push(e.label);
                }
            });
            $.each(this.columnShowHideList2,function(i,e){
                if(!e.value){
                    exportFileds.push(e.label);
                }
            });
            $.each(this.columnShowHideList3,function(i,e){
                if(!e.value){
                    exportFileds.push(e.label);
                }
            });
             exportFileds = exportFileds.join(',');

            var ids = ''
            for(var i = 0;i<this.checkboxModel.length;i++){
                ids += this.checkboxModel[i].lampparamId + ','
                var status = this.checkboxModel[i].projectLampparamVo.dataStatus
                if(status == 1 ){
                    this.$message.error("请选择非暂存状态的灯参")
                    return
                }
                var monomersCount = this.checkboxModel[i].projectLampparamVo.monomersCount;
                if(monomersCount == 0 ){
                    this.$message.error("【"+this.checkboxModel[i].projectLampparamVo.lampparamNo+"】单体使用次数为0，请将灯参应用于单体在操作！")
                    return
                }
            }
            ids = ids.substring(0,ids.length-1)
            this.$http.postObj('/api/lampparams/exportExcel',{projectId:targetProjectId,dataStatus:'2,3,4,5',notZero:true,taskNames:exportFileds,idStr:ids},function(res){

                self.downloadFile(res.data.fileName) //self.ImgPath + "/" +
            })
        },
       //导出灯参用量明细表
        exportNumTable(){
            let self = this
            var targetProjectId = this.request.projectId;
            // var exportFiledArr = ['灯参编号','灯具类型','色温色彩','功率','工作电压','控制'];
            // var exportFileds = exportFileds.join(',');

            var ids = ''
            for(var i = 0;i<this.checkboxModel.length;i++){
                ids += this.checkboxModel[i].lampparamId + ','
                var status = this.checkboxModel[i].projectLampparamVo.dataStatus
                if(status == 1 ){
                    this.$message.error("请选择非暂存状态的灯参")
                    return
                }
                var monomersCount = this.checkboxModel[i].projectLampparamVo.monomersCount;
                if(monomersCount == 0 ){
                    this.$message.error("【"+this.checkboxModel[i].projectLampparamVo.lampparamNo+"】单体使用次数为0，请将灯参应用于单体在操作！")
                    return
                }
            }
            ids = ids.substring(0,ids.length-1)

            this.$http.postObj('/api/lampparams/exportNumExcel',{projectId:targetProjectId,dataStatus:'2,3,4,5',notZero:true,idStr:ids},function(res){

                self.downloadFile(res.data.fileName) //self.ImgPath + "/" +
            })
        },
        exportFullWordZip(){
            var targetProjectId = this.request.projectId
            let self = this
            var ids = ''
            for(var i = 0;i<this.checkboxModel.length;i++){
                ids += this.checkboxModel[i].lampparamId + ','
                var status = this.checkboxModel[i].projectLampparamVo.dataStatus
                if(status == 1 ){
                    this.$message.error("请选择非暂存状态的灯参")
                    return
                }
                var monomersCount = this.checkboxModel[i].projectLampparamVo.monomersCount;
                if(monomersCount == 0 ){
                    this.$message.error("【"+this.checkboxModel[i].projectLampparamVo.lampparamNo+"】单体使用次数为0，请将灯参应用于单体在操作！")
                    return
                }
            }
            ids = ids.substring(0,ids.length-1)
            this.$http.postQuery('/api/lampparams/generateLampparamsWholeZip/'+targetProjectId,{idStr:ids},function(res){
                if(res.code == "0000"){
                    self.downloadFile(res.data.fileName)
                }else{
                    self.$message.error(res.message)
                }
                //self.ImgPath + "/" +
            })
        },
        //导出总则
        exportRulePdf(){
            var targetProjectId = this.request.projectId
            let self = this
            this.$http.postQuery('/api/lampparams/generateProjectRule/'+targetProjectId,{},function(res){
                if(res.code == "0000"){
                    self.downloadFile(res.data.fileName)
                }else{
                    self.$message.error(res.message)
                }
                //self.ImgPath + "/" +
            })
        },
        //导出编辑总则
        exportEditRule(){
            var options = []
            let self = this
            var targetProjectId = this.request.projectId
            this.$http.postObj('/api/projectConfigures/json/'+targetProjectId,{},function(res){
                if(res.success){
                    self.projectConfigureList = res.data
                    for(var i = 0;i<self.projectConfigureList.length;i++){
                        var code = self.projectConfigureList[i].paramCode
                        var name = self.projectConfigureList[i].paramName
                        var paramType = self.projectConfigureList[i].paramType
                        if(name == '项目名称'){
                            self.projectConfigureList[i].paramValue = self.currentProject.itemName
                        }
                        if(name == "所属公司"){
                            for(var a = 0;a<self.organizationsList.length;a++){
                                if(self.organizationsList[a].orgCode == self.projectConfigureList[i].paramValue){
                                    self.exportform.companyText = self.organizationsList[a].orgName
                                    self.exportform.company = self.organizationsList[a].orgCode
                                }
                            }
                        }

                        self.$http.getSync('/api/dictTypeAllList',{indexPinyin:code},function(res){
                            options.push(res.data)
                        })
                    }
                    self.options = options
                    self.exportdialog=true
                    self.exportType =2
                }else{
                    self.$message.error(res.data)
                }
            })
        },
        exportRule(){
            var targetProjectId = this.request.projectId
            let self = this
            this.$http.postQuery('/api/lampparams/generateProjectRule/'+targetProjectId,{},function(res){
                if(res.code == "0000"){
                    self.downloadFile(res.data.fileName)
                }else{
                    self.$message.error(res.message)
                }
            })
        },
        //发送盖章
        sendSeal(){
            let self = this
            this.$confirm('为减少整本灯参不一致，请确认灯参最终版在发送盖章?','提示',{
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                var targetProjectId = this.request.projectId
                this.$http.get('/api/lampparams/sendSeal/'+targetProjectId,{},function(res){
                    if(res.success){
                        self.$message({
                            message: "发送成功！",
                            type: "success"
                        });
                    }else{
                        self.$message.error(res.data)
                    }
                })
            }).catch(()=>{});
        },
        downloadFile(url){
            window.open(this.ImgPath + url)
        },
        HTMLDecode(text) { 
            var temp = document.createElement("div"); 
            temp.innerHTML = text; 
            var output = temp.innerText || temp.textContent; 
            temp = null; 
            return output; 
        },
        setProjectConfigure(item,value,index){
            //如果为项目总则是否导出
            if(item.paramCode == 'xiangmuzongzeshifoudaochu'){
                 if(value=='否'){ //如果不导出总则是设置总则是否包含命名规则项为否
                         for(var i = 0;i<this.projectConfigureList.length;i++){
                             var obj = this.projectConfigureList[i];
                            var code = obj.paramCode;
                            if(code=='zongzeshifoubaohanmingmingguize'){ //
                                obj.paramValue ='否'
                                obj.paramType='0'
                                obj.disabled=true
                                this.$set(this.projectConfigureList,i,obj);
                                break;
                            }
                         }

                 }else{
                     for(var i = 0;i<this.projectConfigureList.length;i++){
                         var obj = this.projectConfigureList[i];
                         var code = obj.paramCode;
                         if(code=='zongzeshifoubaohanmingmingguize'){
                             obj.disabled=false
                             this.$set(this.projectConfigureList,i,obj);
                             break;
                         }
                     }
                 }
             }
             item.paramValue = this.HTMLDecode(value)
             this.$set(this.projectConfigureList,index,item);
             for(var i = 0;i<this.$refs.popoverlist.length;i++){
                 this.$refs.popoverlist[i].doClose()
             }
        },
        editZongZe(){
            let self = this
            var tempList = [];
            for(var i = 0;i<this.projectConfigureList.length;i++){
                var item = this.projectConfigureList[i]
                tempList.push({
                    id:item.id,
                    paramCode:item.paramCode,
                    paramDesc:item.paramDesc,
                    paramName:item.paramName,
                    paramValue:item.paramValue,
                    projectId:item.projectId
                })
            }
            // tempList.push({
            //     paramCode:"xiangmumingcheng",
            //     paramName:"项目名称",
            //     paramValue:this.exportform.projectName,
            // })
            // tempList.push({
            //     paramCode:"fengmianshijian",
            //     paramName:"生成时间",
            //     paramValue:this.exportform.date,
            // })
            // tempList.push({
            //     paramCode:"suoshugongsi",
            //     paramName:"所属公司",
            //     paramValue:this.exportform.company,
            // })

            var targetProjectId = this.request.projectId
            this.$http.postObj('/api/projectConfigures/edit/'+targetProjectId,tempList,function(res){
                if(res.success){
                    // self.$message({
                    //     message: "操作成功！",
                    //     type: "success"
                    // });
                    self.exportdialog=false
                    //延迟执行
                    this.timer = setTimeout(() => {
                        if(self.exportType==1){
                            self.exportFullExcelNow()
                        }
                        if(self.exportType==2){ //总则导出
                            self.exportRule()
                        }

                    }, 500)

                }else{
                    self.$message.error(res.data)
                }
            })
        },
        exportFullExcelNow(){
            this.loadingInstance = Loading.service({ text: '正在导出，请稍后...' })
            //this.loadingInstance = Loading.service({fullscreen: true });
            //this.loadingInstance = Loading.service({fullscreen: true });
            var targetProjectId = this.request.projectId
            var tempList = [];
            for(var i = 0;i<this.projectConfigureList.length;i++){
                var item = this.projectConfigureList[i]
                tempList.push({
                    id:item.id,
                    paramCode:item.paramCode,
                    paramDesc:item.paramDesc,
                    paramName:item.paramName,
                    paramValue:item.paramValue,
                    projectId:item.projectId
                })
            }
            let self = this

            var ids = ''
            for(var i = 0;i<this.checkboxModel.length;i++){
                ids += this.checkboxModel[i].lampparamId + ','
                var status = this.checkboxModel[i].projectLampparamVo.dataStatus
                if(status == 1 ){
                    this.$message.error("请选择非暂存状态的灯参")
                    return
                }
                var monomersCount = this.checkboxModel[i].projectLampparamVo.monomersCount;
                if(monomersCount == 0 ){
                    this.$message.error("【"+this.checkboxModel[i].projectLampparamVo.lampparamNo+"】单体使用次数为0，请将灯参应用于单体在操作！")
                    return
                }
            }
            ids = ids.substring(0,ids.length-1)

            this.$http.postObj('/api/lampparams/generateWholePdf/'+targetProjectId+'?idStr='+ids,tempList,function(res){
                if(res.code == "0000"){
                    self.downloadFile(res.data.fileName) //self.ImgPath + "/" + 
                }else{
                    self.$message.error(res.message)
                }
                self.loadingInstance.close()
            })
        },
        exportFullPdf(){
            var options = []
            let self = this
            var targetProjectId = this.request.projectId

            for(var i = 0;i<self.checkboxModel.length;i++){
                var status = self.checkboxModel[i].projectLampparamVo.dataStatus
                if(status == 1 ){
                    self.$message.error("请选择非暂存状态的灯参")
                    return
                }
                var monomersCount = self.checkboxModel[i].projectLampparamVo.monomersCount;
                if(monomersCount == 0 ){
                    self.$message.error("【"+self.checkboxModel[i].projectLampparamVo.lampparamNo+"】单体使用次数为0，请将灯参应用于单体在操作！")
                    return
                }
            }

            this.$http.postObj('/api/projectConfigures/json/'+targetProjectId,{},function(res){
                if(res.success){
                    self.projectConfigureList = res.data
                    for(var i = 0;i<self.projectConfigureList.length;i++){
                        var code = self.projectConfigureList[i].paramCode
                        var name = self.projectConfigureList[i].paramName
                        var paramType = self.projectConfigureList[i].paramType
                        if(name == '项目名称'){
                            if(self.projectConfigureList[i].paramValue==""){
                                self.projectConfigureList[i].paramValue = self.currentProject.itemName
                            }

                        }
                        if(name == "所属公司"){
                                for(var a = 0;a<self.organizationsList.length;a++){
                                    if(self.organizationsList[a].orgCode == self.projectConfigureList[i].paramValue){
                                        self.exportform.companyText = self.organizationsList[a].orgName
                                        self.exportform.company = self.organizationsList[a].orgCode
                                    }
                                }
                        }

                        self.$http.getSync('/api/dictTypeAllList',{indexPinyin:code},function(res){
                            options.push(res.data)
                        })
                    }
                    self.options = options
                    self.exportdialog=true
                }else{
                    self.$message.error(res.data)
                }
            })
        },
        submitUpload() {
            if(this.lampParamUploadFormColorType.id == null || this.lampParamUploadFormColorType.id == ''){
                this.$message.error('请选择颜色类型!')
                return
            }

            this.$refs.upload.submit();
        },
        LampParamUploadChange(file,fileList){
            var a = 0
            fileList.forEach((item, idx) => {
                if (file.name === item.name) {
                a++
                if (a === 2) {
                    this.$message({
                    message: '此文件已存在',
                    type: 'info'
                    })
                    fileList.splice(idx, 1)
                }
                }
            })
        },
        LampParamUploadBefore(file){
            if(file == null){
                this.$message.error("请选择文件")
                return false
            }
            return true
        },
        LampParamUploadSuccess(res, file){
            if(res.success){
                this.fileList.push(res.data)
                var colorFlag = 1
                if(this.lampParamUploadFormColorType.dictExtra > 1){
                    colorFlag = 2
                }
                var temp = []
                for(var i =0;i<this.fileList.length;i++){
                    temp.push({
                        grayDemand:this.lampParamUploadFormColorType.id,
                        colorType:colorFlag,
                        projectId:this.request.projectId,
                        pdfPath:this.fileList[i].savePath,
                        fileName:this.fileList[i].originalFileName
                    })
                }
                this.lampParamUploadForm = temp
                let self = this
                self.confirmDataTable = []
                this.$http.postObj('/api/batchUploadPdf',this.lampParamUploadForm,function(res){
                    if(res.success){
                        self.showConfrimDialog = true
                        for(var i = 0;i<res.data.rows.length;i++){
                            self.confirmDataTable.push(res.data.rows[i])
                        }
                        for(var i = 0;i<self.confirmDataTable.length;i++){
                            for(var j = 0;j<self.guangseleixingList.length;j++){
                                if(self.confirmDataTable[i].grayDemand == self.guangseleixingList[j].id){
                                    self.confirmDataTable[i].grayDemandText = self.guangseleixingList[j].dictCont
                                }
                            }
                            
                        }
                        self.show3 = false
                    }else{
                        self.$message.error(res.data)
                    }
                })
            }
        },
        handleRemove(file, fileList) {
            var tempList = []
            for(var i = 0;i<fileList.length;i++){
                tempList.push(fileList[i].response.data)
            }
            this.fileList = tempList
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        LampParamUploadSuccess1(res, file){
            if(res.success){
                this.pefEditForm.pdfPath = res.data.savePath
                this.$message({
                    type:'success',
                    message:'文件上传成功!'
                })
            }
        },
        editPdfParamBtn(){
            var row = this.pefEditForm;
                if(row.grayDemand == ''){
                    //光色类型必填
                    this.$message.error('光色类型必填！')
                    return false
                }
                if(row.lampTypeStr == ''){
                    //灯具类型必填
                    this.$message.error('灯具类型必填!')
                    return false
                }
                if(row.lampPower == '' || row.lampPower == 'undefined' || typeof row.lampPower == typeof undefined){
                    //功率必填
                    this.$message.error('灯具功率必填!')
                    return false
                }
                if(row.colorTemperatureStr == ''){
                    //色温色彩必填
                    this.$message.error('色温色彩必填!')
                    return false
                }
                if(row.workVoltage == ''  || row.workVoltage == 'undefined' || typeof row.workVoltage == typeof null){
                    //工作电压必填
                    this.$message.error('工作电压必填!')
                    return false
                }
                if(row.lightType == ''  || row.lightType == 'undefined' || typeof row.lightType == typeof null){
                    //光源类型必填
                    this.$message.error('光源类型必填!')
                    return false
                }
                if(row.controlProtocol == ''  || row.controlProtocol == 'undefined' || typeof row.controlProtocol == typeof null){
                    //控制协议必填
                    this.$message.error('控制协议必填!')
                    return false
                }

            var temp = []
            temp.push({
                grayDemand:this.pefEditForm.grayDemand,
                lampType:this.pefEditForm.lampType,
                lampTypeStr:this.pefEditForm.lampTypeStr,
                angleNo:this.pefEditForm.angleNo,
                colorTemperatureStr:this.pefEditForm.colorTemperatureStr,
                lampPower:this.pefEditForm.lampPower,
                workVoltage:this.pefEditForm.workVoltage,
                lightType:this.pefEditForm.lightType,
                controlProtocol:this.pefEditForm.controlProtocol,

                projectId:this.pefEditForm.projectId,
                lampparamNo:this.pefEditForm.lampparamNo,
                glareStr:this.pefEditForm.glareStr,
                pdfPath:this.pefEditForm.pdfPath,
                id:this.pefEditForm.id,
                powerNo:this.pefEditForm.powerNo,
                lampNo:this.pefEditForm.lampNo,
                colorTempeNo:this.pefEditForm.colorTempeNo,
                delFlag:this.pefEditForm.delFlag,
                colorTemperature:this.pefEditForm.colorTemperature,
                colorType:this.pefEditForm.colorType
            })
            let self = this
            this.$http.postObj('/api/batchUploadPdfSubmit',temp,function(res){
                if(res.success){
                    self.$message({
                        message: "操作成功！",
                        type: "success"
                    });
                    self.search(1)
                    self.showPDFEditViewDiag = false
                }else{
                    self.$message.error(res.data)
                }
            })
        },
        submitConfrim(){
            let self = this
            var flag = true
            for(var i = 0;i<this.confirmDataTable.length;i++){
                var row = this.confirmDataTable[i]
                if(row.grayDemand == ''){
                    //光色类型必填
                    this.$message.error('光色类型必填！')
                    flag = false
                    break;
                }
                if(row.lampTypeStr == ''){
                    //灯具类型必填
                    this.$message.error('灯具类型必填!')
                    flag = false
                    break;
                }
                if(row.lampPower == '' || row.lampPower == 'undefined' || typeof row.lampPower == typeof undefined){
                    //功率必填
                    this.$message.error('灯具功率必填!')
                    flag = false
                    break;
                }
                if(row.colorTemperatureStr == ''){
                    //色温色彩必填
                    this.$message.error('色温色彩必填!')
                    flag = false
                    break;
                }
                if(row.workVoltage == ''  || row.workVoltage == 'undefined' || typeof row.workVoltage == typeof undefined){
                    //工作电压必填
                    this.$message.error('工作电压必填!')
                    flag = false
                    break;
                }
                if(row.lightType == ''  || row.lightType == 'undefined' || typeof row.lightType == typeof undefined){
                    //光源类型必填
                    this.$message.error('光源类型必填!')
                    flag = false
                    break;
                }
                if(row.controlProtocol == ''  || row.controlProtocol == 'undefined' || typeof row.controlProtocol == typeof undefined){
                    //控制协议必填
                    this.$message.error('控制协议必填!')
                    flag = false
                    break;
                }
            }
            if(!flag){
                return false;
            }
            this.$http.postObj('/api/batchUploadPdfSubmit',this.confirmDataTable,function(res){
                if(res.success){
                    self.$message({
                        message: "操作成功！",
                        type: "success"
                    });
                    self.showConfrimDialog = false
                    self.show3 = false
                    self.search(1)
                }else{
                    self.$message.error(res.data)
                }
            })
        },
        SeeeMenu(){
            this.eds = true
        },
        closeSubmitConfrim(){
            this.showConfrimDialog = false
            this.show3 = false
        },
        getProjectRoleUserList(){
            //获取项目角色以及角色用户
            let self = this
            self.userList = []
            var projectId = this.$route.query.id  //this.request.projectId
            
            this.$http.get('/api/users/getCurrentUser',{},function(res){
                var userid = res.data.id
                self.currentUserCompany = res.data.organization.orgName
                self.isStartRules = res.data.organization.isStartRules
                self.$http.get('/api/projects/roles/users/json/'+projectId,{},function(res){
                    if(res.success){
                        for(var i = 0;i<res.data.length;i++){
                            for(var j = 0;j<res.data[i].userList.length;j++){
                                if(res.data[i].roleName =='价格填入人'){ //填价格的权限，其他权限按钮隐藏；
                                    if(res.data[i].userList[j].userId == userid){
                                        self.userhavePrice = true
                                    }
                                }
                                if(res.data[i].roleName =='数量填入人'){ //填数量的权限，其他权限按钮隐藏； 无预估数量
                                    if(res.data[i].userList[j].userId == userid){
                                        self.userhaveCount = true
                                    }
                                }
                                if(res.data[i].roleName =='灯参制作人'){
                                    if(res.data[i].userList[j].userId == userid){
                                        self.userhaveRole = true
                                        self.userhaveCountyugu = true //预估数量
                                    }
                                }
                                if(res.data[i].roleName =='灯参初审人'){
                                    if(res.data[i].userList[j].userId == userid){
                                        self.userhaveAuditRole = true
                                        self.userhaveFirstAuditRole = true
                                    }
                                }

                                if(res.data[i].roleName =='灯参终审人'){
                                    if(res.data[i].userList[j].userId == userid){
                                        self.userhaveAuditRole = true
                                        self.userhaveFinalAuditRole = true
                                    }
                                }

                                // if(res.data[i].roleName =='项目负责人'){
                                //     if(res.data[i].userList[j].userId == userid){
                                //         self.userhaveCountyugu = true //预估数量
                                //     }
                                // }
                                // if(res.data[i].roleName =='第二负责人'){
                                //     if(res.data[i].userList[j].userId == userid){
                                //         self.userhaveCountyugu = true //预估数量
                                //     }
                                // }

                                if(res.data[i].roleName =='灯参制作人'){
                                    self.userList.push(res.data[i].userList[j])
                                }
                            }
                        }
                    }
                })
                //加载项目信息  项目负责人  第二负责人
                self.$http.get('/api/projects/view/'+self.projectRootId,{},function(res){
                    if(res.success){
                        if(userid == res.data.fzrId || userid == res.data.secondFzrId){
                            self.userhaveCountyugu = true //预估数量
                            self.fuheshuju = true
                        }
                        
                    }
                })
            })

            //如果为待审核项目时，默认查询初审中，终审中的的灯参
            var dataStatusList =[]
            if(self.userhaveFirstAuditRole){
                dataStatusList.push('3');
            }
            if(self.userhaveFinalAuditRole){  //终审角色
                dataStatusList.push('4');
            }

            if(self.isgdorPending=='3'){
                self.dataStatusList =dataStatusList;
                var auditPageRequestData = sessionStorage.getItem("auditPageRequestData") ;
                if(auditPageRequestData){
                    var obj = JSON.parse(sessionStorage.getItem("auditPageRequestData"));
                    self.request =  obj;
                    self.dataStatusList = obj.dataStatus.split(',')
                }
            }else{
                //灯参制作页面代入查询参数
                var zhizuoPageRequestData = sessionStorage.getItem("zhizuoPageRequestData") ;
                if(zhizuoPageRequestData){
                    var obj = JSON.parse(sessionStorage.getItem("zhizuoPageRequestData"));
                    self.request =  obj;
                    if(obj.dataStatus){
                        self.dataStatusList = obj.dataStatus.split(',')
                    }

                }
            }
            
        },
        tableRowClassName({row, rowIndex}) {
            row.index = rowIndex;
        },
        tableRowClickEdit(row, event, column){
            if(this.isgdorPending==0){
                if(this.userhavePrice){
                    this.tableData[row.index].showEdit=true;
                }
                if(this.isSingle && this.userhaveCount){
                    this.tableData[row.index].showEditCount=true;
                }
                if(this.isSingle && this.userhaveCountyugu){
                    this.tableData[row.index].showEditCountyugu=true;
                }
            }
            this.$set(this.tableData,row.index,this.tableData[row.index]);
        },
        updatePriceOrCount(){
            var priceList = []
            var countList = []
            let self = this
            for(var i = 0;i<this.tableData.length;i++){
                if(this.tableData[i].showEdit){
                    priceList.push({
                        lampparamId:this.tableData[i].lampparamId,
                        unitPrice:this.tableData[i].projectLampparamVo.unitPrice
                    })

                    self.tableData[i].showEdit=false;
                }
                if(this.tableData[i].showEditCount || this.tableData[i].showEditCountyugu){
                    var targetProjectId = this.request.projectId
                    countList.push({
                        actualCount:this.tableData[i].projectLampparamVo.actualCount,
                        drawingCount:this.tableData[i].projectLampparamVo.drawingCount,
                        estimateNum:this.tableData[i].projectLampparamVo.estimateNum,
                        id:this.tableData[i].id,
                        projectId:targetProjectId
                    })
                    self.tableData[i].showEditCount=false;
                    self.tableData[i].showEditCountyugu = false;
                }
                self.$set(this.tableData,i,this.tableData[i]);
            }
            if(priceList.length>0){
                this.$http.postObj('/api/lampparams/batchEditPrice',priceList,function(res){
                    if(res.success){
                        self.$message({
                            message: "价格更新成功！",
                            type: "success"
                        })
                        self.getTotalPrice()
                    }else{
                        self.$message.error(res.data)
                    }
                })
            }
            if(countList.length>0){
                this.$http.postObj('/api/lampparams/batchEditNum',countList,function(res){
                    if(res.success){
                        self.$message({
                            message: "数量更新成功！",
                            type: "success"
                        })
                        self.getTotalPrice()
                    }
                })
            }
            
        },
        //显示隐藏列
        changeColumnSH1(index,item){
            this.columnShowHideList1[index].value = !item.value
        },
        changeColumnSH2(index,item){
            this.columnShowHideList2[index].value = !item.value
        },
        changeColumnSH3(index,item){
            this.columnShowHideList3[index].value = !item.value
        },
        //上一个
        perv(){
            var id = this.currentDetailInfo.projectLampparamVo.id
            for(var i = 0;i<this.tableData.length;i++){
                if(this.tableData[i].lampparamId == id){
                    if(i==0){
                        this.$message("已经是本页第一条")
                        break
                    }
                    this.showLampParamDetail(this.tableData[i-1].lampparamId)
                }
            }
        },
        //下一个
        next(){
            var id = this.currentDetailInfo.projectLampparamVo.id
            for(var i = 0;i<this.tableData.length;i++){
                if(this.tableData[i].lampparamId == id){
                    if(i==this.tableData.length){
                        this.$message("已经是本页最后一条")
                        break
                    }
                    this.showLampParamDetail(this.tableData[i+1].lampparamId)
                }
            }
        },
        //上一个
        pervPdf(){
            var id = this.currentDetailInfo.projectLampparamVo.id
            for(var i = 0;i<this.tableData.length;i++){
                if(this.tableData[i].lampparamId == id){
                    if(i==0){
                        this.$message("已经是本页第一条")
                        break
                    }
                    this.showLampParamDetailPdf(this.tableData[i-1].lampparamId)
                }
            }
        },
        //下一个
        nextPdf(){
            var id = this.currentDetailInfo.projectLampparamVo.id
            for(var i = 0;i<this.tableData.length;i++){
                if(this.tableData[i].lampparamId == id){
                    if(i==this.tableData.length){
                        this.$message("已经是本页最后一条")
                        break
                    }
                    this.showLampParamDetailPdf(this.tableData[i+1].lampparamId)
                }
            }
        },
        xiugai(){
            if(this.checkboxModel.length == 0){
                this.$message.error("请至少选择一项")
                return
            }
            if(this.checkboxModel.length > 1){
                this.$message.error("只能选择一项")
                return
            }
            var item = this.checkboxModel[0]
            if(item.projectLampparamVo.dataStatus == 4){
                this.$message.error("状态错误，审核中项目不可修改")
                return
            }
            var makingWay = item.projectLampparamVo.makingWay

            if(makingWay == 2){
                this.showPDFEditView(item.lampparamId)
            }else{
                if(item.projectLampparamVo.wordTemplateFlag == 2){
                    this.gotoUpdatePdf(item.lampparamId)
                }else{
                    this.gotoUpdate(item.lampparamId)
                }
            }

            sessionStorage.setItem("zhizuoPageRequestData",   JSON.stringify(this.request));
        },
        initPdfEditInfo(){
            let self = this
                this.fileList = []
                this.uploadUrl = this.$http.getSignUrl('/api/files/upload',{type:'wordpdf'})
                
                //加载灯具类型
                this.$http.get("/api/dictTypeAllList", {indexPinyin:'dengjuleixing'}, function(res) {
                    if (res.success) {
                        self.lampAllTypeList = res.data;
                    }
                });

                //加载光束角编号列表
                this.$http.postQuery('/api/lampparams/AnglemapList',{},function(res){
                    if(res.success){
                        self.AnglemapList = res.data
                    }
                })
                //加载其他自定义列表 
                this.$http.get('/api/dictTypeAllList',{indexPinyin:'sewen/secai'},function(res){
                    if(res.success){
                        self.mbColorList = res.data
                    }
                })
                //加载工作电压
                this.$http.get('/api/dictTypeAllList',{indexPinyin:'gongzuodianya'},function(res){
                    self.gongzuodianyaList = res.data
                })

                //光色类型
                this.$http.get("/api/dictTypeAllList",{indexPinyin:'dengjusecaifenlei'},function(res){
                    self.guangseleixingList = res.data
                })

                //控制协议1
                this.$http.get('/api/dictTypeAllList',{indexPinyin:'kongzhixieyi'},function(res){
                if(res.success){
                    self.controlProtocol1List = res.data
                }
            })
        },
        showPDFEditView(id){
            this.initPdfEditInfo()
            let self = this
            this.$http.get('/api/lampparams/editView/'+id,{},function(res){
                    if(res.success){
                        var item = res.data
                        var info = item.projectLampparamVo
                        self.pefEditForm = info
                        self.$set(self.pefEditForm,'angleNoText','')
                        // self.pefEditForm.angleNoText = ''
                        // self.pefEditForm.grayDemandText = ''
                        self.$set(self.pefEditForm,'grayDemandText','')

                        if(self.pefEditForm.grayDemand != null && self.pefEditForm.grayDemand != ''){
                            self.pefEditForm.grayDemand = parseInt(self.pefEditForm.grayDemand)
                            for(var j = 0;j<self.guangseleixingList.length;j++){
                                if(self.pefEditForm.grayDemand == self.guangseleixingList[j].id){
                                        self.pefEditForm.grayDemandText = self.guangseleixingList[j].dictCont
                                }
                            }
                        }
                        if(self.pefEditForm.lampType != null && self.pefEditForm.lampType != ''){
                            for(var i = 0;i<self.lampAllTypeList.length;i++){
                                if(self.lampAllTypeList[i].dictCont == self.pefEditForm.lampType){
                                    self.pefEditForm.lampType = self.lampAllTypeList[i].id
                                    self.pefEditForm.lampTypeStr = self.lampAllTypeList[i].dictCont
                                }else if(self.lampAllTypeList[i].id == self.pefEditForm.lampType){
                                    self.pefEditForm.lampType = self.lampAllTypeList[i].id
                                    self.pefEditForm.lampTypeStr = self.lampAllTypeList[i].dictCont
                                }
                            }
                        }
                        if(self.pefEditForm.angleNo != null && self.pefEditForm.angleNo != ''){
                            for(var i = 0;i<self.AnglemapList.length;i++){
                                if(self.pefEditForm.angleNo == self.AnglemapList[i].ruleNo){
                                    self.pefEditForm.angleNoText = self.AnglemapList[i].ruleKey
                                }
                            }
                        }
                        self.showPDFEditViewDiag = true
                    }
            })
        },
        //差异对比
        showDiffView(){
            if(this.checkboxModel.length == 0){
                this.$message.error("请至少选择一项")
                return
            }
            this.diff = true
            var ids = ''
            for(var i = 0;i<this.checkboxModel.length;i++){
                ids += this.checkboxModel[i].lampparamId + ','
            }
            ids = ids.substring(0,ids.length-1)
            let self = this
            this.$http.postQuery('/api/lampparams/compareJson',{ids:ids},function(res){
                if(res.success){
                    self.chayidibiContestType = res.data.list[0].contestTypeString
                    self.chayiduibiColorType = res.data.list[0].colorType
                        for(var i = 0;i<res.data.list.length;i++){
                            var temp = []
                            var temp1 = []
                            for(var j = 0;j<res.data.list[i].projectParamindexList.length;j++){
                                var row = res.data.list[i].projectParamindexList[j];
                                if(j == 0){
                                    temp.push(row)
                                }else if(j == 1 && (self.chayidibiContestType=='复合面' || self.chayidibiContestType=='窗框')){
                                    temp.push(row)
                                }else{
                                    temp1.push(row)
                                }
                            }
                            res.data.list[i].projectParamindexHisVoList = temp
                            res.data.list[i].projectParamindexHisVoList1 = temp1
                        }
                    self.tableDiffList = res.data.list
                    self.fields = res.data.fields
                    self.childFields = res.data.childFields
                }
            })
        },
        //归档
        projectArchiving(){
            let self = this
            var targetProjectId = this.request.projectId
            this.$confirm('确认归档？归档后系统将删除使用次数为0的灯参！','提示',{
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
            self.$http.get('/api/lampparams/projectArchiving/'+targetProjectId,{},function(res){
                if(res.success){
                    self.$message({
                        message: "操作成功！",
                        type: "success"
                    }); 
                }else{
                self.$message.error(res.data)
                }
            })
            }).catch(()=>{});
        },
        // 点击推荐灯参的灯参编号
        recommendLamp(id){
            let rootIn = '';
            this.loadingInstance = Loading.service({ text: '拼命加载中' })
            setTimeout(async ()=>{
                await this.$http.get('/api/lampparams/view/'+id,{},function(res){
                    rootIn = res.data.projectLampparamVo.rootIn
                })
                this.recommendLampPdfStatus(rootIn,id,true);
            },1000)
        },
        isPdfStatusParent(item){
            let rootIn = item.rootIn;
            let id = item.lampparamId
            this.loadingInstance = Loading.service({ text: '拼命加载中' })
            setTimeout(()=>{
                this.isPdfStatus(rootIn,id)
            },1000)
            
        },

        hisLampPreview(item){
            let id = item.id
            this.loadingInstance = Loading.service({ text: '拼命加载中' })
            this.getHisPdf(id)
           //  setTimeout(()=>{
           //      getHisPdf(id)
           //  },1000)
            this.loadingInstance.close()
        },

        getHisPdf(id) {
            this.$http.get("/api/lampparams/generateHisLampparamPdf/" + id, {}, (res) => {
                var pdfSrc = this.$http.getSignUrl('/api/previewPdf', {
                    fileName: res.data.fileName,
                    token: this.$store.state.token
                })
                window.open(pdfSrc)
            })
        },
        async isPdfStatus(rootIn, id) {
          await this.$http.get('/api/lampparams/view/' + id, {}, function (res) {
            rootIn = res.data.projectLampparamVo.rootIn
          })
          if (rootIn == '4') { //通用模板添加
            this.showLampParamDetailPdf(id)
          } else {
            this.showLampParamDetail(id)
          }
        },
        recommendLampPdfStatus(rootIn,id,recommend = false){
            if(rootIn == '4'){ //通用模板添加  不允许有操作按钮，只预览
                 this.showLampParamDetailPdf(id,false,recommend)
            }else{
                this.showLampParamDetail(id,false,recommend)
            }
        },
        //详情
        showLampParamDetailPdf(id,flag,recommend){
            this.$refs.detailPdf.show(id,flag,this.isgdorPending,this.userhaveRole,this.request.projectId,recommend)
        },
        showLampParamDetail(id,flag,recommend){
            this.$refs.detail.show(id,flag,this.isgdorPending,this.userhaveRole,this.request.projectId,recommend)
        },
        getDetailLists(){
            let self = this
            //加载效果描述
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'xiaoguomiaoshu'},function(res){
                self.xiaoguomiaoshuList = res.data
            })
            //加载工作电压
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'gongzuodianya'},function(res){
                self.gongzuodianyaList = res.data
            })
            //加载安装方向
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'anzhuangfangxiang'},function(res){
                self.anzhuangfangxiangList = res.data
            })
            //加载灯具颜色
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'dengjuyanse'},function(res){
                self.dengjuyanseList = res.data
            })
            //表面温度
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'biaomianwendu'},function(res){
                self.biaomianwenduList = res.data
            })
            //防护等级
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'fanghudengji'},function(res){
                self.fanghudengjiList = res.data
            })
            //灯体材质
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'caijidengticaizhi'},function(res){
                self.caijidengticaizhiList = res.data
            })
            //表面材质
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'caijibiaomiancaizhi'},function(res){
                self.caijibiaomiancaizhiList = res.data
            })

            //安装方式
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'anzhuangfangshi'},function(res){
                self.anzhuangfangshiList = res.data
            })

            //附件要求
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'fujianyaoqiu'},function(res){
                self.fujianyaoqiuList = res.data
            })

            //控制协议1
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'kongzhixieyi'},function(res){
                if(res.success){
                    self.controlProtocol1List = res.data
                }
            })
            //控制协议2
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'kongzhixieyierji'},function(res){
                if(res.success){
                    self.controlProtocol2List = res.data
                }
            })

            //动态效果
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'dongtaixiaoguo'},function(res){
                self.dongtaixiaoguoList = res.data
            })
            //其他要求
            this.$http.get('/api/dictTypeAllList',{indexPinyin:'qitayaoqiu'},function(res){
                self.qitayaoqiuList = res.data
            })
        },
        shows(){
          this.show = !this.show;
        },
        addClass(jog){
            let self = this
            this.index = jog;
            if(jog == 1){//典型应用面 分类加载
                this.ckblampparamId = []
                this.$http.postObj('/api/lampparams/contestSketch/json',{isDefaut:1},function(res){
                    if(res.success){
                        self.contestTypeList = res.data
                        self.recoImgArr = self.contestTypeList
                        self.currentContestType = self.contestTypeList[0]
                        self.changeReco(356) //默认请求洗墙数据
                        self.otherProjectRequest.contestType = '洗墙'
                        // self.getContestList() //加载右侧列表
                    }
                })
            }else if (jog == 2) //项目库
            {
                //全部项目信息列表
                var targetProjectId = this.request.projectId
                this.$http.postObj('/api/projects/comboJson/'+targetProjectId,{parentId:0,page:1,rows:50},function(res){
                    
                    var res = JSON.parse(res)
                    // if(res.success){
                        self.projectList = res
                    // }
                })
                this.otherProjectRequest={
                    page:1,
                    rows:20,
                    projectId:'',
                    lampPowerMin:'',
                    lampPowerMax:'',
                    contestType:'',
                    contestH:'',
                    lumSize:'',
                    contestW:'',
                    contestW1:'',
                    contestW2:'',
                    lampparamNoLike:'',//灯参编号
                    lampType:'',
                    createBy:'',
                    dataStatus:5,//erp是5
                }
                this.getOtherProject(1)
            }else if(jog == 3){ //自定义
                var targetProjectId = this.request.projectId
                var jduId = ''
                if(this.jduhhs.id != null){
                    jduId = this.jduhhs.id
                }
                var jduhh = ''
                if(this.jduhh != null){
                    jduhh = this.jduhh
                }
                this.$router.push('/custom?pid='+this.projectRootId+'&id='+targetProjectId+"&gd="+this.$route.query.gd+"&dio="+this.$route.query.dio+"&jduhh="+jduhh+"&jduhhs="+jduId)
            }else if(jog == 4){
                // this.initPdfEditInfo()
                
                // 点击通用模板
                this.$router.push('/currency?'+'&id='+this.request.projectId)
            }
        },
        //选择典型应用左侧数据
        chooseContestType(row){
            this.currentContestType = row
            //应用类型id contestTypeId
            this.getContestList()
        },
        //典型应用列表
        getContestList(json = {}){
            let self = this
            var id = this.currentContestType.contestTypeId
         /*   if(this.currentContestType.contestTypeStr=='自发光线'){
                this.lowName ='2000~4000'
                this.middleName ='4000~8000'
                this.highName ='＞8000'
            }else{
                this.lowName ='10~20';
                this.middleName='20~40';
                this.highName='40~60';
            }*/
            var contestDescObj  = self.contestDescMap.get(self.currentContestType.contestTypeStr)
            if(contestDescObj){
                    self.lowNameDesc=contestDescObj.lowNameDesc;
                    self.middleNameDesc=contestDescObj.middleNameDesc;
                    self.highNameDesc =contestDescObj.highNameDesc;
                self.rgb_lowNameDesc=contestDescObj.rgb_lowNameDesc;
                self.rgb_middleNameDesc=contestDescObj.rgb_middleNameDesc;
                self.rgb_highNameDesc =contestDescObj.rgb_highNameDesc;
            }else{
                self.lowNameDesc='';
                self.middleNameDesc= '';
                self.highNameDesc ='';
                self.rgb_lowNameDesc='';
                self.rgb_middleNameDesc= '';
                self.rgb_highNameDesc ='';
            }


            //加载应用类型关联灯具类型
            this.$http.get("/api/dictionaryLampparam/lampparamDictTypeList", { indexPinyin: 'dengjuleixing',
                contestType:id}, function(res) {
                if (res.success) {
                    self.contestUnionLampTypeList = res.data;
                }
            });
            this.$http.postObj('/api/lampparams/contestLampparamjson/'+id,json,function(res){
                if(res.success){
                    self.contestList = res.data;
                    // 给筛选项赋值
                    // self.selectcontestList = JSON.parse(JSON.stringify(self.contestList[0]))
                    // 切换左侧图片
                    if(self.letterItemJson){
                      for(let key in self.letterItemJson){
                        delete self.recoSearchJson[key.toLowerCase()]

                      }
                      self.letterItemJson = {}
                    }
                    // 给字母筛选项赋值
                    self.recoImgArr.forEach(e=>{
                      if(e.id == self.currentContestType.id){
                        self.letterItemJson = JSON.parse(e.sketchAttr)
                        // 数据太多 调整宽度  隐藏横向滚动条
                        if(Object.keys(self.letterItemJson).length > 4){
                          self.scrollHideFlag = true;
                        }else{
                            self.scrollHideFlag = false;
                        }
                      }
                    })
                    for(let key in self.letterItemJson){
                      if(key != "Dmin"){
                        self.recoSearchJson[key.toLowerCase()] = '';
                      }
                    }

                    console.log(self.letterItemJson)

                   /* for(var i = 0;i<self.contestList.length;i++){
                        self.contestList[i].singleColor = JSON.parse(self.contestList[i].singleColor);
                        self.contestList[i].rgbColor = JSON.parse(self.contestList[i].rgbColor);
                    }*/
                }
            })
        },
        //项目列表
        getOtherProject(page){
            let self = this
            this.otherProjectRequest.page = page
                //项目库列表
                var targetProjectId = this.request.projectId
                this.$http.postObj('/api/lampparams/otherProjectJson/'+targetProjectId,this.otherProjectRequest,function(res){
                    if(res.success){
                        self.otherProjectList = res.data.rows
                        self.otherProjectTotalCount = res.data.total
                    }
                })
        },
        otherProjectSelect(val){
            this.checkOtherProjectModel = val
        },
        //导入 典型 或 项目
        copyLamparam(type){
            //1典型 2项目库
            var temp = ''
            if(type==1){
                if(this.ckblampparamId.length == 0){
                    this.$message.error('请至少选择一项！')
                    return false
                }
                for(var i = 0;i<this.ckblampparamId.length;i++){
                    temp += this.ckblampparamId[i] + ','
                }
            }else{
                if(this.checkOtherProjectModel.length == 0){
                    this.$message.error('请至少选择一项！')
                    return false
                }
                for(var i = 0;i<this.checkOtherProjectModel.length;i++){
                    temp += this.checkOtherProjectModel[i].id + ','
                }
            }
            temp = temp.substring(0,temp.length-1)
            let self = this
            var targetProjectId = this.request.projectId
            this.$http.postQuery('/api/lampparams/copyLamparam/'+type,{lampparamIds:temp,targetProjectId:targetProjectId},function(res){
                self.$message({
                    message: "导入成功！",
                    type: "success"
                });
            if(type==1){
                self.ckblampparamId = []
                self.getContestList()
            }else{
                self.checkOtherProjectModel = []
                self.getOtherProject(1)
            }
                self.search(1)
            })
        },
        //归档项目显示添加到我的项目弹窗
        showAddToMyProject2(){
             if(this.checkboxModel.length == 0){
                this.$message.error("请至少选择一项")
                return
            }
            this.addMyProject2 = true
            this.searchgdProject(1)
        },
        searchgdProject(page){
            this.gdPage = page
            let self = this
            this.$http.postObj('/api/projects/json',{itemNameLike:this.searchItemName,parentId:0,page:this.gdPage,rows:10},function(res){
                if(res.success){
                    self.gdProjectList = res.data.rows
                    self.gdTotalCount = res.data.total
                }
            })
        },
         showAddToMyProject3(row){
            this.addMyProject3 = true
            let self = this
            this.$http.get("/api/projects/treeJson/"+row.id,{},function(res){
                if(res.success){
                    var data = res.data
                    var temp = []
                    for(var i = 0;i<data.length;i++){
                        if(data[i].parentId = row.id){
                            temp.push(data[i])
                        }
                    }

                    self.childProjectList = temp
                    self.childProjectListBak = temp
                }
            })

        },
        searchAddMyProjectChild(){
            var temp = []
                var name = this.searchChildProject
                if(name != ''){
                    for(var i = 0;i<this.childProjectListBak.length;i++){
                        if(this.childProjectListBak[i].itemName == name){
                            temp.push(this.childProjectListBak[i])
                        }
                    }
                }else{
                    temp = this.childProjectListBak
                }
                this.childProjectList = temp
        },
        saveAddToMyProject3(){
            let self = this
            var temp = ''
            for(var i = 0;i<this.checkboxModel.length;i++){
                temp += this.checkboxModel[i].lampparamId + ','
            }
            temp = temp.substring(0,temp.length-1)

            var childProjectIds = ''
            for(var i = 0;i<this.gdcheckboxModel.length;i++){
                childProjectIds += this.gdcheckboxModel[i].id + ','
            }
            childProjectIds = childProjectIds.substring(0,childProjectIds.length-1)

            this.$http.postQuery('/api/lampparams/copyLamparam/2',{lampparamIds:temp,targetProjectId:childProjectIds},function(res){
                self.$message({
                    message: "添加成功！",
                    type: "success"
                });
                self.addMyProject2 = false
                self.addMyProject3 = false
            })
        },
        //显示添加到我的项目弹窗
        showAddToMyProject(type){
            //显示
            if(type == 1){
                if(this.checkboxModel.length == 0){
                    this.$message.error("请至少选择一项")
                    return
                }
            }
            this.chooseAddmyProjectSource = type
            this.addMyProject = true
            if(this.$refs.myprojectTree){
                this.$refs.myprojectTree.setCheckedKeys([]); 
            }
        },
        //  //添加到我的项目 树事件
        // choosemyProjectIdchange(data, checked, node){
        //     if(checked == true){
        //         this.chooseMyProjectId = data.id;
        //         this.$refs.myprojectTree.setCheckedNodes([data]);
        //     }
        // },
        // //添加到我的项目 树事件
        // choosemyProjectIdclick(data,checked,node){
        //     this.chooseMyProjectId = data.id
        //     this.$refs.myprojectTree.setCheckedNodes([data]);
        // },
        //添加到我的项目
        addlampProjecttoMyproject(){
            var checkedTree = this.$refs.myprojectTree.getCheckedNodes();
            if (checkedTree.length == 0) {
                this.$message.error("请选择目标项目！");
                return false;
            }
            var tempChooseProjectIds = ''
            for (var i = 0; i < checkedTree.length; i++) {
                tempChooseProjectIds += checkedTree[i].id + ','
            }
            tempChooseProjectIds = tempChooseProjectIds.substring(0,tempChooseProjectIds.length-1)


            let self = this
            var temp = ''
            if(this.chooseAddmyProjectSource == 1){
                //type = 1 就是页面上勾的
                for(var i = 0;i<this.checkboxModel.length;i++){
                    temp += this.checkboxModel[i].lampparamId + ','
                }
                temp = temp.substring(0,temp.length-1)
            }else{
                // 其他就是 详情点击的
                temp = this.currentDetailInfo.projectLampparamVo.id
            }
            this.$http.postQuery('/api/lampparams/copyLamparam/2',{lampparamIds:temp,targetProjectId:tempChooseProjectIds},function(res){
                self.$message({
                    message: "添加成功！",
                    type: "success"
                });
                self.search(1)
                self.addMyProject = false
                if(self.$refs.myprojectTree){
                    self.$refs.myprojectTree.setCheckedKeys([]); 
                }
            })
        },
        //选择树 改变targetprojectid
        SelectProjectTreeMenu(item){
            if(this.$refs.multipleTable){
            this.$refs.multipleTable.clearSelection();
            }
            this.jduhhs = item
            this.request.projectId = item.id

            if(item.monomerAttr){
                 this.isSingle =true
            }else{
                this.isSingle = false
            }
            this.search(1)
            // this.timer = setTimeout(() => {
            //     this.getProjectRoleUserList();
            // }, 300)
            this.asc = true
            this.eds = false

        },
        //select table
        selectTableData(val){
            this.checkboxModel = val
        },

        //选中灯参历史记录数据表
        selectHisTableData(val){
            this.histableCheckboxModel = val
        },
        //select table
        gdselectTableData(val){
            this.gdcheckboxModel = val
        },
        //批量删除
        deleteLampParamBatch(){
            if(this.checkboxModel.length == 0){
                this.$message.error("请至少选择一项")
                return
            }
            var ids = ''
            for(var i = 0;i<this.checkboxModel.length;i++){
                ids += this.checkboxModel[i].lampparamId + ','
            }
            ids = ids.substring(0,ids.length-1)
            let self = this
            this.$confirm('您确定要删除吗?','提示',{
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                var targetProjectId = this.request.projectId
                this.$http.deletePath('/api/lampparams/delete/'+targetProjectId,{lampparamIds:ids},function(res){
                    if(res.success){
                        self.$message({
                            message: "删除成功！",
                            type: "success"
                        });
                        self.search(1)
                    }else{
                        self.$message.error(res.data)
                    }
                })
            }).catch(()=>{});
        },
        //删除单个
        deleteLampParam(id){
            let self = this
            this.$confirm('您确定要删除吗?','提示',{
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                var targetProjectId = this.request.projectId
                this.$http.deletePath('/api/lampparams/delete/'+id+'/'+targetProjectId,{},function(res){
                if(res.success){
                    self.$message({
                        message: "删除成功！",
                        type: "success"
                    });
                    self.search(1)
                    self.showDetail =false
                }else{
                        self.$message.error(res.data)
                    }
            })
            }).catch(()=>{});
            
        },
        gotoUpdatePdf(id){
            var targetProjectId = this.request.projectId
                var jduId = ''
                if(this.jduhhs.id != null){
                    jduId = this.jduhhs.id
                }
                var jduhh = ''
                if(this.jduhh != null){
                    jduhh = this.jduhh
                }
                this.$router.push('/currency?pid='+this.projectRootId+'&id='+targetProjectId+"&cid="+id+"&gd="+this.$route.query.gd+"&dio="+this.$route.query.dio+"&jduhh="+jduhh+"&jduhhs="+jduId)
        },
        gotoUpdate(id){
            var targetProjectId = this.request.projectId
                var jduId = ''
                if(this.jduhhs.id != null){
                    jduId = this.jduhhs.id
                }
                var jduhh = ''
                if(this.jduhh != null){
                    jduhh = this.jduhh
                }
                this.$router.push('/custom?pid='+this.projectRootId+'&id='+targetProjectId+"&cid="+id+"&gd="+this.$route.query.gd+"&dio="+this.$route.query.dio+"&jduhh="+jduhh+"&jduhhs="+jduId)
        },
        //批量撤回
        retractbatch(){
            if(this.checkboxModel.length == 0){
                this.$message.error("请至少选择一项")
                return
            }
            var ids = ''
            var flag = true
            for(var i = 0;i<this.checkboxModel.length;i++){
                if(this.checkboxModel[i].projectLampparamVo.dataStatus != 3){
                    flag = false
                }
                ids += this.checkboxModel[i].lampparamId + ','
            }
            ids = ids.substring(0,ids.length-1)
            if(!flag){
                this.$message.error("请选择状态为初审中的灯参撤回!")
                return
            }


            let self = this
            this.$confirm('您确定要撤回吗?','提示',{
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                this.$http.postQuery('/api/lampparams/batchRetract',{lampparamIds:ids},function(res){
                if(res.success){
                    self.$message({
                        message: "撤回成功！",
                        type: "success"
                    });
                    self.search(1)
                }else{
                    self.$message.error(res.data)
                }
            })
            }).catch(()=>{});

        },

        //批量撤回初审通过,终审未审核的灯参
        retractFirstAudit(){
            if(this.checkboxModel.length == 0){
                this.$message.error("请至少选择一项")
                return
            }
            var ids = ''
            var flag = true
            for(var i = 0;i<this.checkboxModel.length;i++){
                if(this.checkboxModel[i].projectLampparamVo.dataStatus != 4){
                    flag = false
                }
                ids += this.checkboxModel[i].lampparamId + ','
            }
            ids = ids.substring(0,ids.length-1)
            if(!flag){
                this.$message.error("请选择状态为终审中的灯参撤回!")
                return
            }


            let self = this
            this.$confirm('您确定要撤回吗?','提示',{
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                this.$http.postQuery('/api/lampparams/batchRetractFirstAudit',{lampparamIds:ids},function(res){
                    if(res.success){
                        self.$message({
                            message: "撤回成功！",
                            type: "success"
                        });
                        self.search(1)
                    }else{
                        self.$message.error(res.data)
                    }
                })
            }).catch(()=>{});

        },
        //批量申请审核
        auditbatch(){
            if(this.checkboxModel.length == 0){
                this.$message.error("请至少选择一项")
                return
            }
            var ids = ''
            var flag = true
            for(var i = 0;i<this.checkboxModel.length;i++){
                if(this.checkboxModel[i].projectLampparamVo.dataStatus != 2){
                    flag = false
                }
                ids += this.checkboxModel[i].lampparamId + ','
            }
            if(!flag){
                this.$message.error("当前选择的数据错误，状态只能是生成状态！")
                return
            }
            ids = ids.substring(0,ids.length-1)
            let self = this
            this.$confirm('您确定要提交审核吗?','提示',{
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                this.$http.postQuery('/api/lampparams/batchAudit',{lampparamIds:ids},function(res){
                if(res.success){
                    self.$message({
                        message: "提交成功！",
                        type: "success"
                    });
                    self.search(1)
                }else{
                    self.$message.error(res.data)
                }
            })
            }).catch(()=>{});
        },
        //申请审核 单个
        audit(lampparamId){
            let self = this
            this.$confirm('您确定要提交审核吗?','提示',{
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                this.$http.postQuery('/api/lampparams/batchAudit',{lampparamIds:lampparamId},function(res){
                if(res.success){
                    self.$message({
                        message: "提交成功！",
                        type: "success"
                    });
                    self.showLampParamDetail(lampparamId)
                    self.search(1)

                }else{
                    self.$message.error(res.data)
                }
            })
            }).catch(()=>{});
        },
        gotoAudit(){
            if(this.checkboxModel.length == 0){
                this.$message.error("请至少选择一项")
                return
            }
            if(this.checkboxModel.length > 1){
                this.$message.error("只可以选择一项")
                return
            }
            var id = this.checkboxModel[0].lampparamId
            var status = this.checkboxModel[0].projectLampparamVo.dataStatus
            if(status == 1 || status  == 2){
                    this.$message.error("暂存状态和生成状态的灯参不能审核")
                    return
            }

            //验证是否具有审核权限
            let self = this
            this.$http.get("/api/lampparams/validateAuditTask/"+id, {}, function(res) {
                if (res.success) {
                   var isAuditTask = res.data;
                   if(isAuditTask==false){
                       self.$message.error("无审核权限！")
                       return
                   }else{
                       //调整为在新的窗口打开
                       // let routeUrl = self.$router.resolve({
                       //     path: '/auditHtml?id='+id+'&projectId='+self.projectRootId
                       // });
                       // window.open(routeUrl.href, '_blank');

                       //审核页面记录查询条件到缓存中
                       sessionStorage.setItem("auditPageRequestData",   JSON.stringify(self.request));

                       self.$router.push('/auditHtml?id='+id+"&projectId="+self.projectRootId)
                   }
                }
            });
        },
        dianjiAudit(id){
            let self = this
            this.$http.get("/api/lampparams/validateAuditTask/"+id, {}, function(res) {
                if (res.success) {
                    var isAuditTask = res.data;
                    if(isAuditTask==false){
                        self.$message.error("无审核权限！")
                        return
                    }else{
                        self.$router.push('/auditHtml?id='+id+"&projectId="+self.projectRootId)
                    }
                }
            });


        },
        //是否通过审核
        auditSubmit(){
            var ids = ''
            for(var i = 0;i<this.checkboxModel.length;i++){
                ids += this.checkboxModel[i].lampparamId + ","
            }
            ids = ids.substr(0,ids.length -1)
            var temp = {
                auditReson:this.OnKeyAuditReson,
                flag:this.OnKeyAuditFlag,
                lampparamIds:ids
            }
            let self = this
            //flag 1 通过 2退回  auditReson 审核原因
            this.$http.postObj("/api/lampparams/batchAuditSubmit/",temp,function(res){
                if(res.success){
                    self.$message({
                        message: "操作成功！",
                        type: "success"
                    });
                    self.search(1)
                }else{
                    self.$message.error(res.data)
                }
                self.isShowSubmitAudit = false
            })

        },
         //数据来源
        dataSourcesBtn(detectionIds,lampIds){
            if(lampIds == null){
                lampIds = ""
            }
            let self = this
            this.dataSources = true
            this.$http.postObj('/api/contests/list',{page:1,rows:20,lampIdsStr:lampIds,detectionIdsStr:detectionIds},function(res){
                if(res.success){
                    self.dataSourceList = res.data.rows
                }
            })
        },
        //历史修改记录
        historicalRecord(id){
            this.auditId = id;
            this.searchHistoryList(1)
            this.historicalRecord_dialog = true
        },
        searchHistoryList(page){
            let self = this
            this.historyModifyPage = page
            this.$http.postObj('/api/lampparams/hisJson/'+this.auditId,{page:page,rows:5,order: "desc",sort: "updateDate"},function(res){
                if(res.success){
                    if(res.data.rows.length >0){
                        self.historyContestType = res.data.rows[0].contestTypeString
                        self.historyColorType = res.data.rows[0].colorType
                            for(var i = 0;i<res.data.rows.length;i++){
                                var temp = []
                                var temp1 = []
                                for(var j = 0;j<res.data.rows[i].projectParamindexHisVoList.length;j++){
                                    var row = res.data.rows[i].projectParamindexHisVoList[j];
                                    if(j == 0){
                                        temp.push(row)
                                    }else if(j == 1 && (self.historyContestType=='复合面' || self.historyContestType=='窗框')){
                                        temp.push(row)
                                    }else{
                                        temp1.push(row)
                                    }
                                }
                                res.data.rows[i].projectParamindexHisVoList = temp
                                res.data.rows[i].projectParamindexHisVoList1 = temp1
                            }
                    }
                    self.historyModifyList = res.data.rows
                    self.historyModifyCount = res.data.total
                    
                }
            })
        },  
        //审核记录
        ShowAuditRecordList(id){
            this.auditId = id;
            this.searchAuditList(1)
            this.showAuditRecord = true
        },
        searchAuditList(page){
            let self = this
            this.auditPage = page
            this.$http.postObj('/api/lampparams/auditRecordPageJson/'+this.auditId,{page:page,rows:10},function(res){
                self.auditRecordList = res.data.rows
                self.auditCount = res.data.total
            })
        },
        initData(){
            //加载分类信息
            let self = this
            //灯具色温色彩列表
          /*  this.$http.get('/api/dictTypeAllList',{indexPinyin:'dengjusewensecai'},function(res){
                if(res.success){
                    self.colorTypeList = res.data
                }
            })*/


            //加载灯具类型
          /*  this.$http.get("/api/lampTypes/json", {}, function(res) {
                if (res.success) {
                    self.lampTypeList = res.data;
                }
            });*/





            //加载项目树
            this.loadProjectTree()

            this.getProjectRoleUserList()

            this.initContestType();

            this.initLampType();



            // this.getDetailLists()
            //加载预估总价: 2222.00元图纸总价: 2222.00元实际总价: 2222.00元
            this.getTotalPrice()

            this.getdefaultsetting()
        },
        getdefaultsetting(){
            var jsonparamshowhideList1 = localStorage.getItem("paramshowhideList1")
            var jsonparamshowhideList2 = localStorage.getItem("paramshowhideList2")
            var jsonparamshowhideList3 = localStorage.getItem("paramshowhideList3")
            if(jsonparamshowhideList1 != null){
                this.columnShowHideList1 = JSON.parse(jsonparamshowhideList1);
            }
            if(jsonparamshowhideList2 != null){
                this.columnShowHideList2 = JSON.parse(jsonparamshowhideList2);
            }
            if(jsonparamshowhideList3 != null){
                this.columnShowHideList3 = JSON.parse(jsonparamshowhideList3);
            }
        },
        getTotalPrice(){
            let self = this
            var targetProjectId = this.request.projectId
            this.$http.postQuery('/api/totalPrice/'+targetProjectId,{},function(res){
                self.totalPrice = res.data
            })
        },
        //项目列表
        search(page){
            var targetProjectId = this.request.projectId
            var url = "/api/lampparams/pageJson/"+targetProjectId
            if(this.isgdorPending == 3){
                url = "/api/lampparams/auditPageJson/"+targetProjectId
            }else{
                this.request.auditStatus = ''
            }
            var status = ''
            if(this.dataStatusList.length > 0){
                for(var i = 0;i<this.dataStatusList.length;i++){
                    status += this.dataStatusList[i] + ','
                }
            }

            this.request.dataStatus = status.substring(0,status.length-1).replace('6','4')
            this.request.page = page
            let self = this
            this.$http.postObj(url,this.request,function(res){
                if(res.success){
                    self.tableData = res.data.rows
                    self.tabData = res.data.rows
                    self.sortData = [];
                    for(let i = 0;i<self.tableData.length;i++){
                        self.tableData[i].showEdit = false;
                        self.sortData.push({
                            id:self.tableData[i].lampparamId,
                            sorts:''
                        });
                    }
                    self.totalCount = res.data.total
                    //优化逻辑只在加载第一页是刷新预估总价
                    if(page ==1){
                        self.getTotalPrice()
                    }

                }
            })
        },
        //加载项目树
        loadProjectTree(){
            let self = this
            self.jduhh = self.$route.query.jduhh
            this.$http.get("/api/projects/treeJson/"+this.projectRootId,{},function(res){
                if(res.success){
                    var data = res.data
                    self.currentProject = data[0]
                    self.projectTree = self.filterArray(data,self.projectRootId)
                    for(var i = 0;i<self.projectTree.length;i++){
                        if(self.projectTree[i].children){
                            self.projectTree[i].disabled = true
                        }
                    }
                    // var temp = []
                    // temp.push(self.currentProject.id+'')
                    var tempId = self.request.projectId
                    if(self.isgdorPending!='3'){
                            var childProjectId  = self.$route.query.jduhhs
                            if(childProjectId){
                                tempId = childProjectId
                            }
                        }

                    //如果不为为根项目,则重新初始化树结构选择树节点初始化数据
                    if(tempId != self.projectRootId){
                        for(var i = 0;i<self.projectTree.length;i++){
                            if(tempId == self.projectTree[i].id){
                                self.jduhhs = self.projectTree[i]
                                self.SelectProjectTreeMenu(self.projectTree[i])
                            }
                            if(self.projectTree[i].children != null){
                                for(var j = 0;j<self.projectTree[i].children.length;j++){
                                    if(tempId == self.projectTree[i].children[j].id){
                                        self.jduhhs = self.projectTree[i].children[j]
                                        self.SelectProjectTreeMenu(self.projectTree[i].children[j])
                                    }
                                }
                            }
                            // temp.push(self.projectTree[i].id+'')
                        }
                    }else{
                        self.search(1)
                    }
                    
                    // self.defaultOpenTree = temp
                }
            })
        },
        filterArray(data,parent) {
                let vm = this;
                var tree = [];
                var temp;
                for (var i = 0; i < data.length; i++) {
                    data[i].label = data[i].itemName
                    if (data[i].parentId == parent) {
                        var obj = data[i];
                        temp = this.filterArray(data, data[i].id);
                        if (temp.length > 0) {
                            obj.children = temp;
                        }
                        tree.push(obj);
                    }
                }
                return tree;
        },
    },
    created(){
        //设置加载的项目id
        this.request.projectId = this.$route.query.id
        //设置项目根id
        this.projectRootId = this.$route.query.id
        //获取是否是归档项目 不可操作
        this.isgdorPending = this.$route.query.gd
        //如果为待审核项目时，默认查询初审中，终审中的的灯参
        // if(this.isgdorPending=='3'){
        //     this.dataStatusList = ['3','4'];
        //     var auditPageRequestData = sessionStorage.getItem("auditPageRequestData") ;
        //     if(auditPageRequestData){
        //         var obj = JSON.parse(sessionStorage.getItem("auditPageRequestData"));
        //         this.request =  obj;
        //         this.dataStatusList = obj.dataStatus.split(',')
        //     }
        // }

        //先不处理
        // if(this.isgdorPending=='0'){
        //     var projectId  = this.$route.query.jduhhs
        //     if(projectId>0){
        //         this.request.projectId = projectId
        //     }
        // }



        //初始化
        this.initData()

        let self = this;
        this.$http.postQuery("/api/organizations/json", {isOrgState:true}, function(res) {
            if (res.success) {
                var flag = false
                self.organizationsList = res.data;
                for(var i = 0;i<self.organizationsList.length;i++){
                    var item = self.organizationsList[i]
                    if(item.isStartRules == true){
                        flag = true
                    }
                }
                self.printneedZong = flag
                console.log("需要显示总则"+self.printneedZong)
            }
        });
    },
     mounted(){
          //页面被刷新时清除缓存
         if (window.performance.navigation.type == 1) {
             sessionStorage.setItem("auditPageRequestData","") ;
             sessionStorage.setItem("zhizuoPageRequestData","") ;
         }
        this.$nextTick(function () {
            
            this.tableHeight = window.innerHeight - 380;
            this.tableHeight8 = window.innerHeight - 280;
            let self = this;
            window.onresize = function() {
                self.tableHeight = window.innerHeight - 380
            }
            this.tableHeight1 = window.innerHeight - 380;
            let self1 = this;
            window.onresize = function() {
                self1.tableHeight = window.innerHeight - 380
            }
             this.tableHeight2 = window.innerHeight - 380;
             
            let self2 = this;
            window.onresize = function() {
                self2.tableHeight = window.innerHeight - 380
                self2.tableHeight8 = window.innerHeight - 280;
            }
              
             this.tableHeight3 = window.innerHeight - 380;
             this.tableHeight4 = window.innerHeight - 280;
             this.tableHeight5 = window.innerHeight - 484;
             this.tableHeight6 = window.innerHeight - 200;
             this.parameterTableH = window.innerHeight - 436;
            let self3 = this;
            window.onresize = function() {
                self3.tableHeight3 = window.innerHeight - 380
                self3.tableHeight4 = window.innerHeight - 280
                self3.tableHeight5 = window.innerHeight - 484
                self3.tableHeight6= window.innerHeight - 200
                self3.parameterTableH = window.innerHeight - 436;
            }
            this.rowDrop();
           
        })
        $('.icon_is').click(function(){
            $(this).parents('.icon_top').siblings('.icon_cont').slideToggle();
            $(this).parents('li').toggleClass('is-opened'); 
            $(this).parents('li').siblings('li').find('.icon_cont').slideUp();
            $(this).parents('li').siblings('li').removeClass('is-opened');
          
        });
       
        // $(window).scroll(function(){
        //         console.log()
        //     //   $('.el-popover').offsetTop;
        //      })
        // $(".icon_ise").click(function(){
        //     $(this).parents('.icon_top').addClass('pened');
        //      $(this).parents('li').siblings('li').find('.icon_top').removeClass('pened');
        // })
  },
   computed: {
               iRowStyle: function ({ row, rowIndex }) {
                   return {'height':'20px'};
               },
               iCellStyle: function ({ row, column, rowIndex, columnIndex }) {
                   return {'padding':'0px'}
               },
                // 获取select框中所选文本值
                inputValue: function () {
                    const self = this;
                    var value;
 
                    //遍历找到对应文本值
                    this.options.forEach(function (item, index) {
                        if (item.value === self.selectValue) {
                            value = item.text;
                        }
                    });
 
                    return value;
                }
            },
    filters:{
        ellipsisLength20(value) {
            if (value.length > 20) {
                return value.slice(0, 20) + '...'
            }
            return value
        }
    }
}
</script>
<style rel="stylesheet/scss" lang='scss' scoped>

.tables_div{
    display: inline-block;
    padding-top: 60px;
    .div_flex{
        position: sticky;
        top:0;
        margin-top: -60px; 
    }
    .box_flex:nth-of-type(2n-1){
        background-color:#f6f7fb;
    }
    .box_flex{
        // border-bottom:1px solid #ccc;
        display:flex;
        >div:last-of-type{
            border-right: 1px solid #ccc;
        }
        >div{
            font-weight:bold;
            height: 60px;
            line-height:60px;
            text-align: center;
        }
        .td_unit{
            width: 115px;
            border-left: 1px solid #ccc;
            border-bottom: 1px solid #ccc;
        }
        .td_weight{
            width:100px;
            border-left: 1px solid #ccc;
            border-bottom: 1px solid #ccc;
            >div{
                height: 30px;
                border-bottom: 1px solid #ccc;
            }
            >div:last-of-type{
                border-bottom: none;
            }
        }
        .td_view_t{
            width:270px;
            border-left: 1px solid #ccc;
            >div{
                justify-content:center;
                text-align: center;
                height: 30px;
                line-height: 30px;
                display: flex;
                .td_view{
                    flex:1;
                    border-top:1px solid #ccc;
                }
            }
        }
    }
    .border_right{
        border-right:1px solid #ccc;
    }
    .boder_top{
        border-top:1px solid #ccc;
    }
    .border_bottom{
        border-bottom:1px solid #ccc;
    }
    .box_flex.div_tr{
        >div{
            font-weight:normal;
        }
        .td_unit{
            height: 90px;
            line-height: 90px;
            border-bottom: 1px solid #ccc;
        }
        .td_weight{
            height: 90px;
            width: 100px;
            line-height: 30px;
            border-left: 1px solid #ccc;
            border-bottom: 1px solid #ccc;
            >div{
                border-bottom: 1px solid #ccc;
            }
            >div:last-of-type{
                border-bottom: none;
            }
        }
        .td_view{
            width: 90px;
            text-align: center;
            height:90px;
            line-height:30px;
            border-left: 1px solid #ccc;
            >div{
                height:30px;
                border-bottom: 1px solid #ccc;
                
                color: #238fcb;
                cursor: pointer;
            }
            // >div:last-of-type{
            //     border-bottom: none;
            // }
        }
    }
}
.scrollHideFlag{
  .td_unit{
    width: 90px!important;
  }
}
</style>
<style rel="stylesheet/scss" lang="scss" >
.applicationbounced .cont{
  min-height: 575px;
}
.recoSelect{
  margin-top:15px;
  .el-input{
    width: 100px;
  }
}
.lampTypeWidth{
  .el-input{
    width: 120px!important;
  }
}
.recoLabel{
  margin-bottom: 0;
  .el-form-item__label{
    font-size: 18px;
    padding-right: 7px;
    color: #fff!important;
  }
  .el-input__inner{
    color: #5a63a3;
    background-color: #DCDFE6;
  } 
  .el-icon-arrow-up:before{
    color:#5a63a3;
  }
} 
.letterInput{
  .el-input{
    width: 50px!important;
  }
}
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
}
.el-icon-arrow-down {
    font-size: 12px;
}
.ltNavConts{
    font-size: 14px;
    color: #303133;
    cursor: pointer;
    -webkit-transition: border-color .3s,background-color .3s,color .3s;
    transition: border-color .3s,background-color .3s,color .3s;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 50px;
    position: relative;
    -webkit-box-sizing: border-box;
    // white-space: nowrap;
    list-style: none;
    i{
        vertical-align: middle;
        margin-right: 5px;
        width: 24px;
        text-align: center;
        font-size: 18px;
    }
    .icon_is{
        float: left;
        i{
            position: relative;
            top: -2px;
        }
    }
    .icon_i {
        float: left;
        i{
            position: relative;
            top: -2px;
        }
    }
    .icon_top{
        font-size: 16px;
        font-weight: bold;
        vertical-align: middle;
        padding: 0 20px;
        height: 50px;
            color: #303133;
            background-color: #fff;
        .el-icon-caret-bottom{
            display: inline-block !important;
        }
        .el-icon-caret-right{
            display: none;
        }
        &.pened{
            
            color: #ffa128;
            background-color: #ecf5ff;
             .el-icon-caret-bottom{
                display: none !important;
            }
            .el-icon-caret-right{
                display: inline-block !important;
            }
        }
        &.active{
            color: #ffa128;
            background-color: #ecf5ff;
        }
        span:last-child{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            float: left;
            width: 150px;
        }
    }
    .icon_cont{
        // display: none;
        .icon_bottoms{
            display: none;
            &.active{
                display: block;
            }
        }
        .icon_tops{
            font-size: 14px;
            font-weight: bold;
             padding:0 20px 0 40px;
             height: 50px;
             span:last-child{
                width: calc(100% - 30px);
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                float: left;
            }
             &.selected{
                background-color: #ecf5ff;
                .name{
                    color: #ffa128;
                }
            }
        }
        .icon_bottoms{
            font-size: 14px;
            p{
                padding: 0 20px 0 60px;
                &.selected{
                    color: #ffa128;
                    background-color: #ecf5ff;
                }
            }

        }
        .active{
             .icon_tops{
                .icon_i{
                    .el-icon-caret-bottom{display: inline-block}
                    .el-icon-caret-right{display: none;}
                }
            }
        }
    }
    .is-opened{
        .icon_top{
            color: #5a63a3;
            .icon_is{
                .el-icon-caret-bottom{display: inline-block}
                .el-icon-caret-right{display: none;}
            }
        }
    }
}
.exportTable tr{
    width: 50%;
    float: left;
    td:first-child{
        text-align: right;
        background: #eff5ff;
    }
    td{
        height: 69px;
    }

}
.sdsdeee{
    li{
        padding: 0 4px;
    font-size: 13px;
    min-width: 35.5px;
    height: 28px;
    line-height: 28px;
    width: auto !important;
    border-bottom: none !important;
    &.active{
        background: #fff !important;
    }
    }
}
.addss{
    position: absolute;
    padding: 0 !important;
    float: right;
    border: none  !important;
    right: 0;
    bottom: 5px;
}
.width15_s .el-form-item__label{
    width: 100px !important;
}
.width15 {
    el-select{
        width: 120px;
    }
    .el-form-item__content{
        width: 120px;
    }
}
.xiala{width: 185px;}
.export{
    max-height: 80%;
    height: auto !important;
    width: 811px;
    input{
        width: 100%;
    }
}
.parameter_rt{
    float: right;
    height: 60px;
    line-height: 60px;
    span{
        color: #fff;
        font-size: 13px;
        display: inline-block;
        margin-right:20px; 
    }
}
#export{
    height: auto !important;
    .el-dialog__body{
        padding-top: 5px;
        .el-form-item{
            margin-top: 12px;
        }
        .el-form-item__content{
            margin-left:0 !important;
            text-align: center
        }
    }
    form{
max-height: 500px;
        overflow: auto;
    }
    table{
        width: 100%;
        
        td{
            padding: 10px;
            .el-date-editor.el-input{
                width: 100% !important;
            }
            &:first-child{
                background: #eff5ff;
            }
        }
    }

}
.dabiao{
    background: none;
    border:none;
    padding: 0;
    color: #fff;
    margin-right: 12px;
    font-size: 15px;
    cursor: pointer;
}
.dabiao img{
    display: inline-block;
    margin-right: 6px;
    position: relative;
    top: 3px;
    height: 17px;
}
.zhizuoren{
    .el-form-item__label{
        width: 68px;
    }
}
.applicationbouncedrt{
    overflow: auto;
    //height: 400px;
    height: var(tableHeightss);
}
.scd{
    width: 100% !important;
    padding: 0 !important;
    display: flex;
    display: -webkit-flex;
    height: auto !important;
    .el-dialog__headerbtn{
        top: 4px;
        right: 5px;
    }
    .scd_lt{
        width: 9%;
        background-color: #f6f7fb;
        border-right: solid 1px rgba(184, 205, 217, 0.4);
    }
    .scd_rt{
        width: 91%;
        padding: 10px;
        background-color:#fff;
        .el-form-item{
            margin-bottom: 0;
            width: auto;
            display: inline-block;
            .el-form-item__label{
               display: inline-block;
               float: none;
            }
            .el-form-item__content{
                display: inline-block;
            }
        }
        table{
            width: 100%;
            th{
                text-align: center;
                padding: 5px;
                background-color: #f6f7fb;
            }
            td{
                text-align: center;
                padding: 5px;
            }
            tr:first-child{
                td{
                    background-color: #f6f7fb;
                }
            }
        }
    }
}

.classCources{
    width: 80% !important;
    // max-height: 80vh;
    .el-dialog__header{
        background-color: #5a63a3;
        padding: 15px;
        .el-dialog__title{
            color: #fff;
        }
    }
    .el-dialog__body {
        padding: 10px 10px;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }
}
.showMorelist{
    padding: 0;
    .el-dialog__header{
       position: absolute;
        z-index: 99;
        width: 100%;
       .el-dialog__headerbtn{
           background-color:#fff;
           i{
               color: #5a63a3 !important;
           } 
       }
    }
    .el-dialog__body{
        padding: 0
    }
    .el-button--mini {
        position: absolute;
        right: 30px;
        color: #000;
        font-size: 18px;
        top: 7px;
        i{
            font-size: #fff;
        }
    }
    .tp {
        background-color: #5a63a3;
        color: #fff;
        padding: 15px 25px;
    }
    .contcheck{
        width: 770px;
            padding: 5%;
        .el-form-item__content .li_list {
            width: 25%;
            float: left;
            margin-right: 0;
        }
     } 
}
.list_Se 
.list_Se_btn{
    height: auto;
    border:none;
    padding: 0;
}
.parameter{
    padding-top: 88px;
    background-color: #f4f4fc;
    overflow: hidden;
    .parameter_dh{
        background-color: #5a63a3;
        .el-button{
            width: 60px;
	        height: 60px;
	        background-color: #3b437c;
            text-align: center;
            border: none;
            color: #fff;
            i{
                display: inline-block;
                border-radius: 50%;
                width: 22px;
                height: 22px;
                line-height: 22px;
                border: 1px solid #fff;
            }
        }
        .right{
            float: right;
            padding-right: 5px;
            line-height: 60px;
            span{
                display: inline-block;
                color: #fff;
                font-size: 17px;
                margin-right: 30px;
                height: 60px;
                line-height: 60px;
                img{
                    display: inline-block;
                    margin-right: 5px;
                    position: relative;
                    top: 2px;
                }
            }
        }
        .title{
            font-size: 16px;
            color: #fff;
            margin-left: 25px;
            &.title2{
                margin-left: 2px;
            }
        }
    }
    .rtNav{
        float: right;
        margin-top: 33px;
        margin-bottom: 40px;
        background: #fff;
        position: relative;
        // height: 760px;
        box-shadow: 0px 1px 10px 0px 	#f6f6f6;
        .kongzhi{
            position: absolute;
            top: 30%;
            left: -24px;
            width: 24px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            background-color: #ffffff;
            box-shadow: 0px 1px 10px 0px #f6f6f6;
            border-radius: 0px 4px 4px 0px;
            border: solid 1px #eeeeee;
            border-right: none;
            cursor: pointer;
            i{
                color: #666;
                &:first-child{
                    display: none;
                }
            }
            &.active{
                i:first-child{
                    display: inline-block;
                }
                i:last-child{
                    display: none;
                }
            }
        }
        li{
            width: 220px;
            text-align: center;
            border-bottom: solid 1px rgba(184, 205, 217, 0.4);
            &.active{
                background: #5a63a3;
                .btn img:nth-child(2){
                    display: inline-block;
                }
                .btn img:nth-child(1){
                    display: none;
                }
                 .btn p{
                     color: #fff;
                 }
            }
            .btn{
                padding: 35px 0;
                img:nth-child(2){
                    display: none;
                }
                p{
                    color: #5a63a3;
                    font-size: 20px;
                    margin-top: 10px;
                }
            }
           
        }
        ul{
            width: 220px;
            height: auto;
            transition: all 0.3s;
            -moz-transition: all 0.3s;
            -webkit-transition: all 0.3s;
            -o-transition: all 0.3s;
            &.active{
                width: 0;
            }
        }
    }
    .centerCont{
        position: relative;
        height: calc(100vh - 180px);
        height: -webkit-calc(100vh - 180px);
        width: calc(100% - 290px);
        width: -webkit-calc(100% - 290px);
        float: left;
        background: #fff;
        box-shadow: 0px 1px 10px 0px 	#f6f6f6;
        margin-top: 33px;
        margin-left: 35px;
        transition: all 0.3s;
        -moz-transition: all 0.3s;
        -webkit-transition: all 0.3s;
        -o-transition: all 0.3s;
        margin-bottom: 40px;
        &.active{
        width: calc(100% - 100px);
        width: -webkit-calc(100% - 100px);
        }
        .power .el-input{
            width: 80px;
        }
        .demo-form-inline{
            border-bottom: solid 1px #dedede;
            padding: 40px 30px;
        }
        .witd{
            .el-input__inner{
                width:170px;
            }
        }
        .goglv{
            .el-form-item__content{
                .el-input{
                    width: 80px;
                }
            }
        }
        .el-button--primary{
            background-color: #5962a3;
	        border-radius: 3px;
            border: none;
        }
        .centerCont_list{
            text-align: right;
            padding: 15px 40px 5px;
            li{
                display: inline-block;
                color: #999999;
                font-size: 16px;
                margin-left: 28px;
                cursor: pointer;
                img{
                    display: inline-block;
                    margin-right: 4px;
                    position: relative;
                    top: 2px;
                }
                i{
                    color: #5a63a3;
                    margin-right: 4px;
                }
            }
        }
        .parameterTable{
            th{
                background-color: #f6f7fb;
                color: #555555;
                text-align: center
            }
            td{
                text-align: center;
                color: #555555;
              
                div {
  min-height: 30px;
                }
                .bianhao{
                    color: #238fcb;
                    cursor: pointer;
                    position: relative;
                }
                .size{
                    color: #333333;
                    padding: 0 10px;
                    text-align: left
                }
                .btns{
                    .btn1{color: #3dc26f}
                    .btn2{width: 83px;height: 38px;line-height:38px;background-color: #ffaf49;color:#fff;border-radius: 4px;}
                    .btn3{width: 83px;height: 38px;line-height:38px;background-color: #fb6666;color:#fff;border-radius: 4px;}
                    .btn4{
                        color: #ffa128;
                        p{
                            color: #9f9f9f;
                            font-size: 12px;
                        }
                    }
                    .btn5{
                        color: #fb6666;
                        p{
                            color: #9f9f9f;
                            font-size: 12px;
                        }
                    }
                }
                .btns_S{
                    cursor: pointer;
                    .btn1{
                        font-size: 30px;
                    }
                    .cont{
                        display: none;
                        .btn2{
                            width: 30px;
                            height: 30px;
                            line-height: 30px;
                            background-color: #ffffff;
                            border-radius: 4px;
                            display: inline-block;
                            color:#000;
                            margin-left: 2px;
                            &:first-child{
                                margin-left: 0;
                            }
                        }
                    }
                }
            }
            .el-table__row{
                &:hover{
                    & td:last-child  {
                        background-color: #5a63a3;
                    }
                    .btns_S{
                        .btn1{
                            display: none;
                        }
                        .cont{
                            display: block;
                        }
                    }
                }
                .btn2:hover{
                    background-color: #fec028 !important;
                    color: #fff !important;
                }
            }
        }
    }
    .ltNav{
        overflow: auto;
         float: left;
        margin-bottom: 40px;
        background: #fff;
        position: relative;
        box-shadow: 0px 1px 10px 0px 	#f6f6f6;
        height: calc(100vh - 148px);
        height: -webkit-calc(100vh - 148px);
        .ltNav_cont{
            overflow: hidden;
            .el-menu-item.is-active {
                background-color: #ecf5ff !important;
            }
        }
        .el-menu-vertical-demo{
            height: 100%;
            width: 220px;
            transition: all 0.3s;
            -moz-transition: all 0.3s;
            -webkit-transition: all 0.3s;
            -o-transition: all 0.3s;
            overflow: hidden;
            li{
                width: 100%;
                overflow: hidden;
            }
            .icon_top{
                width: 220px;
                transition: all 0.3s;
                -moz-transition: all 0.3s;
                -webkit-transition: all 0.3s;
                -o-transition: all 0.3s;
            }
            &.active{
                width: 0;
                .icon_top{
                    width: 0;
                }
            }
        }
        .el-menu{
            border-right: none;
        }
        .kongzhi{
            position: absolute;
            top: 30%;
            right: -22px;
            width: 24px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            background-color: #ffffff;
            box-shadow: 0px 1px 10px 0px #f6f6f6;
            border-radius: 0px 4px 4px 0px;
            border-right: none;
            cursor: pointer;
            i{
                color: #666;
                &:first-child{
                    display: none;
                }
            }
            &.active{
                i:first-child{
                    display: inline-block;
                }
                i:last-child{
                    display: none;
                }
            }
        }
        .el-submenu__icon-arrow{
            display: none;
        }
        .el-icon-caret-bottom{
            display: none;
        }
        .el-submenu{
             .el-submenu__title{
                 span{font-size: 16px;font-weight: bold}
             }
             .el-submenu{
                .el-submenu__title{
                    span{font-size: 14px;}
                }
             }
            i{
                color: #5a63a3
            }
        }
        .el-submenu.is-opened{
            .el-submenu__title{
                .el-icon-caret-right{display: none;}
                .el-icon-caret-bottom{display: inline-block}
                span{color: #5a63a3;}
                i{color: #5a63a3;}
            }
            .el-submenu{
                .el-icon-caret-right{display: inline-block;}
                .el-icon-caret-bottom{display: none}
                span{color: #666;}
                i{color: #5a63a3;}
                &.is-opened{
                    .el-icon-caret-right{display: none;}
                     .el-icon-caret-bottom{display: inline-block}
                     span{color: #ffa128;}
                     .el-menu-item.is-active{
                        color: #ffa128;
                     }
                }
            }
        }
    }
}

.applicationbounced{
    width: 80%;
    height: auto;
    max-height: 80vh;
    .cont{
        overflow: hidden;
    }
    .lt{
        width: 30%;
        float: left;
    }
    .rt{
        width: 70%;
        float: left;
       
        .te{
            background-color: #5a63a3;
            text-align: center;
            font-size: 18px;
            color: #fff;
            height: 65px;
            line-height: 65px;
            font-weight: bold;
            border-left: 1px solid #fff;
        }
    }
    .tables_td{
        vertical-align: top;
        .import{
            margin-bottom: 5px;
            text-align: right;
            padding:10px 25px;
            span{
                color: #fff;
                font-size: 14px;
                cursor: pointer;
                background-color: #5a63a3;
                border-radius: 3px;
                padding: 9px 20px;
                img{
                    display: inline-block;
                    margin-right: 5px;
                    position: relative;
                    top: 2px;
                }
            }
        }
    }
    .el-dialog__header{
        padding: 20px 20px 0px;
        .el-dialog__title{
            font-weight: bold;
        }
        .el-dialog__headerbtn{
            background-color: #5a63a3;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            i{
                color: #fff;
            }
        }
    }
    .el-dialog__body{
        .title{
            color: #333333;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 15px;
        }
        th{
            background-color: #5a63a3;
            text-align: center;
            font-size: 18px;
            color: #fff;
             height: 46px;
        }
        td:first-child{
            background-color: #f6f7fb;
        }
        .tables{
           
            th{
                 font-size: 14px;
                color: #555555;
                background-color: #f6f7fb;
                padding: 0 12px;
            }
            td:first-child{
                background-color: rgba(0, 0, 0, 0);
            }
            tr:nth-child(odd){
                background-color: #f6f7fb;
            }
            td{
                padding: 10px;
            }
            .check{
                height: 30px;
                text-align: left;
                border-bottom: 1px solid #ccc;
                label{
                    display: inline-block;
                        margin-right: 10px;
                }
            }
            .check:last-of-type{
                border: none;
            }
        }
    }
}
 .el-dialog__wrapper .upload.el-dialog{
        height: auto;
    }
.upload{
    padding: 0 10%;
    text-align: left;
   
    .title{
        font-size: 22px;
        font-weight: bold;
        color: #333;
        margin-bottom: 16px;
        text-align: center;
    }
    .tihsi{
        color: #fd0000;
        font-size: 12px;
        margin: 6px 0 18px;
    }
    .el-upload{
        width: 100%;
    }
    .el-upload-dragger{
        width: 100%;
    }
    .el-form-item__content{
        text-align: center;
        .el-button--primary{
            background-color: #5a63a3;
            border-radius: 3px;
            border: solid 1px #dde9ef;
            color: #fff;
            border: none;
            margin-top: 20px;
        }
    }
    .el-upload-list,.el-upload-list li{
        width: 100% !important;
        text-align: left;
    }
}
.library{
    .el-dialog__body{
        padding-top: 5px;
    }
    .el-dialog__title{
        font-weight: bold;
    }
    .el-form--inline .el-form-item__label{
        width: 70px;
    }
    .power{
        .el-form-item__label{
            width: 30px;
        }
        .el-input{
            width: 80px;
        }
    }
    .power1{
        .el-form-item__label{
            width: 40px;
        }
    }
    .power2 {
        .el-form-item__label{
            width: 70px;
        }
        .el-input{
            margin-right: 5px;
            &:last-child{
                margin-right:0
            }
        }
     }
    .el-form{
        overflow: hidden;
        position: relative;
        .el-form-item{
            float: left;
        }
    }
    .el-table__header-wrapper .el-table__header{
        border-bottom: none;
    }
    .el-table{
        border-right:1px solid rgba(184, 205, 217, 0.4);
    }
    .add{
        text-align: right;
        padding: 20px;
        border-left: solid 1px rgba(184, 205, 217, 0.4);
        border-right: solid 1px rgba(184, 205, 217, 0.4);
        border-bottom: solid 1px rgba(184, 205, 217, 0.4);
        border-top: none;
        span{
            display: inline-block;
            color: #999999;
            cursor: pointer;
            img{
                display: inline-block;
                height: 15px;
                position: relative;
                top: 2px;
                margin-right: 4px;
            }
        }
    }
}

.el-button--primary{
    background-color: #5a63a3;
    border-radius: 3px;
    border: none;
}
.el-dialog__headerbtn {
    background-color: #5a63a3;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 22px;
    i{
        color: #fff !important;
    }
}
@media (max-width: 1500px){
    #typeshowhtml .contrascont{
        padding: 20px 40px 10px;
    }
}
@media (max-width: 1400px){
    #typeshowhtml .contrascont{
        padding: 20px 30px 10px;
         .hst{
                font-size: 18px;
            }
        .lsde{
            li{
                font-size: 12px;
                padding: 3px;
            }
            .title{
                height: 36px;
                line-height: 36px;
                font-size: 16px;
            }
            .cd1,.cd2,.cd6{
                height: 160px;
            }
            .cd3,.cd4{
                height: 40px;
            }
            .cd5{
                line-height: 1em;
                height: 40px;
            }
            .cd7,.cd9,.cd8{
                height: 36px;
            }
        }
    }
}
.tableDiff.el-dialog__wrapper {
    .chayibi{
        top: 50% !important;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
    }
    .el-dialog{
        height: auto;
        .el-dialog__body{
            padding-top: 5px;
        }
        .el-dialog__header{
            text-align: center;
            .el-dialog__title{
                font-weight: bold;
            }
        }
        thead{
            th{
                background-color: #f6f7fb;
                color: #555555;
                text-align: center;
            }
        }
        tbody{
            td{
                text-align: center;
                color: #555555;
            }
        }
    }
}
.tableAddproducts{
    .el-dialog{
        width: 560px;
        .el-select{
            width: 100%;
        }
    }
}
.dataContrast{
    .el-dialog{
        width: 90%;
        .el-dialog__body{
            overflow: hidden;
        }
        .lt{
            width: 300px;
            float: left;
        }
        .rt{
            width: calc(100% - 300px);
            width: -webkit-calc(100% - 300px);
            float: left;
            padding-left: 30px;
        }
    }
    
}

.setyou{
        padding: 20px 30px 0px !important;
        .witd{
            .el-form-item__content{
                .el-input__inner{
                width: 120px;
                }
            }
        }
    .power{
        .el-input{
            width: 86px !important;
            .el-input__inner{
                padding: 0 8px;
            }
        }
    }
}
// #myprojectTree .el-tree-node{
//     .el-checkbox{
//         display:none
//     }
// }
// #myprojectTree .el-tree-node{
//     .el-tree-node__children .el-checkbox{
//         display:inline-block;
//     }
// }

.el-tree-node__content>.el-checkbox{
    span{
        height: 16px; 
    }
}

.xiangqing{
    .el-dialog__body{
        overflow: auto;
    }
}
.el-form--inline .powerList  .el-form-item__label{
width: 90px;
} 
.chayibi{
    margin-top: 50px !important;
}
.parameterTable .el-table--border .el-table__header-wrapper {
    //  overflow: scroll;
    th{
        white-space: nowrap; 
        overflow: hidden;
        -webkit-user-select: all;
        -moz-user-select: all;
        -ms-user-select: all;
        user-select: all;
    }
}
.parameterTable .el-table th{
 -webkit-user-select: all;
        -moz-user-select: all;
        -ms-user-select: all;
        user-select: all;
}
.sdTable{
    border-collapse:collapse;
    width: 100%;
    td{
        padding:0 5px;
    }
    .el-form-item{
        margin-bottom: 0 !important;
    }
}
.widTable{
    display: flex;
    display: -webkit-flex;
    width: 100%;
    padding: 0 !important;

}
.widTable .ltt{
    background-color: #f6f7fb;
    width: 9%;
    border: solid 1px rgba(184, 205, 217, 0.4);
}
.widTable .rtt{
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-pack: center;
    -webkit-flex-flow: column wrap;
    -ms-flex-flow: column wrap;
    flex-flow: column wrap;
    padding: 0 15px;
}
.widTabless{
    width: 100%;
    padding: 0 !important;
    height: auto;
    ul{
        height: auto;
        display: flex;
    display: -webkit-flex;
        max-height: 100% !important;
        li{
            height: auto !important;
        }
    }
}
.el-pagination{
    text-align: center
}
.addsse{
        position: initial;
            float: none;
    margin: 10px 0;
    color: #fff;
    .el-button{
        span{
            color: #fff
        }
    }
}
.parameter_rt_btn{
        background-color:initial !important;
        width: auto !important;
        padding: 0 !important;
        span{
                margin-right: 5px !important;
        }
        i{
            border: none !important
        }
}
#typeshowhtml .el-dialog.show_list{
    width: 780px
}
#typeshowhtml .el-dialog.show_list .title{
      font-size: 16px;
      color: #000;
      font-weight: bold;
      line-height: 1;
      margin-top: 15px;
    }
    #typeshowhtml .el-dialog.show_list  .conts{
      display: inline-block;
      width: 100%;
    }
.tableAddproducts.tableDiff{
    max-height: 80%;
    overflow:auto;
    .el-dialog{
           max-height: 73%;
    overflow: auto;
    }
}
.xiala.dianya{
    max-height: 200px;
    overflow: auto
}
.donlv{
    .el-input__suffix{
        line-height: 40px;
    }
}
.glv{
    width: 86px !important;
    min-width: 86px !important;
}
#export .exportTable{
    .el-input__suffix{
        line-height: 40px;
        top: 0
    }
}
#container{
    position: relative;
    .select-box{
        -webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        width: 100%;
        position: relative;
        z-index: 9;
    }
    .el-input{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
    }
}
.tectCent{
    text-align: center
}
.guidangtable{
    table{
        width: 100% !important;
    }
    .el-form{
        .el-form-item{
            .el-input{
                .el-input__inner{
                    height: 26px;
                    line-height: 26px;
                    border-radius: 0;
                }
            }
        }
    }
}
.guidangtable1{
    .dialog-footer{
        margin-top: 50px;
        text-align: center;
            display: block;
    }
    .el-button{
        padding: 6px 16px;
    }
    .el-form{
        .el-form-item{
            .el-input{
                .el-input__inner{
                    height: 26px;
                    line-height: 26px;
                    border-radius: 0;
                }
            }
        }
    }
}
.markIcon{
    position: absolute;
    width: 0;
    height: 0;
    top: -10px;
    right: -10px;
    border: 10px solid transparent;
    border-bottom: 10px solid green;
    transform: rotate(44deg);
}
    .tanhao{
        color: red;font-size: 24px;margin-left: 2px;
    }
.lianghuazhibiaoTip{
    .el-tooltip__popper{
        max-width: 150px!important;
    }
}
</style>
